import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  bpchar: any;
  date: any;
  jsonb: any;
  numeric: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type Add_Panel_Input = {
  name: Scalars['String'];
};

export type Add_Panel_Output = {
  __typename?: 'add_panel_output';
  id: Scalars['String'];
  message: Scalars['String'];
};

export type Add_Ticker_Input = {
  panel_id: Scalars['uuid'];
  ticker: Scalars['String'];
};

export type Add_Ticker_Output = {
  __typename?: 'add_ticker_output';
  downgrade_plan_key: Scalars['String'];
  downgrade_plan_title: Scalars['String'];
  message: Scalars['String'];
  payment_confirmation_message: Scalars['String'];
  payment_success_message: Scalars['String'];
  tickers_left: Scalars['Int'];
  total_tickers: Scalars['Int'];
  upgrade_message: Scalars['String'];
  upgrade_plan_key: Scalars['String'];
  upgrade_plan_title: Scalars['String'];
};

/** Boolean expression to compare columns of type "bpchar". All fields are combined with logical 'AND'. */
export type Bpchar_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bpchar']>;
  _gt?: InputMaybe<Scalars['bpchar']>;
  _gte?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['bpchar']>;
  _in?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['bpchar']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['bpchar']>;
  _lt?: InputMaybe<Scalars['bpchar']>;
  _lte?: InputMaybe<Scalars['bpchar']>;
  _neq?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['bpchar']>;
  _nin?: InputMaybe<Array<Scalars['bpchar']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['bpchar']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['bpchar']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['bpchar']>;
};

/** columns and relationships of "cacv" */
export type Cacv = {
  __typename?: 'cacv';
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamptz'];
  id: Scalars['uuid'];
  order: Scalars['Int'];
  /** An object relationship */
  panel?: Maybe<Panel>;
  panel_id: Scalars['uuid'];
  ticker: Scalars['String'];
};

/** aggregated selection of "cacv" */
export type Cacv_Aggregate = {
  __typename?: 'cacv_aggregate';
  aggregate?: Maybe<Cacv_Aggregate_Fields>;
  nodes: Array<Cacv>;
};

/** aggregate fields of "cacv" */
export type Cacv_Aggregate_Fields = {
  __typename?: 'cacv_aggregate_fields';
  avg?: Maybe<Cacv_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Cacv_Max_Fields>;
  min?: Maybe<Cacv_Min_Fields>;
  stddev?: Maybe<Cacv_Stddev_Fields>;
  stddev_pop?: Maybe<Cacv_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Cacv_Stddev_Samp_Fields>;
  sum?: Maybe<Cacv_Sum_Fields>;
  var_pop?: Maybe<Cacv_Var_Pop_Fields>;
  var_samp?: Maybe<Cacv_Var_Samp_Fields>;
  variance?: Maybe<Cacv_Variance_Fields>;
};


/** aggregate fields of "cacv" */
export type Cacv_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cacv_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Cacv_Avg_Fields = {
  __typename?: 'cacv_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "cacv". All fields are combined with a logical 'AND'. */
export type Cacv_Bool_Exp = {
  _and?: InputMaybe<Array<Cacv_Bool_Exp>>;
  _not?: InputMaybe<Cacv_Bool_Exp>;
  _or?: InputMaybe<Array<Cacv_Bool_Exp>>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  panel?: InputMaybe<Panel_Bool_Exp>;
  panel_id?: InputMaybe<Uuid_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cacv" */
export enum Cacv_Constraint {
  /** unique or primary key constraint on columns "id" */
  CacvPkey = 'cacv_pkey'
}

/** input type for incrementing numeric columns in table "cacv" */
export type Cacv_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "cacv" */
export type Cacv_Insert_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  panel?: InputMaybe<Panel_Obj_Rel_Insert_Input>;
  panel_id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cacv_Max_Fields = {
  __typename?: 'cacv_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  panel_id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cacv_Min_Fields = {
  __typename?: 'cacv_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  panel_id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cacv" */
export type Cacv_Mutation_Response = {
  __typename?: 'cacv_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cacv>;
};

/** on_conflict condition type for table "cacv" */
export type Cacv_On_Conflict = {
  constraint: Cacv_Constraint;
  update_columns?: Array<Cacv_Update_Column>;
  where?: InputMaybe<Cacv_Bool_Exp>;
};

/** Ordering options when selecting data from "cacv". */
export type Cacv_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel?: InputMaybe<Panel_Order_By>;
  panel_id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cacv */
export type Cacv_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cacv" */
export enum Cacv_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PanelId = 'panel_id',
  /** column name */
  Ticker = 'ticker'
}

/** input type for updating data in table "cacv" */
export type Cacv_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Cacv_Stddev_Fields = {
  __typename?: 'cacv_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Cacv_Stddev_Pop_Fields = {
  __typename?: 'cacv_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Cacv_Stddev_Samp_Fields = {
  __typename?: 'cacv_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "cacv" */
export type Cacv_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cacv_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cacv_Stream_Cursor_Value_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Cacv_Sum_Fields = {
  __typename?: 'cacv_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** update columns of table "cacv" */
export enum Cacv_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PanelId = 'panel_id',
  /** column name */
  Ticker = 'ticker'
}

export type Cacv_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Cacv_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cacv_Set_Input>;
  where: Cacv_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Cacv_Var_Pop_Fields = {
  __typename?: 'cacv_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Cacv_Var_Samp_Fields = {
  __typename?: 'cacv_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Cacv_Variance_Fields = {
  __typename?: 'cacv_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "chat" */
export type Chat = {
  __typename?: 'chat';
  content: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid'];
  username?: Maybe<Scalars['String']>;
};

/** aggregated selection of "chat" */
export type Chat_Aggregate = {
  __typename?: 'chat_aggregate';
  aggregate?: Maybe<Chat_Aggregate_Fields>;
  nodes: Array<Chat>;
};

/** aggregate fields of "chat" */
export type Chat_Aggregate_Fields = {
  __typename?: 'chat_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Chat_Max_Fields>;
  min?: Maybe<Chat_Min_Fields>;
};


/** aggregate fields of "chat" */
export type Chat_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Chat_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "chat". All fields are combined with a logical 'AND'. */
export type Chat_Bool_Exp = {
  _and?: InputMaybe<Array<Chat_Bool_Exp>>;
  _not?: InputMaybe<Chat_Bool_Exp>;
  _or?: InputMaybe<Array<Chat_Bool_Exp>>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "chat" */
export enum Chat_Constraint {
  /** unique or primary key constraint on columns "id" */
  ChatPkey = 'chat_pkey'
}

/** input type for inserting data into table "chat" */
export type Chat_Insert_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Chat_Max_Fields = {
  __typename?: 'chat_max_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Chat_Min_Fields = {
  __typename?: 'chat_min_fields';
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  user_id?: Maybe<Scalars['uuid']>;
  username?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "chat" */
export type Chat_Mutation_Response = {
  __typename?: 'chat_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Chat>;
};

/** on_conflict condition type for table "chat" */
export type Chat_On_Conflict = {
  constraint: Chat_Constraint;
  update_columns?: Array<Chat_Update_Column>;
  where?: InputMaybe<Chat_Bool_Exp>;
};

/** Ordering options when selecting data from "chat". */
export type Chat_Order_By = {
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** primary key columns input for table: chat */
export type Chat_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "chat" */
export enum Chat_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "chat" */
export type Chat_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "chat" */
export type Chat_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Chat_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Chat_Stream_Cursor_Value_Input = {
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  user_id?: InputMaybe<Scalars['uuid']>;
  username?: InputMaybe<Scalars['String']>;
};

/** update columns of table "chat" */
export enum Chat_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Username = 'username'
}

export type Chat_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Chat_Set_Input>;
  where: Chat_Bool_Exp;
};

/** columns and relationships of "column" */
export type Column = {
  __typename?: 'column';
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamptz'];
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  key?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  order: Scalars['numeric'];
  section_id: Scalars['uuid'];
};

/** aggregated selection of "column" */
export type Column_Aggregate = {
  __typename?: 'column_aggregate';
  aggregate?: Maybe<Column_Aggregate_Fields>;
  nodes: Array<Column>;
};

/** aggregate fields of "column" */
export type Column_Aggregate_Fields = {
  __typename?: 'column_aggregate_fields';
  avg?: Maybe<Column_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Column_Max_Fields>;
  min?: Maybe<Column_Min_Fields>;
  stddev?: Maybe<Column_Stddev_Fields>;
  stddev_pop?: Maybe<Column_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Column_Stddev_Samp_Fields>;
  sum?: Maybe<Column_Sum_Fields>;
  var_pop?: Maybe<Column_Var_Pop_Fields>;
  var_samp?: Maybe<Column_Var_Samp_Fields>;
  variance?: Maybe<Column_Variance_Fields>;
};


/** aggregate fields of "column" */
export type Column_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Column_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "column" */
export type Column_Aggregate_Order_By = {
  avg?: InputMaybe<Column_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Column_Max_Order_By>;
  min?: InputMaybe<Column_Min_Order_By>;
  stddev?: InputMaybe<Column_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Column_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Column_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Column_Sum_Order_By>;
  var_pop?: InputMaybe<Column_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Column_Var_Samp_Order_By>;
  variance?: InputMaybe<Column_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "column" */
export type Column_Arr_Rel_Insert_Input = {
  data: Array<Column_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Column_On_Conflict>;
};

/** aggregate avg on columns */
export type Column_Avg_Fields = {
  __typename?: 'column_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "column" */
export type Column_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "column". All fields are combined with a logical 'AND'. */
export type Column_Bool_Exp = {
  _and?: InputMaybe<Array<Column_Bool_Exp>>;
  _not?: InputMaybe<Column_Bool_Exp>;
  _or?: InputMaybe<Array<Column_Bool_Exp>>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Numeric_Comparison_Exp>;
  section_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "column" */
export enum Column_Constraint {
  /** unique or primary key constraint on columns "id" */
  ColumnPkey = 'column_pkey'
}

/** input type for incrementing numeric columns in table "column" */
export type Column_Inc_Input = {
  order?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "column" */
export type Column_Insert_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['numeric']>;
  section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Column_Max_Fields = {
  __typename?: 'column_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['numeric']>;
  section_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "column" */
export type Column_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Column_Min_Fields = {
  __typename?: 'column_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['numeric']>;
  section_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "column" */
export type Column_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "column" */
export type Column_Mutation_Response = {
  __typename?: 'column_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Column>;
};

/** on_conflict condition type for table "column" */
export type Column_On_Conflict = {
  constraint: Column_Constraint;
  update_columns?: Array<Column_Update_Column>;
  where?: InputMaybe<Column_Bool_Exp>;
};

/** Ordering options when selecting data from "column". */
export type Column_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  section_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: column */
export type Column_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "column" */
export enum Column_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SectionId = 'section_id'
}

/** input type for updating data in table "column" */
export type Column_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['numeric']>;
  section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Column_Stddev_Fields = {
  __typename?: 'column_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "column" */
export type Column_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Column_Stddev_Pop_Fields = {
  __typename?: 'column_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "column" */
export type Column_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Column_Stddev_Samp_Fields = {
  __typename?: 'column_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "column" */
export type Column_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "column" */
export type Column_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Column_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Column_Stream_Cursor_Value_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  key?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['numeric']>;
  section_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Column_Sum_Fields = {
  __typename?: 'column_sum_fields';
  order?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "column" */
export type Column_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "column" */
export enum Column_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SectionId = 'section_id'
}

export type Column_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Column_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Column_Set_Input>;
  where: Column_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Column_Var_Pop_Fields = {
  __typename?: 'column_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "column" */
export type Column_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Column_Var_Samp_Fields = {
  __typename?: 'column_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "column" */
export type Column_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Column_Variance_Fields = {
  __typename?: 'column_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "column" */
export type Column_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "correlations" */
export type Correlations = {
  __typename?: 'correlations';
  bitcoin?: Maybe<Scalars['numeric']>;
  bitcoin_15?: Maybe<Scalars['numeric']>;
  bitcoin_30?: Maybe<Scalars['numeric']>;
  bitcoin_60?: Maybe<Scalars['numeric']>;
  bitcoin_90?: Maybe<Scalars['numeric']>;
  bitcoin_120?: Maybe<Scalars['numeric']>;
  bitcoin_180?: Maybe<Scalars['numeric']>;
  bitcoin_max?: Maybe<Scalars['numeric']>;
  bitcoin_maxchg?: Maybe<Scalars['numeric']>;
  bitcoin_min?: Maybe<Scalars['numeric']>;
  bitcoin_minchg?: Maybe<Scalars['numeric']>;
  commodity?: Maybe<Scalars['numeric']>;
  commodity_15?: Maybe<Scalars['numeric']>;
  commodity_30?: Maybe<Scalars['numeric']>;
  commodity_60?: Maybe<Scalars['numeric']>;
  commodity_90?: Maybe<Scalars['numeric']>;
  commodity_120?: Maybe<Scalars['numeric']>;
  commodity_180?: Maybe<Scalars['numeric']>;
  commodity_max?: Maybe<Scalars['numeric']>;
  commodity_maxchg?: Maybe<Scalars['numeric']>;
  commodity_min?: Maybe<Scalars['numeric']>;
  commodity_minchg?: Maybe<Scalars['numeric']>;
  date: Scalars['date'];
  gold?: Maybe<Scalars['numeric']>;
  gold_15?: Maybe<Scalars['numeric']>;
  gold_30?: Maybe<Scalars['numeric']>;
  gold_60?: Maybe<Scalars['numeric']>;
  gold_90?: Maybe<Scalars['numeric']>;
  gold_120?: Maybe<Scalars['numeric']>;
  gold_180?: Maybe<Scalars['numeric']>;
  gold_max?: Maybe<Scalars['numeric']>;
  gold_maxchg?: Maybe<Scalars['numeric']>;
  gold_min?: Maybe<Scalars['numeric']>;
  gold_minchg?: Maybe<Scalars['numeric']>;
  oil?: Maybe<Scalars['numeric']>;
  oil_15?: Maybe<Scalars['numeric']>;
  oil_30?: Maybe<Scalars['numeric']>;
  oil_60?: Maybe<Scalars['numeric']>;
  oil_90?: Maybe<Scalars['numeric']>;
  oil_120?: Maybe<Scalars['numeric']>;
  oil_180?: Maybe<Scalars['numeric']>;
  oil_max?: Maybe<Scalars['numeric']>;
  oil_maxchg?: Maybe<Scalars['numeric']>;
  oil_min?: Maybe<Scalars['numeric']>;
  oil_minchg?: Maybe<Scalars['numeric']>;
  sp?: Maybe<Scalars['numeric']>;
  sp_15?: Maybe<Scalars['numeric']>;
  sp_30?: Maybe<Scalars['numeric']>;
  sp_60?: Maybe<Scalars['numeric']>;
  sp_90?: Maybe<Scalars['numeric']>;
  sp_120?: Maybe<Scalars['numeric']>;
  sp_180?: Maybe<Scalars['numeric']>;
  sp_max?: Maybe<Scalars['numeric']>;
  sp_maxchg?: Maybe<Scalars['numeric']>;
  sp_min?: Maybe<Scalars['numeric']>;
  sp_minchg?: Maybe<Scalars['numeric']>;
  usd?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "correlations" */
export type Correlations_Aggregate = {
  __typename?: 'correlations_aggregate';
  aggregate?: Maybe<Correlations_Aggregate_Fields>;
  nodes: Array<Correlations>;
};

/** aggregate fields of "correlations" */
export type Correlations_Aggregate_Fields = {
  __typename?: 'correlations_aggregate_fields';
  avg?: Maybe<Correlations_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Correlations_Max_Fields>;
  min?: Maybe<Correlations_Min_Fields>;
  stddev?: Maybe<Correlations_Stddev_Fields>;
  stddev_pop?: Maybe<Correlations_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Correlations_Stddev_Samp_Fields>;
  sum?: Maybe<Correlations_Sum_Fields>;
  var_pop?: Maybe<Correlations_Var_Pop_Fields>;
  var_samp?: Maybe<Correlations_Var_Samp_Fields>;
  variance?: Maybe<Correlations_Variance_Fields>;
};


/** aggregate fields of "correlations" */
export type Correlations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Correlations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Correlations_Avg_Fields = {
  __typename?: 'correlations_avg_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "correlations". All fields are combined with a logical 'AND'. */
export type Correlations_Bool_Exp = {
  _and?: InputMaybe<Array<Correlations_Bool_Exp>>;
  _not?: InputMaybe<Correlations_Bool_Exp>;
  _or?: InputMaybe<Array<Correlations_Bool_Exp>>;
  bitcoin?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_15?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_30?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_60?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_90?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_120?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_180?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_max?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_maxchg?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_min?: InputMaybe<Numeric_Comparison_Exp>;
  bitcoin_minchg?: InputMaybe<Numeric_Comparison_Exp>;
  commodity?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_15?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_30?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_60?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_90?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_120?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_180?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_max?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_maxchg?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_min?: InputMaybe<Numeric_Comparison_Exp>;
  commodity_minchg?: InputMaybe<Numeric_Comparison_Exp>;
  date?: InputMaybe<Date_Comparison_Exp>;
  gold?: InputMaybe<Numeric_Comparison_Exp>;
  gold_15?: InputMaybe<Numeric_Comparison_Exp>;
  gold_30?: InputMaybe<Numeric_Comparison_Exp>;
  gold_60?: InputMaybe<Numeric_Comparison_Exp>;
  gold_90?: InputMaybe<Numeric_Comparison_Exp>;
  gold_120?: InputMaybe<Numeric_Comparison_Exp>;
  gold_180?: InputMaybe<Numeric_Comparison_Exp>;
  gold_max?: InputMaybe<Numeric_Comparison_Exp>;
  gold_maxchg?: InputMaybe<Numeric_Comparison_Exp>;
  gold_min?: InputMaybe<Numeric_Comparison_Exp>;
  gold_minchg?: InputMaybe<Numeric_Comparison_Exp>;
  oil?: InputMaybe<Numeric_Comparison_Exp>;
  oil_15?: InputMaybe<Numeric_Comparison_Exp>;
  oil_30?: InputMaybe<Numeric_Comparison_Exp>;
  oil_60?: InputMaybe<Numeric_Comparison_Exp>;
  oil_90?: InputMaybe<Numeric_Comparison_Exp>;
  oil_120?: InputMaybe<Numeric_Comparison_Exp>;
  oil_180?: InputMaybe<Numeric_Comparison_Exp>;
  oil_max?: InputMaybe<Numeric_Comparison_Exp>;
  oil_maxchg?: InputMaybe<Numeric_Comparison_Exp>;
  oil_min?: InputMaybe<Numeric_Comparison_Exp>;
  oil_minchg?: InputMaybe<Numeric_Comparison_Exp>;
  sp?: InputMaybe<Numeric_Comparison_Exp>;
  sp_15?: InputMaybe<Numeric_Comparison_Exp>;
  sp_30?: InputMaybe<Numeric_Comparison_Exp>;
  sp_60?: InputMaybe<Numeric_Comparison_Exp>;
  sp_90?: InputMaybe<Numeric_Comparison_Exp>;
  sp_120?: InputMaybe<Numeric_Comparison_Exp>;
  sp_180?: InputMaybe<Numeric_Comparison_Exp>;
  sp_max?: InputMaybe<Numeric_Comparison_Exp>;
  sp_maxchg?: InputMaybe<Numeric_Comparison_Exp>;
  sp_min?: InputMaybe<Numeric_Comparison_Exp>;
  sp_minchg?: InputMaybe<Numeric_Comparison_Exp>;
  usd?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "correlations" */
export enum Correlations_Constraint {
  /** unique or primary key constraint on columns "date" */
  CorrelationsPkey = 'correlations_pkey'
}

/** input type for incrementing numeric columns in table "correlations" */
export type Correlations_Inc_Input = {
  bitcoin?: InputMaybe<Scalars['numeric']>;
  bitcoin_15?: InputMaybe<Scalars['numeric']>;
  bitcoin_30?: InputMaybe<Scalars['numeric']>;
  bitcoin_60?: InputMaybe<Scalars['numeric']>;
  bitcoin_90?: InputMaybe<Scalars['numeric']>;
  bitcoin_120?: InputMaybe<Scalars['numeric']>;
  bitcoin_180?: InputMaybe<Scalars['numeric']>;
  bitcoin_max?: InputMaybe<Scalars['numeric']>;
  bitcoin_maxchg?: InputMaybe<Scalars['numeric']>;
  bitcoin_min?: InputMaybe<Scalars['numeric']>;
  bitcoin_minchg?: InputMaybe<Scalars['numeric']>;
  commodity?: InputMaybe<Scalars['numeric']>;
  commodity_15?: InputMaybe<Scalars['numeric']>;
  commodity_30?: InputMaybe<Scalars['numeric']>;
  commodity_60?: InputMaybe<Scalars['numeric']>;
  commodity_90?: InputMaybe<Scalars['numeric']>;
  commodity_120?: InputMaybe<Scalars['numeric']>;
  commodity_180?: InputMaybe<Scalars['numeric']>;
  commodity_max?: InputMaybe<Scalars['numeric']>;
  commodity_maxchg?: InputMaybe<Scalars['numeric']>;
  commodity_min?: InputMaybe<Scalars['numeric']>;
  commodity_minchg?: InputMaybe<Scalars['numeric']>;
  gold?: InputMaybe<Scalars['numeric']>;
  gold_15?: InputMaybe<Scalars['numeric']>;
  gold_30?: InputMaybe<Scalars['numeric']>;
  gold_60?: InputMaybe<Scalars['numeric']>;
  gold_90?: InputMaybe<Scalars['numeric']>;
  gold_120?: InputMaybe<Scalars['numeric']>;
  gold_180?: InputMaybe<Scalars['numeric']>;
  gold_max?: InputMaybe<Scalars['numeric']>;
  gold_maxchg?: InputMaybe<Scalars['numeric']>;
  gold_min?: InputMaybe<Scalars['numeric']>;
  gold_minchg?: InputMaybe<Scalars['numeric']>;
  oil?: InputMaybe<Scalars['numeric']>;
  oil_15?: InputMaybe<Scalars['numeric']>;
  oil_30?: InputMaybe<Scalars['numeric']>;
  oil_60?: InputMaybe<Scalars['numeric']>;
  oil_90?: InputMaybe<Scalars['numeric']>;
  oil_120?: InputMaybe<Scalars['numeric']>;
  oil_180?: InputMaybe<Scalars['numeric']>;
  oil_max?: InputMaybe<Scalars['numeric']>;
  oil_maxchg?: InputMaybe<Scalars['numeric']>;
  oil_min?: InputMaybe<Scalars['numeric']>;
  oil_minchg?: InputMaybe<Scalars['numeric']>;
  sp?: InputMaybe<Scalars['numeric']>;
  sp_15?: InputMaybe<Scalars['numeric']>;
  sp_30?: InputMaybe<Scalars['numeric']>;
  sp_60?: InputMaybe<Scalars['numeric']>;
  sp_90?: InputMaybe<Scalars['numeric']>;
  sp_120?: InputMaybe<Scalars['numeric']>;
  sp_180?: InputMaybe<Scalars['numeric']>;
  sp_max?: InputMaybe<Scalars['numeric']>;
  sp_maxchg?: InputMaybe<Scalars['numeric']>;
  sp_min?: InputMaybe<Scalars['numeric']>;
  sp_minchg?: InputMaybe<Scalars['numeric']>;
  usd?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "correlations" */
export type Correlations_Insert_Input = {
  bitcoin?: InputMaybe<Scalars['numeric']>;
  bitcoin_15?: InputMaybe<Scalars['numeric']>;
  bitcoin_30?: InputMaybe<Scalars['numeric']>;
  bitcoin_60?: InputMaybe<Scalars['numeric']>;
  bitcoin_90?: InputMaybe<Scalars['numeric']>;
  bitcoin_120?: InputMaybe<Scalars['numeric']>;
  bitcoin_180?: InputMaybe<Scalars['numeric']>;
  bitcoin_max?: InputMaybe<Scalars['numeric']>;
  bitcoin_maxchg?: InputMaybe<Scalars['numeric']>;
  bitcoin_min?: InputMaybe<Scalars['numeric']>;
  bitcoin_minchg?: InputMaybe<Scalars['numeric']>;
  commodity?: InputMaybe<Scalars['numeric']>;
  commodity_15?: InputMaybe<Scalars['numeric']>;
  commodity_30?: InputMaybe<Scalars['numeric']>;
  commodity_60?: InputMaybe<Scalars['numeric']>;
  commodity_90?: InputMaybe<Scalars['numeric']>;
  commodity_120?: InputMaybe<Scalars['numeric']>;
  commodity_180?: InputMaybe<Scalars['numeric']>;
  commodity_max?: InputMaybe<Scalars['numeric']>;
  commodity_maxchg?: InputMaybe<Scalars['numeric']>;
  commodity_min?: InputMaybe<Scalars['numeric']>;
  commodity_minchg?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  gold?: InputMaybe<Scalars['numeric']>;
  gold_15?: InputMaybe<Scalars['numeric']>;
  gold_30?: InputMaybe<Scalars['numeric']>;
  gold_60?: InputMaybe<Scalars['numeric']>;
  gold_90?: InputMaybe<Scalars['numeric']>;
  gold_120?: InputMaybe<Scalars['numeric']>;
  gold_180?: InputMaybe<Scalars['numeric']>;
  gold_max?: InputMaybe<Scalars['numeric']>;
  gold_maxchg?: InputMaybe<Scalars['numeric']>;
  gold_min?: InputMaybe<Scalars['numeric']>;
  gold_minchg?: InputMaybe<Scalars['numeric']>;
  oil?: InputMaybe<Scalars['numeric']>;
  oil_15?: InputMaybe<Scalars['numeric']>;
  oil_30?: InputMaybe<Scalars['numeric']>;
  oil_60?: InputMaybe<Scalars['numeric']>;
  oil_90?: InputMaybe<Scalars['numeric']>;
  oil_120?: InputMaybe<Scalars['numeric']>;
  oil_180?: InputMaybe<Scalars['numeric']>;
  oil_max?: InputMaybe<Scalars['numeric']>;
  oil_maxchg?: InputMaybe<Scalars['numeric']>;
  oil_min?: InputMaybe<Scalars['numeric']>;
  oil_minchg?: InputMaybe<Scalars['numeric']>;
  sp?: InputMaybe<Scalars['numeric']>;
  sp_15?: InputMaybe<Scalars['numeric']>;
  sp_30?: InputMaybe<Scalars['numeric']>;
  sp_60?: InputMaybe<Scalars['numeric']>;
  sp_90?: InputMaybe<Scalars['numeric']>;
  sp_120?: InputMaybe<Scalars['numeric']>;
  sp_180?: InputMaybe<Scalars['numeric']>;
  sp_max?: InputMaybe<Scalars['numeric']>;
  sp_maxchg?: InputMaybe<Scalars['numeric']>;
  sp_min?: InputMaybe<Scalars['numeric']>;
  sp_minchg?: InputMaybe<Scalars['numeric']>;
  usd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Correlations_Max_Fields = {
  __typename?: 'correlations_max_fields';
  bitcoin?: Maybe<Scalars['numeric']>;
  bitcoin_15?: Maybe<Scalars['numeric']>;
  bitcoin_30?: Maybe<Scalars['numeric']>;
  bitcoin_60?: Maybe<Scalars['numeric']>;
  bitcoin_90?: Maybe<Scalars['numeric']>;
  bitcoin_120?: Maybe<Scalars['numeric']>;
  bitcoin_180?: Maybe<Scalars['numeric']>;
  bitcoin_max?: Maybe<Scalars['numeric']>;
  bitcoin_maxchg?: Maybe<Scalars['numeric']>;
  bitcoin_min?: Maybe<Scalars['numeric']>;
  bitcoin_minchg?: Maybe<Scalars['numeric']>;
  commodity?: Maybe<Scalars['numeric']>;
  commodity_15?: Maybe<Scalars['numeric']>;
  commodity_30?: Maybe<Scalars['numeric']>;
  commodity_60?: Maybe<Scalars['numeric']>;
  commodity_90?: Maybe<Scalars['numeric']>;
  commodity_120?: Maybe<Scalars['numeric']>;
  commodity_180?: Maybe<Scalars['numeric']>;
  commodity_max?: Maybe<Scalars['numeric']>;
  commodity_maxchg?: Maybe<Scalars['numeric']>;
  commodity_min?: Maybe<Scalars['numeric']>;
  commodity_minchg?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  gold?: Maybe<Scalars['numeric']>;
  gold_15?: Maybe<Scalars['numeric']>;
  gold_30?: Maybe<Scalars['numeric']>;
  gold_60?: Maybe<Scalars['numeric']>;
  gold_90?: Maybe<Scalars['numeric']>;
  gold_120?: Maybe<Scalars['numeric']>;
  gold_180?: Maybe<Scalars['numeric']>;
  gold_max?: Maybe<Scalars['numeric']>;
  gold_maxchg?: Maybe<Scalars['numeric']>;
  gold_min?: Maybe<Scalars['numeric']>;
  gold_minchg?: Maybe<Scalars['numeric']>;
  oil?: Maybe<Scalars['numeric']>;
  oil_15?: Maybe<Scalars['numeric']>;
  oil_30?: Maybe<Scalars['numeric']>;
  oil_60?: Maybe<Scalars['numeric']>;
  oil_90?: Maybe<Scalars['numeric']>;
  oil_120?: Maybe<Scalars['numeric']>;
  oil_180?: Maybe<Scalars['numeric']>;
  oil_max?: Maybe<Scalars['numeric']>;
  oil_maxchg?: Maybe<Scalars['numeric']>;
  oil_min?: Maybe<Scalars['numeric']>;
  oil_minchg?: Maybe<Scalars['numeric']>;
  sp?: Maybe<Scalars['numeric']>;
  sp_15?: Maybe<Scalars['numeric']>;
  sp_30?: Maybe<Scalars['numeric']>;
  sp_60?: Maybe<Scalars['numeric']>;
  sp_90?: Maybe<Scalars['numeric']>;
  sp_120?: Maybe<Scalars['numeric']>;
  sp_180?: Maybe<Scalars['numeric']>;
  sp_max?: Maybe<Scalars['numeric']>;
  sp_maxchg?: Maybe<Scalars['numeric']>;
  sp_min?: Maybe<Scalars['numeric']>;
  sp_minchg?: Maybe<Scalars['numeric']>;
  usd?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Correlations_Min_Fields = {
  __typename?: 'correlations_min_fields';
  bitcoin?: Maybe<Scalars['numeric']>;
  bitcoin_15?: Maybe<Scalars['numeric']>;
  bitcoin_30?: Maybe<Scalars['numeric']>;
  bitcoin_60?: Maybe<Scalars['numeric']>;
  bitcoin_90?: Maybe<Scalars['numeric']>;
  bitcoin_120?: Maybe<Scalars['numeric']>;
  bitcoin_180?: Maybe<Scalars['numeric']>;
  bitcoin_max?: Maybe<Scalars['numeric']>;
  bitcoin_maxchg?: Maybe<Scalars['numeric']>;
  bitcoin_min?: Maybe<Scalars['numeric']>;
  bitcoin_minchg?: Maybe<Scalars['numeric']>;
  commodity?: Maybe<Scalars['numeric']>;
  commodity_15?: Maybe<Scalars['numeric']>;
  commodity_30?: Maybe<Scalars['numeric']>;
  commodity_60?: Maybe<Scalars['numeric']>;
  commodity_90?: Maybe<Scalars['numeric']>;
  commodity_120?: Maybe<Scalars['numeric']>;
  commodity_180?: Maybe<Scalars['numeric']>;
  commodity_max?: Maybe<Scalars['numeric']>;
  commodity_maxchg?: Maybe<Scalars['numeric']>;
  commodity_min?: Maybe<Scalars['numeric']>;
  commodity_minchg?: Maybe<Scalars['numeric']>;
  date?: Maybe<Scalars['date']>;
  gold?: Maybe<Scalars['numeric']>;
  gold_15?: Maybe<Scalars['numeric']>;
  gold_30?: Maybe<Scalars['numeric']>;
  gold_60?: Maybe<Scalars['numeric']>;
  gold_90?: Maybe<Scalars['numeric']>;
  gold_120?: Maybe<Scalars['numeric']>;
  gold_180?: Maybe<Scalars['numeric']>;
  gold_max?: Maybe<Scalars['numeric']>;
  gold_maxchg?: Maybe<Scalars['numeric']>;
  gold_min?: Maybe<Scalars['numeric']>;
  gold_minchg?: Maybe<Scalars['numeric']>;
  oil?: Maybe<Scalars['numeric']>;
  oil_15?: Maybe<Scalars['numeric']>;
  oil_30?: Maybe<Scalars['numeric']>;
  oil_60?: Maybe<Scalars['numeric']>;
  oil_90?: Maybe<Scalars['numeric']>;
  oil_120?: Maybe<Scalars['numeric']>;
  oil_180?: Maybe<Scalars['numeric']>;
  oil_max?: Maybe<Scalars['numeric']>;
  oil_maxchg?: Maybe<Scalars['numeric']>;
  oil_min?: Maybe<Scalars['numeric']>;
  oil_minchg?: Maybe<Scalars['numeric']>;
  sp?: Maybe<Scalars['numeric']>;
  sp_15?: Maybe<Scalars['numeric']>;
  sp_30?: Maybe<Scalars['numeric']>;
  sp_60?: Maybe<Scalars['numeric']>;
  sp_90?: Maybe<Scalars['numeric']>;
  sp_120?: Maybe<Scalars['numeric']>;
  sp_180?: Maybe<Scalars['numeric']>;
  sp_max?: Maybe<Scalars['numeric']>;
  sp_maxchg?: Maybe<Scalars['numeric']>;
  sp_min?: Maybe<Scalars['numeric']>;
  sp_minchg?: Maybe<Scalars['numeric']>;
  usd?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "correlations" */
export type Correlations_Mutation_Response = {
  __typename?: 'correlations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Correlations>;
};

/** on_conflict condition type for table "correlations" */
export type Correlations_On_Conflict = {
  constraint: Correlations_Constraint;
  update_columns?: Array<Correlations_Update_Column>;
  where?: InputMaybe<Correlations_Bool_Exp>;
};

/** Ordering options when selecting data from "correlations". */
export type Correlations_Order_By = {
  bitcoin?: InputMaybe<Order_By>;
  bitcoin_15?: InputMaybe<Order_By>;
  bitcoin_30?: InputMaybe<Order_By>;
  bitcoin_60?: InputMaybe<Order_By>;
  bitcoin_90?: InputMaybe<Order_By>;
  bitcoin_120?: InputMaybe<Order_By>;
  bitcoin_180?: InputMaybe<Order_By>;
  bitcoin_max?: InputMaybe<Order_By>;
  bitcoin_maxchg?: InputMaybe<Order_By>;
  bitcoin_min?: InputMaybe<Order_By>;
  bitcoin_minchg?: InputMaybe<Order_By>;
  commodity?: InputMaybe<Order_By>;
  commodity_15?: InputMaybe<Order_By>;
  commodity_30?: InputMaybe<Order_By>;
  commodity_60?: InputMaybe<Order_By>;
  commodity_90?: InputMaybe<Order_By>;
  commodity_120?: InputMaybe<Order_By>;
  commodity_180?: InputMaybe<Order_By>;
  commodity_max?: InputMaybe<Order_By>;
  commodity_maxchg?: InputMaybe<Order_By>;
  commodity_min?: InputMaybe<Order_By>;
  commodity_minchg?: InputMaybe<Order_By>;
  date?: InputMaybe<Order_By>;
  gold?: InputMaybe<Order_By>;
  gold_15?: InputMaybe<Order_By>;
  gold_30?: InputMaybe<Order_By>;
  gold_60?: InputMaybe<Order_By>;
  gold_90?: InputMaybe<Order_By>;
  gold_120?: InputMaybe<Order_By>;
  gold_180?: InputMaybe<Order_By>;
  gold_max?: InputMaybe<Order_By>;
  gold_maxchg?: InputMaybe<Order_By>;
  gold_min?: InputMaybe<Order_By>;
  gold_minchg?: InputMaybe<Order_By>;
  oil?: InputMaybe<Order_By>;
  oil_15?: InputMaybe<Order_By>;
  oil_30?: InputMaybe<Order_By>;
  oil_60?: InputMaybe<Order_By>;
  oil_90?: InputMaybe<Order_By>;
  oil_120?: InputMaybe<Order_By>;
  oil_180?: InputMaybe<Order_By>;
  oil_max?: InputMaybe<Order_By>;
  oil_maxchg?: InputMaybe<Order_By>;
  oil_min?: InputMaybe<Order_By>;
  oil_minchg?: InputMaybe<Order_By>;
  sp?: InputMaybe<Order_By>;
  sp_15?: InputMaybe<Order_By>;
  sp_30?: InputMaybe<Order_By>;
  sp_60?: InputMaybe<Order_By>;
  sp_90?: InputMaybe<Order_By>;
  sp_120?: InputMaybe<Order_By>;
  sp_180?: InputMaybe<Order_By>;
  sp_max?: InputMaybe<Order_By>;
  sp_maxchg?: InputMaybe<Order_By>;
  sp_min?: InputMaybe<Order_By>;
  sp_minchg?: InputMaybe<Order_By>;
  usd?: InputMaybe<Order_By>;
};

/** primary key columns input for table: correlations */
export type Correlations_Pk_Columns_Input = {
  date: Scalars['date'];
};

/** select columns of table "correlations" */
export enum Correlations_Select_Column {
  /** column name */
  Bitcoin = 'bitcoin',
  /** column name */
  Bitcoin_15 = 'bitcoin_15',
  /** column name */
  Bitcoin_30 = 'bitcoin_30',
  /** column name */
  Bitcoin_60 = 'bitcoin_60',
  /** column name */
  Bitcoin_90 = 'bitcoin_90',
  /** column name */
  Bitcoin_120 = 'bitcoin_120',
  /** column name */
  Bitcoin_180 = 'bitcoin_180',
  /** column name */
  BitcoinMax = 'bitcoin_max',
  /** column name */
  BitcoinMaxchg = 'bitcoin_maxchg',
  /** column name */
  BitcoinMin = 'bitcoin_min',
  /** column name */
  BitcoinMinchg = 'bitcoin_minchg',
  /** column name */
  Commodity = 'commodity',
  /** column name */
  Commodity_15 = 'commodity_15',
  /** column name */
  Commodity_30 = 'commodity_30',
  /** column name */
  Commodity_60 = 'commodity_60',
  /** column name */
  Commodity_90 = 'commodity_90',
  /** column name */
  Commodity_120 = 'commodity_120',
  /** column name */
  Commodity_180 = 'commodity_180',
  /** column name */
  CommodityMax = 'commodity_max',
  /** column name */
  CommodityMaxchg = 'commodity_maxchg',
  /** column name */
  CommodityMin = 'commodity_min',
  /** column name */
  CommodityMinchg = 'commodity_minchg',
  /** column name */
  Date = 'date',
  /** column name */
  Gold = 'gold',
  /** column name */
  Gold_15 = 'gold_15',
  /** column name */
  Gold_30 = 'gold_30',
  /** column name */
  Gold_60 = 'gold_60',
  /** column name */
  Gold_90 = 'gold_90',
  /** column name */
  Gold_120 = 'gold_120',
  /** column name */
  Gold_180 = 'gold_180',
  /** column name */
  GoldMax = 'gold_max',
  /** column name */
  GoldMaxchg = 'gold_maxchg',
  /** column name */
  GoldMin = 'gold_min',
  /** column name */
  GoldMinchg = 'gold_minchg',
  /** column name */
  Oil = 'oil',
  /** column name */
  Oil_15 = 'oil_15',
  /** column name */
  Oil_30 = 'oil_30',
  /** column name */
  Oil_60 = 'oil_60',
  /** column name */
  Oil_90 = 'oil_90',
  /** column name */
  Oil_120 = 'oil_120',
  /** column name */
  Oil_180 = 'oil_180',
  /** column name */
  OilMax = 'oil_max',
  /** column name */
  OilMaxchg = 'oil_maxchg',
  /** column name */
  OilMin = 'oil_min',
  /** column name */
  OilMinchg = 'oil_minchg',
  /** column name */
  Sp = 'sp',
  /** column name */
  Sp_15 = 'sp_15',
  /** column name */
  Sp_30 = 'sp_30',
  /** column name */
  Sp_60 = 'sp_60',
  /** column name */
  Sp_90 = 'sp_90',
  /** column name */
  Sp_120 = 'sp_120',
  /** column name */
  Sp_180 = 'sp_180',
  /** column name */
  SpMax = 'sp_max',
  /** column name */
  SpMaxchg = 'sp_maxchg',
  /** column name */
  SpMin = 'sp_min',
  /** column name */
  SpMinchg = 'sp_minchg',
  /** column name */
  Usd = 'usd'
}

/** input type for updating data in table "correlations" */
export type Correlations_Set_Input = {
  bitcoin?: InputMaybe<Scalars['numeric']>;
  bitcoin_15?: InputMaybe<Scalars['numeric']>;
  bitcoin_30?: InputMaybe<Scalars['numeric']>;
  bitcoin_60?: InputMaybe<Scalars['numeric']>;
  bitcoin_90?: InputMaybe<Scalars['numeric']>;
  bitcoin_120?: InputMaybe<Scalars['numeric']>;
  bitcoin_180?: InputMaybe<Scalars['numeric']>;
  bitcoin_max?: InputMaybe<Scalars['numeric']>;
  bitcoin_maxchg?: InputMaybe<Scalars['numeric']>;
  bitcoin_min?: InputMaybe<Scalars['numeric']>;
  bitcoin_minchg?: InputMaybe<Scalars['numeric']>;
  commodity?: InputMaybe<Scalars['numeric']>;
  commodity_15?: InputMaybe<Scalars['numeric']>;
  commodity_30?: InputMaybe<Scalars['numeric']>;
  commodity_60?: InputMaybe<Scalars['numeric']>;
  commodity_90?: InputMaybe<Scalars['numeric']>;
  commodity_120?: InputMaybe<Scalars['numeric']>;
  commodity_180?: InputMaybe<Scalars['numeric']>;
  commodity_max?: InputMaybe<Scalars['numeric']>;
  commodity_maxchg?: InputMaybe<Scalars['numeric']>;
  commodity_min?: InputMaybe<Scalars['numeric']>;
  commodity_minchg?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  gold?: InputMaybe<Scalars['numeric']>;
  gold_15?: InputMaybe<Scalars['numeric']>;
  gold_30?: InputMaybe<Scalars['numeric']>;
  gold_60?: InputMaybe<Scalars['numeric']>;
  gold_90?: InputMaybe<Scalars['numeric']>;
  gold_120?: InputMaybe<Scalars['numeric']>;
  gold_180?: InputMaybe<Scalars['numeric']>;
  gold_max?: InputMaybe<Scalars['numeric']>;
  gold_maxchg?: InputMaybe<Scalars['numeric']>;
  gold_min?: InputMaybe<Scalars['numeric']>;
  gold_minchg?: InputMaybe<Scalars['numeric']>;
  oil?: InputMaybe<Scalars['numeric']>;
  oil_15?: InputMaybe<Scalars['numeric']>;
  oil_30?: InputMaybe<Scalars['numeric']>;
  oil_60?: InputMaybe<Scalars['numeric']>;
  oil_90?: InputMaybe<Scalars['numeric']>;
  oil_120?: InputMaybe<Scalars['numeric']>;
  oil_180?: InputMaybe<Scalars['numeric']>;
  oil_max?: InputMaybe<Scalars['numeric']>;
  oil_maxchg?: InputMaybe<Scalars['numeric']>;
  oil_min?: InputMaybe<Scalars['numeric']>;
  oil_minchg?: InputMaybe<Scalars['numeric']>;
  sp?: InputMaybe<Scalars['numeric']>;
  sp_15?: InputMaybe<Scalars['numeric']>;
  sp_30?: InputMaybe<Scalars['numeric']>;
  sp_60?: InputMaybe<Scalars['numeric']>;
  sp_90?: InputMaybe<Scalars['numeric']>;
  sp_120?: InputMaybe<Scalars['numeric']>;
  sp_180?: InputMaybe<Scalars['numeric']>;
  sp_max?: InputMaybe<Scalars['numeric']>;
  sp_maxchg?: InputMaybe<Scalars['numeric']>;
  sp_min?: InputMaybe<Scalars['numeric']>;
  sp_minchg?: InputMaybe<Scalars['numeric']>;
  usd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Correlations_Stddev_Fields = {
  __typename?: 'correlations_stddev_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Correlations_Stddev_Pop_Fields = {
  __typename?: 'correlations_stddev_pop_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Correlations_Stddev_Samp_Fields = {
  __typename?: 'correlations_stddev_samp_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "correlations" */
export type Correlations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Correlations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Correlations_Stream_Cursor_Value_Input = {
  bitcoin?: InputMaybe<Scalars['numeric']>;
  bitcoin_15?: InputMaybe<Scalars['numeric']>;
  bitcoin_30?: InputMaybe<Scalars['numeric']>;
  bitcoin_60?: InputMaybe<Scalars['numeric']>;
  bitcoin_90?: InputMaybe<Scalars['numeric']>;
  bitcoin_120?: InputMaybe<Scalars['numeric']>;
  bitcoin_180?: InputMaybe<Scalars['numeric']>;
  bitcoin_max?: InputMaybe<Scalars['numeric']>;
  bitcoin_maxchg?: InputMaybe<Scalars['numeric']>;
  bitcoin_min?: InputMaybe<Scalars['numeric']>;
  bitcoin_minchg?: InputMaybe<Scalars['numeric']>;
  commodity?: InputMaybe<Scalars['numeric']>;
  commodity_15?: InputMaybe<Scalars['numeric']>;
  commodity_30?: InputMaybe<Scalars['numeric']>;
  commodity_60?: InputMaybe<Scalars['numeric']>;
  commodity_90?: InputMaybe<Scalars['numeric']>;
  commodity_120?: InputMaybe<Scalars['numeric']>;
  commodity_180?: InputMaybe<Scalars['numeric']>;
  commodity_max?: InputMaybe<Scalars['numeric']>;
  commodity_maxchg?: InputMaybe<Scalars['numeric']>;
  commodity_min?: InputMaybe<Scalars['numeric']>;
  commodity_minchg?: InputMaybe<Scalars['numeric']>;
  date?: InputMaybe<Scalars['date']>;
  gold?: InputMaybe<Scalars['numeric']>;
  gold_15?: InputMaybe<Scalars['numeric']>;
  gold_30?: InputMaybe<Scalars['numeric']>;
  gold_60?: InputMaybe<Scalars['numeric']>;
  gold_90?: InputMaybe<Scalars['numeric']>;
  gold_120?: InputMaybe<Scalars['numeric']>;
  gold_180?: InputMaybe<Scalars['numeric']>;
  gold_max?: InputMaybe<Scalars['numeric']>;
  gold_maxchg?: InputMaybe<Scalars['numeric']>;
  gold_min?: InputMaybe<Scalars['numeric']>;
  gold_minchg?: InputMaybe<Scalars['numeric']>;
  oil?: InputMaybe<Scalars['numeric']>;
  oil_15?: InputMaybe<Scalars['numeric']>;
  oil_30?: InputMaybe<Scalars['numeric']>;
  oil_60?: InputMaybe<Scalars['numeric']>;
  oil_90?: InputMaybe<Scalars['numeric']>;
  oil_120?: InputMaybe<Scalars['numeric']>;
  oil_180?: InputMaybe<Scalars['numeric']>;
  oil_max?: InputMaybe<Scalars['numeric']>;
  oil_maxchg?: InputMaybe<Scalars['numeric']>;
  oil_min?: InputMaybe<Scalars['numeric']>;
  oil_minchg?: InputMaybe<Scalars['numeric']>;
  sp?: InputMaybe<Scalars['numeric']>;
  sp_15?: InputMaybe<Scalars['numeric']>;
  sp_30?: InputMaybe<Scalars['numeric']>;
  sp_60?: InputMaybe<Scalars['numeric']>;
  sp_90?: InputMaybe<Scalars['numeric']>;
  sp_120?: InputMaybe<Scalars['numeric']>;
  sp_180?: InputMaybe<Scalars['numeric']>;
  sp_max?: InputMaybe<Scalars['numeric']>;
  sp_maxchg?: InputMaybe<Scalars['numeric']>;
  sp_min?: InputMaybe<Scalars['numeric']>;
  sp_minchg?: InputMaybe<Scalars['numeric']>;
  usd?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Correlations_Sum_Fields = {
  __typename?: 'correlations_sum_fields';
  bitcoin?: Maybe<Scalars['numeric']>;
  bitcoin_15?: Maybe<Scalars['numeric']>;
  bitcoin_30?: Maybe<Scalars['numeric']>;
  bitcoin_60?: Maybe<Scalars['numeric']>;
  bitcoin_90?: Maybe<Scalars['numeric']>;
  bitcoin_120?: Maybe<Scalars['numeric']>;
  bitcoin_180?: Maybe<Scalars['numeric']>;
  bitcoin_max?: Maybe<Scalars['numeric']>;
  bitcoin_maxchg?: Maybe<Scalars['numeric']>;
  bitcoin_min?: Maybe<Scalars['numeric']>;
  bitcoin_minchg?: Maybe<Scalars['numeric']>;
  commodity?: Maybe<Scalars['numeric']>;
  commodity_15?: Maybe<Scalars['numeric']>;
  commodity_30?: Maybe<Scalars['numeric']>;
  commodity_60?: Maybe<Scalars['numeric']>;
  commodity_90?: Maybe<Scalars['numeric']>;
  commodity_120?: Maybe<Scalars['numeric']>;
  commodity_180?: Maybe<Scalars['numeric']>;
  commodity_max?: Maybe<Scalars['numeric']>;
  commodity_maxchg?: Maybe<Scalars['numeric']>;
  commodity_min?: Maybe<Scalars['numeric']>;
  commodity_minchg?: Maybe<Scalars['numeric']>;
  gold?: Maybe<Scalars['numeric']>;
  gold_15?: Maybe<Scalars['numeric']>;
  gold_30?: Maybe<Scalars['numeric']>;
  gold_60?: Maybe<Scalars['numeric']>;
  gold_90?: Maybe<Scalars['numeric']>;
  gold_120?: Maybe<Scalars['numeric']>;
  gold_180?: Maybe<Scalars['numeric']>;
  gold_max?: Maybe<Scalars['numeric']>;
  gold_maxchg?: Maybe<Scalars['numeric']>;
  gold_min?: Maybe<Scalars['numeric']>;
  gold_minchg?: Maybe<Scalars['numeric']>;
  oil?: Maybe<Scalars['numeric']>;
  oil_15?: Maybe<Scalars['numeric']>;
  oil_30?: Maybe<Scalars['numeric']>;
  oil_60?: Maybe<Scalars['numeric']>;
  oil_90?: Maybe<Scalars['numeric']>;
  oil_120?: Maybe<Scalars['numeric']>;
  oil_180?: Maybe<Scalars['numeric']>;
  oil_max?: Maybe<Scalars['numeric']>;
  oil_maxchg?: Maybe<Scalars['numeric']>;
  oil_min?: Maybe<Scalars['numeric']>;
  oil_minchg?: Maybe<Scalars['numeric']>;
  sp?: Maybe<Scalars['numeric']>;
  sp_15?: Maybe<Scalars['numeric']>;
  sp_30?: Maybe<Scalars['numeric']>;
  sp_60?: Maybe<Scalars['numeric']>;
  sp_90?: Maybe<Scalars['numeric']>;
  sp_120?: Maybe<Scalars['numeric']>;
  sp_180?: Maybe<Scalars['numeric']>;
  sp_max?: Maybe<Scalars['numeric']>;
  sp_maxchg?: Maybe<Scalars['numeric']>;
  sp_min?: Maybe<Scalars['numeric']>;
  sp_minchg?: Maybe<Scalars['numeric']>;
  usd?: Maybe<Scalars['numeric']>;
};

/** update columns of table "correlations" */
export enum Correlations_Update_Column {
  /** column name */
  Bitcoin = 'bitcoin',
  /** column name */
  Bitcoin_15 = 'bitcoin_15',
  /** column name */
  Bitcoin_30 = 'bitcoin_30',
  /** column name */
  Bitcoin_60 = 'bitcoin_60',
  /** column name */
  Bitcoin_90 = 'bitcoin_90',
  /** column name */
  Bitcoin_120 = 'bitcoin_120',
  /** column name */
  Bitcoin_180 = 'bitcoin_180',
  /** column name */
  BitcoinMax = 'bitcoin_max',
  /** column name */
  BitcoinMaxchg = 'bitcoin_maxchg',
  /** column name */
  BitcoinMin = 'bitcoin_min',
  /** column name */
  BitcoinMinchg = 'bitcoin_minchg',
  /** column name */
  Commodity = 'commodity',
  /** column name */
  Commodity_15 = 'commodity_15',
  /** column name */
  Commodity_30 = 'commodity_30',
  /** column name */
  Commodity_60 = 'commodity_60',
  /** column name */
  Commodity_90 = 'commodity_90',
  /** column name */
  Commodity_120 = 'commodity_120',
  /** column name */
  Commodity_180 = 'commodity_180',
  /** column name */
  CommodityMax = 'commodity_max',
  /** column name */
  CommodityMaxchg = 'commodity_maxchg',
  /** column name */
  CommodityMin = 'commodity_min',
  /** column name */
  CommodityMinchg = 'commodity_minchg',
  /** column name */
  Date = 'date',
  /** column name */
  Gold = 'gold',
  /** column name */
  Gold_15 = 'gold_15',
  /** column name */
  Gold_30 = 'gold_30',
  /** column name */
  Gold_60 = 'gold_60',
  /** column name */
  Gold_90 = 'gold_90',
  /** column name */
  Gold_120 = 'gold_120',
  /** column name */
  Gold_180 = 'gold_180',
  /** column name */
  GoldMax = 'gold_max',
  /** column name */
  GoldMaxchg = 'gold_maxchg',
  /** column name */
  GoldMin = 'gold_min',
  /** column name */
  GoldMinchg = 'gold_minchg',
  /** column name */
  Oil = 'oil',
  /** column name */
  Oil_15 = 'oil_15',
  /** column name */
  Oil_30 = 'oil_30',
  /** column name */
  Oil_60 = 'oil_60',
  /** column name */
  Oil_90 = 'oil_90',
  /** column name */
  Oil_120 = 'oil_120',
  /** column name */
  Oil_180 = 'oil_180',
  /** column name */
  OilMax = 'oil_max',
  /** column name */
  OilMaxchg = 'oil_maxchg',
  /** column name */
  OilMin = 'oil_min',
  /** column name */
  OilMinchg = 'oil_minchg',
  /** column name */
  Sp = 'sp',
  /** column name */
  Sp_15 = 'sp_15',
  /** column name */
  Sp_30 = 'sp_30',
  /** column name */
  Sp_60 = 'sp_60',
  /** column name */
  Sp_90 = 'sp_90',
  /** column name */
  Sp_120 = 'sp_120',
  /** column name */
  Sp_180 = 'sp_180',
  /** column name */
  SpMax = 'sp_max',
  /** column name */
  SpMaxchg = 'sp_maxchg',
  /** column name */
  SpMin = 'sp_min',
  /** column name */
  SpMinchg = 'sp_minchg',
  /** column name */
  Usd = 'usd'
}

export type Correlations_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Correlations_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Correlations_Set_Input>;
  where: Correlations_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Correlations_Var_Pop_Fields = {
  __typename?: 'correlations_var_pop_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Correlations_Var_Samp_Fields = {
  __typename?: 'correlations_var_samp_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Correlations_Variance_Fields = {
  __typename?: 'correlations_variance_fields';
  bitcoin?: Maybe<Scalars['Float']>;
  bitcoin_15?: Maybe<Scalars['Float']>;
  bitcoin_30?: Maybe<Scalars['Float']>;
  bitcoin_60?: Maybe<Scalars['Float']>;
  bitcoin_90?: Maybe<Scalars['Float']>;
  bitcoin_120?: Maybe<Scalars['Float']>;
  bitcoin_180?: Maybe<Scalars['Float']>;
  bitcoin_max?: Maybe<Scalars['Float']>;
  bitcoin_maxchg?: Maybe<Scalars['Float']>;
  bitcoin_min?: Maybe<Scalars['Float']>;
  bitcoin_minchg?: Maybe<Scalars['Float']>;
  commodity?: Maybe<Scalars['Float']>;
  commodity_15?: Maybe<Scalars['Float']>;
  commodity_30?: Maybe<Scalars['Float']>;
  commodity_60?: Maybe<Scalars['Float']>;
  commodity_90?: Maybe<Scalars['Float']>;
  commodity_120?: Maybe<Scalars['Float']>;
  commodity_180?: Maybe<Scalars['Float']>;
  commodity_max?: Maybe<Scalars['Float']>;
  commodity_maxchg?: Maybe<Scalars['Float']>;
  commodity_min?: Maybe<Scalars['Float']>;
  commodity_minchg?: Maybe<Scalars['Float']>;
  gold?: Maybe<Scalars['Float']>;
  gold_15?: Maybe<Scalars['Float']>;
  gold_30?: Maybe<Scalars['Float']>;
  gold_60?: Maybe<Scalars['Float']>;
  gold_90?: Maybe<Scalars['Float']>;
  gold_120?: Maybe<Scalars['Float']>;
  gold_180?: Maybe<Scalars['Float']>;
  gold_max?: Maybe<Scalars['Float']>;
  gold_maxchg?: Maybe<Scalars['Float']>;
  gold_min?: Maybe<Scalars['Float']>;
  gold_minchg?: Maybe<Scalars['Float']>;
  oil?: Maybe<Scalars['Float']>;
  oil_15?: Maybe<Scalars['Float']>;
  oil_30?: Maybe<Scalars['Float']>;
  oil_60?: Maybe<Scalars['Float']>;
  oil_90?: Maybe<Scalars['Float']>;
  oil_120?: Maybe<Scalars['Float']>;
  oil_180?: Maybe<Scalars['Float']>;
  oil_max?: Maybe<Scalars['Float']>;
  oil_maxchg?: Maybe<Scalars['Float']>;
  oil_min?: Maybe<Scalars['Float']>;
  oil_minchg?: Maybe<Scalars['Float']>;
  sp?: Maybe<Scalars['Float']>;
  sp_15?: Maybe<Scalars['Float']>;
  sp_30?: Maybe<Scalars['Float']>;
  sp_60?: Maybe<Scalars['Float']>;
  sp_90?: Maybe<Scalars['Float']>;
  sp_120?: Maybe<Scalars['Float']>;
  sp_180?: Maybe<Scalars['Float']>;
  sp_max?: Maybe<Scalars['Float']>;
  sp_maxchg?: Maybe<Scalars['Float']>;
  sp_min?: Maybe<Scalars['Float']>;
  sp_minchg?: Maybe<Scalars['Float']>;
  usd?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "data3" */
export type Data3 = {
  __typename?: 'data3';
  algo?: Maybe<Ticker2_Schema_Data>;
  algo_30D_ST_MOMENTUM?: Maybe<Scalars['String']>;
  algo_30D_ST_MOMENTUM_3D?: Maybe<Scalars['String']>;
  algo_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_90D_MT_MOMENTUM?: Maybe<Scalars['String']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: Maybe<Scalars['String']>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: Maybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: Maybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_SIGNAL?: Maybe<Scalars['String']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_IVOL_1WK_CHECK?: Maybe<Scalars['String']>;
  algo_IVOL_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM_3D?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_90D_MT_MOMENTUM?: Maybe<Scalars['String']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_daily_IVOL_1WK_CHECK?: Maybe<Scalars['String']>;
  algo_daily_IVOL_3MO_CHECK?: Maybe<Scalars['String']>;
  algo_daily_IVOL_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_kiss_high?: Maybe<Scalars['String']>;
  algo_daily_kiss_low?: Maybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: Maybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength: Scalars['numeric'];
  calc_realized_volatility_1m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_current?: Maybe<Scalars['numeric']>;
  calc_volume_1d?: Maybe<Scalars['numeric']>;
  calc_volume_1m?: Maybe<Scalars['numeric']>;
  calc_volume_3m?: Maybe<Scalars['numeric']>;
  calc_volume_5d?: Maybe<Scalars['numeric']>;
  cdr_country_code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  crncy?: Maybe<Scalars['String']>;
  current_trr_1d?: Maybe<Scalars['numeric']>;
  current_trr_1mo?: Maybe<Scalars['numeric']>;
  current_trr_3mo?: Maybe<Scalars['numeric']>;
  current_trr_5d?: Maybe<Scalars['numeric']>;
  current_trr_ytd?: Maybe<Scalars['numeric']>;
  daily: Scalars['Boolean'];
  entry_date?: Maybe<Scalars['String']>;
  entry_price?: Maybe<Scalars['numeric']>;
  eqy_beta?: Maybe<Scalars['numeric']>;
  eqy_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_raw_beta?: Maybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['numeric']>;
  eqy_split_dt?: Maybe<Scalars['date']>;
  eqy_split_ratio?: Maybe<Scalars['String']>;
  exposure?: Maybe<Scalars['numeric']>;
  insider_monthly_transaction?: Maybe<Scalars['String']>;
  long_short?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onem_short_int_pct?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['numeric']>;
  px_close_1d?: Maybe<Scalars['numeric']>;
  px_close_1m?: Maybe<Scalars['numeric']>;
  px_close_1yr?: Maybe<Scalars['numeric']>;
  px_close_3m?: Maybe<Scalars['numeric']>;
  px_close_5d?: Maybe<Scalars['numeric']>;
  px_close_dt?: Maybe<Scalars['date']>;
  px_close_ytd?: Maybe<Scalars['numeric']>;
  px_high?: Maybe<Scalars['numeric']>;
  px_last?: Maybe<Scalars['numeric']>;
  px_last_eod?: Maybe<Scalars['numeric']>;
  px_low?: Maybe<Scalars['numeric']>;
  px_volume?: Maybe<Scalars['numeric']>;
  px_volume_1d?: Maybe<Scalars['numeric']>;
  red_current_trr_1d?: Maybe<Scalars['Boolean']>;
  red_current_trr_1mo?: Maybe<Scalars['Boolean']>;
  red_current_trr_3mo?: Maybe<Scalars['Boolean']>;
  red_current_trr_5d?: Maybe<Scalars['Boolean']>;
  red_current_trr_ytd?: Maybe<Scalars['Boolean']>;
  red_eqy_beta?: Maybe<Scalars['Boolean']>;
  red_eqy_beta_6m?: Maybe<Scalars['Boolean']>;
  red_eqy_raw_beta?: Maybe<Scalars['Boolean']>;
  red_eqy_raw_beta_6m?: Maybe<Scalars['Boolean']>;
  red_onem_short_int_pct?: Maybe<Scalars['Boolean']>;
  red_put_imp_vol_30d?: Maybe<Scalars['Boolean']>;
  red_px_close_1d?: Maybe<Scalars['Boolean']>;
  red_px_close_1m?: Maybe<Scalars['Boolean']>;
  red_px_close_1yr?: Maybe<Scalars['Boolean']>;
  red_px_close_3m?: Maybe<Scalars['Boolean']>;
  red_px_close_5d?: Maybe<Scalars['Boolean']>;
  red_px_close_ytd?: Maybe<Scalars['Boolean']>;
  red_px_high?: Maybe<Scalars['Boolean']>;
  red_px_last?: Maybe<Scalars['Boolean']>;
  red_px_last_eod?: Maybe<Scalars['Boolean']>;
  red_px_low?: Maybe<Scalars['Boolean']>;
  red_px_volume?: Maybe<Scalars['Boolean']>;
  red_px_volume_1d?: Maybe<Scalars['Boolean']>;
  red_short_int_pct_chg?: Maybe<Scalars['Boolean']>;
  red_si_percent_equity_float?: Maybe<Scalars['Boolean']>;
  red_volatility_10d?: Maybe<Scalars['Boolean']>;
  red_volatility_30d?: Maybe<Scalars['Boolean']>;
  red_volume_avg_3m?: Maybe<Scalars['Boolean']>;
  red_volume_avg_5d?: Maybe<Scalars['Boolean']>;
  red_volume_avg_6m?: Maybe<Scalars['Boolean']>;
  red_volume_avg_30d?: Maybe<Scalars['Boolean']>;
  security_typ?: Maybe<Scalars['String']>;
  short_int_date?: Maybe<Scalars['date']>;
  short_int_pct_chg?: Maybe<Scalars['numeric']>;
  si_percent_equity_float?: Maybe<Scalars['numeric']>;
  ticker: Scalars['String'];
  ticker_and_exch_code?: Maybe<Scalars['String']>;
  volatility_10d?: Maybe<Scalars['numeric']>;
  volatility_30d?: Maybe<Scalars['numeric']>;
  volatility_30d_1d?: Maybe<Scalars['numeric']>;
  volatility_30d_1m?: Maybe<Scalars['numeric']>;
  volatility_30d_1w?: Maybe<Scalars['numeric']>;
  volatility_30d_3m?: Maybe<Scalars['numeric']>;
  volume_avg_1d?: Maybe<Scalars['numeric']>;
  volume_avg_3m?: Maybe<Scalars['numeric']>;
  volume_avg_5d?: Maybe<Scalars['numeric']>;
  volume_avg_6m?: Maybe<Scalars['numeric']>;
  volume_avg_30d?: Maybe<Scalars['numeric']>;
};

/** aggregated selection of "data3" */
export type Data3_Aggregate = {
  __typename?: 'data3_aggregate';
  aggregate?: Maybe<Data3_Aggregate_Fields>;
  nodes: Array<Data3>;
};

/** aggregate fields of "data3" */
export type Data3_Aggregate_Fields = {
  __typename?: 'data3_aggregate_fields';
  avg?: Maybe<Data3_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Data3_Max_Fields>;
  min?: Maybe<Data3_Min_Fields>;
  stddev?: Maybe<Data3_Stddev_Fields>;
  stddev_pop?: Maybe<Data3_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Data3_Stddev_Samp_Fields>;
  sum?: Maybe<Data3_Sum_Fields>;
  var_pop?: Maybe<Data3_Var_Pop_Fields>;
  var_samp?: Maybe<Data3_Var_Samp_Fields>;
  variance?: Maybe<Data3_Variance_Fields>;
};


/** aggregate fields of "data3" */
export type Data3_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Data3_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Data3_Avg_Fields = {
  __typename?: 'data3_avg_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "data3". All fields are combined with a logical 'AND'. */
export type Data3_Bool_Exp = {
  _and?: InputMaybe<Array<Data3_Bool_Exp>>;
  _not?: InputMaybe<Data3_Bool_Exp>;
  _or?: InputMaybe<Array<Data3_Bool_Exp>>;
  algo_30D_ST_MOMENTUM?: InputMaybe<String_Comparison_Exp>;
  algo_30D_ST_MOMENTUM_3D?: InputMaybe<String_Comparison_Exp>;
  algo_30D_ST_PRICE?: InputMaybe<Numeric_Comparison_Exp>;
  algo_90D_MT_MOMENTUM?: InputMaybe<String_Comparison_Exp>;
  algo_90D_MT_PRICE?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CALC_TRADE_RANGE_HIGH?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CALC_TRADE_RANGE_LOW?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CALC_TRADE_RANGE_ODDS?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<String_Comparison_Exp>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<String_Comparison_Exp>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<String_Comparison_Exp>;
  algo_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_CurrImpVolDiscPrem?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CurrImpVolDiscPrem1D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CurrImpVolDiscPrem7D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CurrImpVolDiscPrem30D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_CurrImpVolDiscPrem90D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_IVOL_1WK_CHECK?: InputMaybe<String_Comparison_Exp>;
  algo_IVOL_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_daily_30D_ST_MOMENTUM?: InputMaybe<String_Comparison_Exp>;
  algo_daily_30D_ST_MOMENTUM_3D?: InputMaybe<String_Comparison_Exp>;
  algo_daily_30D_ST_PRICE?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_90D_MT_MOMENTUM?: InputMaybe<String_Comparison_Exp>;
  algo_daily_90D_MT_PRICE?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CALC_TRADE_RANGE_LOW?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<String_Comparison_Exp>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<String_Comparison_Exp>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<String_Comparison_Exp>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_daily_CurrImpVolDiscPrem?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CurrImpVolDiscPrem1D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CurrImpVolDiscPrem7D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CurrImpVolDiscPrem30D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_CurrImpVolDiscPrem90D?: InputMaybe<Numeric_Comparison_Exp>;
  algo_daily_IVOL_1WK_CHECK?: InputMaybe<String_Comparison_Exp>;
  algo_daily_IVOL_3MO_CHECK?: InputMaybe<String_Comparison_Exp>;
  algo_daily_IVOL_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_daily_kiss_high?: InputMaybe<String_Comparison_Exp>;
  algo_daily_kiss_low?: InputMaybe<String_Comparison_Exp>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<String_Comparison_Exp>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Numeric_Comparison_Exp>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: InputMaybe<Numeric_Comparison_Exp>;
  algo_eod_CALC_TRADE_RANGE_LOW?: InputMaybe<Numeric_Comparison_Exp>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: InputMaybe<Numeric_Comparison_Exp>;
  algo_eod_PX_LAST?: InputMaybe<Numeric_Comparison_Exp>;
  calc_position_longbow_signal_strength?: InputMaybe<Numeric_Comparison_Exp>;
  calc_realized_volatility_1m?: InputMaybe<Numeric_Comparison_Exp>;
  calc_realized_volatility_1w?: InputMaybe<Numeric_Comparison_Exp>;
  calc_realized_volatility_3m?: InputMaybe<Numeric_Comparison_Exp>;
  calc_realized_volatility_current?: InputMaybe<Numeric_Comparison_Exp>;
  calc_volume_1d?: InputMaybe<Numeric_Comparison_Exp>;
  calc_volume_1m?: InputMaybe<Numeric_Comparison_Exp>;
  calc_volume_3m?: InputMaybe<Numeric_Comparison_Exp>;
  calc_volume_5d?: InputMaybe<Numeric_Comparison_Exp>;
  cdr_country_code?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  crncy?: InputMaybe<String_Comparison_Exp>;
  current_trr_1d?: InputMaybe<Numeric_Comparison_Exp>;
  current_trr_1mo?: InputMaybe<Numeric_Comparison_Exp>;
  current_trr_3mo?: InputMaybe<Numeric_Comparison_Exp>;
  current_trr_5d?: InputMaybe<Numeric_Comparison_Exp>;
  current_trr_ytd?: InputMaybe<Numeric_Comparison_Exp>;
  daily?: InputMaybe<Boolean_Comparison_Exp>;
  entry_date?: InputMaybe<String_Comparison_Exp>;
  entry_price?: InputMaybe<Numeric_Comparison_Exp>;
  eqy_beta?: InputMaybe<Numeric_Comparison_Exp>;
  eqy_beta_6m?: InputMaybe<Numeric_Comparison_Exp>;
  eqy_raw_beta?: InputMaybe<Numeric_Comparison_Exp>;
  eqy_raw_beta_6m?: InputMaybe<Numeric_Comparison_Exp>;
  eqy_split_adjustment_factor?: InputMaybe<Numeric_Comparison_Exp>;
  eqy_split_dt?: InputMaybe<Date_Comparison_Exp>;
  eqy_split_ratio?: InputMaybe<String_Comparison_Exp>;
  exposure?: InputMaybe<Numeric_Comparison_Exp>;
  insider_monthly_transaction?: InputMaybe<String_Comparison_Exp>;
  long_short?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  onem_short_int_pct?: InputMaybe<Numeric_Comparison_Exp>;
  put_imp_vol_30d?: InputMaybe<Numeric_Comparison_Exp>;
  put_imp_vol_30d_1d?: InputMaybe<Numeric_Comparison_Exp>;
  put_imp_vol_30d_1m?: InputMaybe<Numeric_Comparison_Exp>;
  put_imp_vol_30d_1w?: InputMaybe<Numeric_Comparison_Exp>;
  put_imp_vol_30d_3m?: InputMaybe<Numeric_Comparison_Exp>;
  px_close_1d?: InputMaybe<Numeric_Comparison_Exp>;
  px_close_1m?: InputMaybe<Numeric_Comparison_Exp>;
  px_close_1yr?: InputMaybe<Numeric_Comparison_Exp>;
  px_close_3m?: InputMaybe<Numeric_Comparison_Exp>;
  px_close_5d?: InputMaybe<Numeric_Comparison_Exp>;
  px_close_dt?: InputMaybe<Date_Comparison_Exp>;
  px_close_ytd?: InputMaybe<Numeric_Comparison_Exp>;
  px_high?: InputMaybe<Numeric_Comparison_Exp>;
  px_last?: InputMaybe<Numeric_Comparison_Exp>;
  px_last_eod?: InputMaybe<Numeric_Comparison_Exp>;
  px_low?: InputMaybe<Numeric_Comparison_Exp>;
  px_volume?: InputMaybe<Numeric_Comparison_Exp>;
  px_volume_1d?: InputMaybe<Numeric_Comparison_Exp>;
  red_current_trr_1d?: InputMaybe<Boolean_Comparison_Exp>;
  red_current_trr_1mo?: InputMaybe<Boolean_Comparison_Exp>;
  red_current_trr_3mo?: InputMaybe<Boolean_Comparison_Exp>;
  red_current_trr_5d?: InputMaybe<Boolean_Comparison_Exp>;
  red_current_trr_ytd?: InputMaybe<Boolean_Comparison_Exp>;
  red_eqy_beta?: InputMaybe<Boolean_Comparison_Exp>;
  red_eqy_beta_6m?: InputMaybe<Boolean_Comparison_Exp>;
  red_eqy_raw_beta?: InputMaybe<Boolean_Comparison_Exp>;
  red_eqy_raw_beta_6m?: InputMaybe<Boolean_Comparison_Exp>;
  red_onem_short_int_pct?: InputMaybe<Boolean_Comparison_Exp>;
  red_put_imp_vol_30d?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_close_1d?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_close_1m?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_close_1yr?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_close_3m?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_close_5d?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_close_ytd?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_high?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_last?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_last_eod?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_low?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_volume?: InputMaybe<Boolean_Comparison_Exp>;
  red_px_volume_1d?: InputMaybe<Boolean_Comparison_Exp>;
  red_short_int_pct_chg?: InputMaybe<Boolean_Comparison_Exp>;
  red_si_percent_equity_float?: InputMaybe<Boolean_Comparison_Exp>;
  red_volatility_10d?: InputMaybe<Boolean_Comparison_Exp>;
  red_volatility_30d?: InputMaybe<Boolean_Comparison_Exp>;
  red_volume_avg_3m?: InputMaybe<Boolean_Comparison_Exp>;
  red_volume_avg_5d?: InputMaybe<Boolean_Comparison_Exp>;
  red_volume_avg_6m?: InputMaybe<Boolean_Comparison_Exp>;
  red_volume_avg_30d?: InputMaybe<Boolean_Comparison_Exp>;
  security_typ?: InputMaybe<String_Comparison_Exp>;
  short_int_date?: InputMaybe<Date_Comparison_Exp>;
  short_int_pct_chg?: InputMaybe<Numeric_Comparison_Exp>;
  si_percent_equity_float?: InputMaybe<Numeric_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  ticker_and_exch_code?: InputMaybe<String_Comparison_Exp>;
  volatility_10d?: InputMaybe<Numeric_Comparison_Exp>;
  volatility_30d?: InputMaybe<Numeric_Comparison_Exp>;
  volatility_30d_1d?: InputMaybe<Numeric_Comparison_Exp>;
  volatility_30d_1m?: InputMaybe<Numeric_Comparison_Exp>;
  volatility_30d_1w?: InputMaybe<Numeric_Comparison_Exp>;
  volatility_30d_3m?: InputMaybe<Numeric_Comparison_Exp>;
  volume_avg_1d?: InputMaybe<Numeric_Comparison_Exp>;
  volume_avg_3m?: InputMaybe<Numeric_Comparison_Exp>;
  volume_avg_5d?: InputMaybe<Numeric_Comparison_Exp>;
  volume_avg_6m?: InputMaybe<Numeric_Comparison_Exp>;
  volume_avg_30d?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "data3" */
export enum Data3_Constraint {
  /** unique or primary key constraint on columns "ticker" */
  Data2Pkey_1 = 'data2_pkey_1'
}

/** input type for incrementing numeric columns in table "data3" */
export type Data3_Inc_Input = {
  algo_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_daily_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: InputMaybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_current?: InputMaybe<Scalars['numeric']>;
  calc_volume_1d?: InputMaybe<Scalars['numeric']>;
  calc_volume_1m?: InputMaybe<Scalars['numeric']>;
  calc_volume_3m?: InputMaybe<Scalars['numeric']>;
  calc_volume_5d?: InputMaybe<Scalars['numeric']>;
  current_trr_1d?: InputMaybe<Scalars['numeric']>;
  current_trr_1mo?: InputMaybe<Scalars['numeric']>;
  current_trr_3mo?: InputMaybe<Scalars['numeric']>;
  current_trr_5d?: InputMaybe<Scalars['numeric']>;
  current_trr_ytd?: InputMaybe<Scalars['numeric']>;
  entry_price?: InputMaybe<Scalars['numeric']>;
  eqy_beta?: InputMaybe<Scalars['numeric']>;
  eqy_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: InputMaybe<Scalars['numeric']>;
  exposure?: InputMaybe<Scalars['numeric']>;
  onem_short_int_pct?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: InputMaybe<Scalars['numeric']>;
  px_close_1d?: InputMaybe<Scalars['numeric']>;
  px_close_1m?: InputMaybe<Scalars['numeric']>;
  px_close_1yr?: InputMaybe<Scalars['numeric']>;
  px_close_3m?: InputMaybe<Scalars['numeric']>;
  px_close_5d?: InputMaybe<Scalars['numeric']>;
  px_close_ytd?: InputMaybe<Scalars['numeric']>;
  px_high?: InputMaybe<Scalars['numeric']>;
  px_last?: InputMaybe<Scalars['numeric']>;
  px_last_eod?: InputMaybe<Scalars['numeric']>;
  px_low?: InputMaybe<Scalars['numeric']>;
  px_volume?: InputMaybe<Scalars['numeric']>;
  px_volume_1d?: InputMaybe<Scalars['numeric']>;
  short_int_pct_chg?: InputMaybe<Scalars['numeric']>;
  si_percent_equity_float?: InputMaybe<Scalars['numeric']>;
  volatility_10d?: InputMaybe<Scalars['numeric']>;
  volatility_30d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1m?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1w?: InputMaybe<Scalars['numeric']>;
  volatility_30d_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_1d?: InputMaybe<Scalars['numeric']>;
  volume_avg_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_5d?: InputMaybe<Scalars['numeric']>;
  volume_avg_6m?: InputMaybe<Scalars['numeric']>;
  volume_avg_30d?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "data3" */
export type Data3_Insert_Input = {
  algo_30D_ST_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_30D_ST_MOMENTUM_3D?: InputMaybe<Scalars['String']>;
  algo_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_90D_MT_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_IVOL_1WK_CHECK?: InputMaybe<Scalars['String']>;
  algo_IVOL_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM_3D?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_90D_MT_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_daily_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_daily_IVOL_1WK_CHECK?: InputMaybe<Scalars['String']>;
  algo_daily_IVOL_3MO_CHECK?: InputMaybe<Scalars['String']>;
  algo_daily_IVOL_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_kiss_high?: InputMaybe<Scalars['String']>;
  algo_daily_kiss_low?: InputMaybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: InputMaybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_current?: InputMaybe<Scalars['numeric']>;
  calc_volume_1d?: InputMaybe<Scalars['numeric']>;
  calc_volume_1m?: InputMaybe<Scalars['numeric']>;
  calc_volume_3m?: InputMaybe<Scalars['numeric']>;
  calc_volume_5d?: InputMaybe<Scalars['numeric']>;
  cdr_country_code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  crncy?: InputMaybe<Scalars['String']>;
  current_trr_1d?: InputMaybe<Scalars['numeric']>;
  current_trr_1mo?: InputMaybe<Scalars['numeric']>;
  current_trr_3mo?: InputMaybe<Scalars['numeric']>;
  current_trr_5d?: InputMaybe<Scalars['numeric']>;
  current_trr_ytd?: InputMaybe<Scalars['numeric']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  entry_date?: InputMaybe<Scalars['String']>;
  entry_price?: InputMaybe<Scalars['numeric']>;
  eqy_beta?: InputMaybe<Scalars['numeric']>;
  eqy_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: InputMaybe<Scalars['numeric']>;
  eqy_split_dt?: InputMaybe<Scalars['date']>;
  eqy_split_ratio?: InputMaybe<Scalars['String']>;
  exposure?: InputMaybe<Scalars['numeric']>;
  insider_monthly_transaction?: InputMaybe<Scalars['String']>;
  long_short?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  onem_short_int_pct?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: InputMaybe<Scalars['numeric']>;
  px_close_1d?: InputMaybe<Scalars['numeric']>;
  px_close_1m?: InputMaybe<Scalars['numeric']>;
  px_close_1yr?: InputMaybe<Scalars['numeric']>;
  px_close_3m?: InputMaybe<Scalars['numeric']>;
  px_close_5d?: InputMaybe<Scalars['numeric']>;
  px_close_dt?: InputMaybe<Scalars['date']>;
  px_close_ytd?: InputMaybe<Scalars['numeric']>;
  px_high?: InputMaybe<Scalars['numeric']>;
  px_last?: InputMaybe<Scalars['numeric']>;
  px_last_eod?: InputMaybe<Scalars['numeric']>;
  px_low?: InputMaybe<Scalars['numeric']>;
  px_volume?: InputMaybe<Scalars['numeric']>;
  px_volume_1d?: InputMaybe<Scalars['numeric']>;
  red_current_trr_1d?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_1mo?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_3mo?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_5d?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_ytd?: InputMaybe<Scalars['Boolean']>;
  red_eqy_beta?: InputMaybe<Scalars['Boolean']>;
  red_eqy_beta_6m?: InputMaybe<Scalars['Boolean']>;
  red_eqy_raw_beta?: InputMaybe<Scalars['Boolean']>;
  red_eqy_raw_beta_6m?: InputMaybe<Scalars['Boolean']>;
  red_onem_short_int_pct?: InputMaybe<Scalars['Boolean']>;
  red_put_imp_vol_30d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1m?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1yr?: InputMaybe<Scalars['Boolean']>;
  red_px_close_3m?: InputMaybe<Scalars['Boolean']>;
  red_px_close_5d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_ytd?: InputMaybe<Scalars['Boolean']>;
  red_px_high?: InputMaybe<Scalars['Boolean']>;
  red_px_last?: InputMaybe<Scalars['Boolean']>;
  red_px_last_eod?: InputMaybe<Scalars['Boolean']>;
  red_px_low?: InputMaybe<Scalars['Boolean']>;
  red_px_volume?: InputMaybe<Scalars['Boolean']>;
  red_px_volume_1d?: InputMaybe<Scalars['Boolean']>;
  red_short_int_pct_chg?: InputMaybe<Scalars['Boolean']>;
  red_si_percent_equity_float?: InputMaybe<Scalars['Boolean']>;
  red_volatility_10d?: InputMaybe<Scalars['Boolean']>;
  red_volatility_30d?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_3m?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_5d?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_6m?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_30d?: InputMaybe<Scalars['Boolean']>;
  security_typ?: InputMaybe<Scalars['String']>;
  short_int_date?: InputMaybe<Scalars['date']>;
  short_int_pct_chg?: InputMaybe<Scalars['numeric']>;
  si_percent_equity_float?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  ticker_and_exch_code?: InputMaybe<Scalars['String']>;
  volatility_10d?: InputMaybe<Scalars['numeric']>;
  volatility_30d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1m?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1w?: InputMaybe<Scalars['numeric']>;
  volatility_30d_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_1d?: InputMaybe<Scalars['numeric']>;
  volume_avg_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_5d?: InputMaybe<Scalars['numeric']>;
  volume_avg_6m?: InputMaybe<Scalars['numeric']>;
  volume_avg_30d?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Data3_Max_Fields = {
  __typename?: 'data3_max_fields';
  algo_30D_ST_MOMENTUM?: Maybe<Scalars['String']>;
  algo_30D_ST_MOMENTUM_3D?: Maybe<Scalars['String']>;
  algo_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_90D_MT_MOMENTUM?: Maybe<Scalars['String']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: Maybe<Scalars['String']>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: Maybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: Maybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_SIGNAL?: Maybe<Scalars['String']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_IVOL_1WK_CHECK?: Maybe<Scalars['String']>;
  algo_IVOL_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM_3D?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_90D_MT_MOMENTUM?: Maybe<Scalars['String']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_daily_IVOL_1WK_CHECK?: Maybe<Scalars['String']>;
  algo_daily_IVOL_3MO_CHECK?: Maybe<Scalars['String']>;
  algo_daily_IVOL_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_kiss_high?: Maybe<Scalars['String']>;
  algo_daily_kiss_low?: Maybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: Maybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_current?: Maybe<Scalars['numeric']>;
  calc_volume_1d?: Maybe<Scalars['numeric']>;
  calc_volume_1m?: Maybe<Scalars['numeric']>;
  calc_volume_3m?: Maybe<Scalars['numeric']>;
  calc_volume_5d?: Maybe<Scalars['numeric']>;
  cdr_country_code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  crncy?: Maybe<Scalars['String']>;
  current_trr_1d?: Maybe<Scalars['numeric']>;
  current_trr_1mo?: Maybe<Scalars['numeric']>;
  current_trr_3mo?: Maybe<Scalars['numeric']>;
  current_trr_5d?: Maybe<Scalars['numeric']>;
  current_trr_ytd?: Maybe<Scalars['numeric']>;
  entry_date?: Maybe<Scalars['String']>;
  entry_price?: Maybe<Scalars['numeric']>;
  eqy_beta?: Maybe<Scalars['numeric']>;
  eqy_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_raw_beta?: Maybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['numeric']>;
  eqy_split_dt?: Maybe<Scalars['date']>;
  eqy_split_ratio?: Maybe<Scalars['String']>;
  exposure?: Maybe<Scalars['numeric']>;
  insider_monthly_transaction?: Maybe<Scalars['String']>;
  long_short?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onem_short_int_pct?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['numeric']>;
  px_close_1d?: Maybe<Scalars['numeric']>;
  px_close_1m?: Maybe<Scalars['numeric']>;
  px_close_1yr?: Maybe<Scalars['numeric']>;
  px_close_3m?: Maybe<Scalars['numeric']>;
  px_close_5d?: Maybe<Scalars['numeric']>;
  px_close_dt?: Maybe<Scalars['date']>;
  px_close_ytd?: Maybe<Scalars['numeric']>;
  px_high?: Maybe<Scalars['numeric']>;
  px_last?: Maybe<Scalars['numeric']>;
  px_last_eod?: Maybe<Scalars['numeric']>;
  px_low?: Maybe<Scalars['numeric']>;
  px_volume?: Maybe<Scalars['numeric']>;
  px_volume_1d?: Maybe<Scalars['numeric']>;
  security_typ?: Maybe<Scalars['String']>;
  short_int_date?: Maybe<Scalars['date']>;
  short_int_pct_chg?: Maybe<Scalars['numeric']>;
  si_percent_equity_float?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  ticker_and_exch_code?: Maybe<Scalars['String']>;
  volatility_10d?: Maybe<Scalars['numeric']>;
  volatility_30d?: Maybe<Scalars['numeric']>;
  volatility_30d_1d?: Maybe<Scalars['numeric']>;
  volatility_30d_1m?: Maybe<Scalars['numeric']>;
  volatility_30d_1w?: Maybe<Scalars['numeric']>;
  volatility_30d_3m?: Maybe<Scalars['numeric']>;
  volume_avg_1d?: Maybe<Scalars['numeric']>;
  volume_avg_3m?: Maybe<Scalars['numeric']>;
  volume_avg_5d?: Maybe<Scalars['numeric']>;
  volume_avg_6m?: Maybe<Scalars['numeric']>;
  volume_avg_30d?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Data3_Min_Fields = {
  __typename?: 'data3_min_fields';
  algo_30D_ST_MOMENTUM?: Maybe<Scalars['String']>;
  algo_30D_ST_MOMENTUM_3D?: Maybe<Scalars['String']>;
  algo_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_90D_MT_MOMENTUM?: Maybe<Scalars['String']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: Maybe<Scalars['String']>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: Maybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: Maybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_SIGNAL?: Maybe<Scalars['String']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_IVOL_1WK_CHECK?: Maybe<Scalars['String']>;
  algo_IVOL_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM_3D?: Maybe<Scalars['String']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_90D_MT_MOMENTUM?: Maybe<Scalars['String']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: Maybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_daily_IVOL_1WK_CHECK?: Maybe<Scalars['String']>;
  algo_daily_IVOL_3MO_CHECK?: Maybe<Scalars['String']>;
  algo_daily_IVOL_SIGNAL?: Maybe<Scalars['String']>;
  algo_daily_kiss_high?: Maybe<Scalars['String']>;
  algo_daily_kiss_low?: Maybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: Maybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: Maybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_current?: Maybe<Scalars['numeric']>;
  calc_volume_1d?: Maybe<Scalars['numeric']>;
  calc_volume_1m?: Maybe<Scalars['numeric']>;
  calc_volume_3m?: Maybe<Scalars['numeric']>;
  calc_volume_5d?: Maybe<Scalars['numeric']>;
  cdr_country_code?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  crncy?: Maybe<Scalars['String']>;
  current_trr_1d?: Maybe<Scalars['numeric']>;
  current_trr_1mo?: Maybe<Scalars['numeric']>;
  current_trr_3mo?: Maybe<Scalars['numeric']>;
  current_trr_5d?: Maybe<Scalars['numeric']>;
  current_trr_ytd?: Maybe<Scalars['numeric']>;
  entry_date?: Maybe<Scalars['String']>;
  entry_price?: Maybe<Scalars['numeric']>;
  eqy_beta?: Maybe<Scalars['numeric']>;
  eqy_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_raw_beta?: Maybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['numeric']>;
  eqy_split_dt?: Maybe<Scalars['date']>;
  eqy_split_ratio?: Maybe<Scalars['String']>;
  exposure?: Maybe<Scalars['numeric']>;
  insider_monthly_transaction?: Maybe<Scalars['String']>;
  long_short?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  onem_short_int_pct?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['numeric']>;
  px_close_1d?: Maybe<Scalars['numeric']>;
  px_close_1m?: Maybe<Scalars['numeric']>;
  px_close_1yr?: Maybe<Scalars['numeric']>;
  px_close_3m?: Maybe<Scalars['numeric']>;
  px_close_5d?: Maybe<Scalars['numeric']>;
  px_close_dt?: Maybe<Scalars['date']>;
  px_close_ytd?: Maybe<Scalars['numeric']>;
  px_high?: Maybe<Scalars['numeric']>;
  px_last?: Maybe<Scalars['numeric']>;
  px_last_eod?: Maybe<Scalars['numeric']>;
  px_low?: Maybe<Scalars['numeric']>;
  px_volume?: Maybe<Scalars['numeric']>;
  px_volume_1d?: Maybe<Scalars['numeric']>;
  security_typ?: Maybe<Scalars['String']>;
  short_int_date?: Maybe<Scalars['date']>;
  short_int_pct_chg?: Maybe<Scalars['numeric']>;
  si_percent_equity_float?: Maybe<Scalars['numeric']>;
  ticker?: Maybe<Scalars['String']>;
  ticker_and_exch_code?: Maybe<Scalars['String']>;
  volatility_10d?: Maybe<Scalars['numeric']>;
  volatility_30d?: Maybe<Scalars['numeric']>;
  volatility_30d_1d?: Maybe<Scalars['numeric']>;
  volatility_30d_1m?: Maybe<Scalars['numeric']>;
  volatility_30d_1w?: Maybe<Scalars['numeric']>;
  volatility_30d_3m?: Maybe<Scalars['numeric']>;
  volume_avg_1d?: Maybe<Scalars['numeric']>;
  volume_avg_3m?: Maybe<Scalars['numeric']>;
  volume_avg_5d?: Maybe<Scalars['numeric']>;
  volume_avg_6m?: Maybe<Scalars['numeric']>;
  volume_avg_30d?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "data3" */
export type Data3_Mutation_Response = {
  __typename?: 'data3_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Data3>;
};

/** input type for inserting object relation for remote table "data3" */
export type Data3_Obj_Rel_Insert_Input = {
  data: Data3_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Data3_On_Conflict>;
};

/** on_conflict condition type for table "data3" */
export type Data3_On_Conflict = {
  constraint: Data3_Constraint;
  update_columns?: Array<Data3_Update_Column>;
  where?: InputMaybe<Data3_Bool_Exp>;
};

/** Ordering options when selecting data from "data3". */
export type Data3_Order_By = {
  algo_30D_ST_MOMENTUM?: InputMaybe<Order_By>;
  algo_30D_ST_MOMENTUM_3D?: InputMaybe<Order_By>;
  algo_30D_ST_PRICE?: InputMaybe<Order_By>;
  algo_90D_MT_MOMENTUM?: InputMaybe<Order_By>;
  algo_90D_MT_PRICE?: InputMaybe<Order_By>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Order_By>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Order_By>;
  algo_CALC_TRADE_RANGE_HIGH?: InputMaybe<Order_By>;
  algo_CALC_TRADE_RANGE_LOW?: InputMaybe<Order_By>;
  algo_CALC_TRADE_RANGE_ODDS?: InputMaybe<Order_By>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Order_By>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Order_By>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Order_By>;
  algo_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Order_By>;
  algo_CurrImpVolDiscPrem?: InputMaybe<Order_By>;
  algo_CurrImpVolDiscPrem1D?: InputMaybe<Order_By>;
  algo_CurrImpVolDiscPrem7D?: InputMaybe<Order_By>;
  algo_CurrImpVolDiscPrem30D?: InputMaybe<Order_By>;
  algo_CurrImpVolDiscPrem90D?: InputMaybe<Order_By>;
  algo_IVOL_1WK_CHECK?: InputMaybe<Order_By>;
  algo_IVOL_SIGNAL?: InputMaybe<Order_By>;
  algo_daily_30D_ST_MOMENTUM?: InputMaybe<Order_By>;
  algo_daily_30D_ST_MOMENTUM_3D?: InputMaybe<Order_By>;
  algo_daily_30D_ST_PRICE?: InputMaybe<Order_By>;
  algo_daily_90D_MT_MOMENTUM?: InputMaybe<Order_By>;
  algo_daily_90D_MT_PRICE?: InputMaybe<Order_By>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Order_By>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADE_RANGE_LOW?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Order_By>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Order_By>;
  algo_daily_CurrImpVolDiscPrem?: InputMaybe<Order_By>;
  algo_daily_CurrImpVolDiscPrem1D?: InputMaybe<Order_By>;
  algo_daily_CurrImpVolDiscPrem7D?: InputMaybe<Order_By>;
  algo_daily_CurrImpVolDiscPrem30D?: InputMaybe<Order_By>;
  algo_daily_CurrImpVolDiscPrem90D?: InputMaybe<Order_By>;
  algo_daily_IVOL_1WK_CHECK?: InputMaybe<Order_By>;
  algo_daily_IVOL_3MO_CHECK?: InputMaybe<Order_By>;
  algo_daily_IVOL_SIGNAL?: InputMaybe<Order_By>;
  algo_daily_kiss_high?: InputMaybe<Order_By>;
  algo_daily_kiss_low?: InputMaybe<Order_By>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Order_By>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Order_By>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: InputMaybe<Order_By>;
  algo_eod_CALC_TRADE_RANGE_LOW?: InputMaybe<Order_By>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: InputMaybe<Order_By>;
  algo_eod_PX_LAST?: InputMaybe<Order_By>;
  calc_position_longbow_signal_strength?: InputMaybe<Order_By>;
  calc_realized_volatility_1m?: InputMaybe<Order_By>;
  calc_realized_volatility_1w?: InputMaybe<Order_By>;
  calc_realized_volatility_3m?: InputMaybe<Order_By>;
  calc_realized_volatility_current?: InputMaybe<Order_By>;
  calc_volume_1d?: InputMaybe<Order_By>;
  calc_volume_1m?: InputMaybe<Order_By>;
  calc_volume_3m?: InputMaybe<Order_By>;
  calc_volume_5d?: InputMaybe<Order_By>;
  cdr_country_code?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  crncy?: InputMaybe<Order_By>;
  current_trr_1d?: InputMaybe<Order_By>;
  current_trr_1mo?: InputMaybe<Order_By>;
  current_trr_3mo?: InputMaybe<Order_By>;
  current_trr_5d?: InputMaybe<Order_By>;
  current_trr_ytd?: InputMaybe<Order_By>;
  daily?: InputMaybe<Order_By>;
  entry_date?: InputMaybe<Order_By>;
  entry_price?: InputMaybe<Order_By>;
  eqy_beta?: InputMaybe<Order_By>;
  eqy_beta_6m?: InputMaybe<Order_By>;
  eqy_raw_beta?: InputMaybe<Order_By>;
  eqy_raw_beta_6m?: InputMaybe<Order_By>;
  eqy_split_adjustment_factor?: InputMaybe<Order_By>;
  eqy_split_dt?: InputMaybe<Order_By>;
  eqy_split_ratio?: InputMaybe<Order_By>;
  exposure?: InputMaybe<Order_By>;
  insider_monthly_transaction?: InputMaybe<Order_By>;
  long_short?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  onem_short_int_pct?: InputMaybe<Order_By>;
  put_imp_vol_30d?: InputMaybe<Order_By>;
  put_imp_vol_30d_1d?: InputMaybe<Order_By>;
  put_imp_vol_30d_1m?: InputMaybe<Order_By>;
  put_imp_vol_30d_1w?: InputMaybe<Order_By>;
  put_imp_vol_30d_3m?: InputMaybe<Order_By>;
  px_close_1d?: InputMaybe<Order_By>;
  px_close_1m?: InputMaybe<Order_By>;
  px_close_1yr?: InputMaybe<Order_By>;
  px_close_3m?: InputMaybe<Order_By>;
  px_close_5d?: InputMaybe<Order_By>;
  px_close_dt?: InputMaybe<Order_By>;
  px_close_ytd?: InputMaybe<Order_By>;
  px_high?: InputMaybe<Order_By>;
  px_last?: InputMaybe<Order_By>;
  px_last_eod?: InputMaybe<Order_By>;
  px_low?: InputMaybe<Order_By>;
  px_volume?: InputMaybe<Order_By>;
  px_volume_1d?: InputMaybe<Order_By>;
  red_current_trr_1d?: InputMaybe<Order_By>;
  red_current_trr_1mo?: InputMaybe<Order_By>;
  red_current_trr_3mo?: InputMaybe<Order_By>;
  red_current_trr_5d?: InputMaybe<Order_By>;
  red_current_trr_ytd?: InputMaybe<Order_By>;
  red_eqy_beta?: InputMaybe<Order_By>;
  red_eqy_beta_6m?: InputMaybe<Order_By>;
  red_eqy_raw_beta?: InputMaybe<Order_By>;
  red_eqy_raw_beta_6m?: InputMaybe<Order_By>;
  red_onem_short_int_pct?: InputMaybe<Order_By>;
  red_put_imp_vol_30d?: InputMaybe<Order_By>;
  red_px_close_1d?: InputMaybe<Order_By>;
  red_px_close_1m?: InputMaybe<Order_By>;
  red_px_close_1yr?: InputMaybe<Order_By>;
  red_px_close_3m?: InputMaybe<Order_By>;
  red_px_close_5d?: InputMaybe<Order_By>;
  red_px_close_ytd?: InputMaybe<Order_By>;
  red_px_high?: InputMaybe<Order_By>;
  red_px_last?: InputMaybe<Order_By>;
  red_px_last_eod?: InputMaybe<Order_By>;
  red_px_low?: InputMaybe<Order_By>;
  red_px_volume?: InputMaybe<Order_By>;
  red_px_volume_1d?: InputMaybe<Order_By>;
  red_short_int_pct_chg?: InputMaybe<Order_By>;
  red_si_percent_equity_float?: InputMaybe<Order_By>;
  red_volatility_10d?: InputMaybe<Order_By>;
  red_volatility_30d?: InputMaybe<Order_By>;
  red_volume_avg_3m?: InputMaybe<Order_By>;
  red_volume_avg_5d?: InputMaybe<Order_By>;
  red_volume_avg_6m?: InputMaybe<Order_By>;
  red_volume_avg_30d?: InputMaybe<Order_By>;
  security_typ?: InputMaybe<Order_By>;
  short_int_date?: InputMaybe<Order_By>;
  short_int_pct_chg?: InputMaybe<Order_By>;
  si_percent_equity_float?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  ticker_and_exch_code?: InputMaybe<Order_By>;
  volatility_10d?: InputMaybe<Order_By>;
  volatility_30d?: InputMaybe<Order_By>;
  volatility_30d_1d?: InputMaybe<Order_By>;
  volatility_30d_1m?: InputMaybe<Order_By>;
  volatility_30d_1w?: InputMaybe<Order_By>;
  volatility_30d_3m?: InputMaybe<Order_By>;
  volume_avg_1d?: InputMaybe<Order_By>;
  volume_avg_3m?: InputMaybe<Order_By>;
  volume_avg_5d?: InputMaybe<Order_By>;
  volume_avg_6m?: InputMaybe<Order_By>;
  volume_avg_30d?: InputMaybe<Order_By>;
};

/** primary key columns input for table: data3 */
export type Data3_Pk_Columns_Input = {
  ticker: Scalars['String'];
};

/** select columns of table "data3" */
export enum Data3_Select_Column {
  /** column name */
  Algo_30DStMomentum = 'algo_30D_ST_MOMENTUM',
  /** column name */
  Algo_30DStMomentum_3D = 'algo_30D_ST_MOMENTUM_3D',
  /** column name */
  Algo_30DStPrice = 'algo_30D_ST_PRICE',
  /** column name */
  Algo_90DMtMomentum = 'algo_90D_MT_MOMENTUM',
  /** column name */
  Algo_90DMtPrice = 'algo_90D_MT_PRICE',
  /** column name */
  AlgoCalcPositionLongbowSignal = 'algo_CALC_POSITION_LONGBOW_SIGNAL',
  /** column name */
  AlgoCalcPositionLongbowSignalStrength = 'algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH',
  /** column name */
  AlgoCalcTradeRangeHigh = 'algo_CALC_TRADE_RANGE_HIGH',
  /** column name */
  AlgoCalcTradeRangeLow = 'algo_CALC_TRADE_RANGE_LOW',
  /** column name */
  AlgoCalcTradeRangeOdds = 'algo_CALC_TRADE_RANGE_ODDS',
  /** column name */
  AlgoCalcTradeRangePercentHigh = 'algo_CALC_TRADE_RANGE_PERCENT_HIGH',
  /** column name */
  AlgoCalcTradeRangePercentLow = 'algo_CALC_TRADE_RANGE_PERCENT_LOW',
  /** column name */
  AlgoCalcTradingRangeAsymmetry = 'algo_CALC_TRADING_RANGE_ASYMMETRY',
  /** column name */
  AlgoCalcTradingRangeSignal = 'algo_CALC_TRADING_RANGE_SIGNAL',
  /** column name */
  AlgoCurrImpVolDiscPrem = 'algo_CurrImpVolDiscPrem',
  /** column name */
  AlgoCurrImpVolDiscPrem1D = 'algo_CurrImpVolDiscPrem1D',
  /** column name */
  AlgoCurrImpVolDiscPrem7D = 'algo_CurrImpVolDiscPrem7D',
  /** column name */
  AlgoCurrImpVolDiscPrem30D = 'algo_CurrImpVolDiscPrem30D',
  /** column name */
  AlgoCurrImpVolDiscPrem90D = 'algo_CurrImpVolDiscPrem90D',
  /** column name */
  AlgoIvol_1WkCheck = 'algo_IVOL_1WK_CHECK',
  /** column name */
  AlgoIvolSignal = 'algo_IVOL_SIGNAL',
  /** column name */
  AlgoDaily_30DStMomentum = 'algo_daily_30D_ST_MOMENTUM',
  /** column name */
  AlgoDaily_30DStMomentum_3D = 'algo_daily_30D_ST_MOMENTUM_3D',
  /** column name */
  AlgoDaily_30DStPrice = 'algo_daily_30D_ST_PRICE',
  /** column name */
  AlgoDaily_90DMtMomentum = 'algo_daily_90D_MT_MOMENTUM',
  /** column name */
  AlgoDaily_90DMtPrice = 'algo_daily_90D_MT_PRICE',
  /** column name */
  AlgoDailyCalcPositionLongbowSignal = 'algo_daily_CALC_POSITION_LONGBOW_SIGNAL',
  /** column name */
  AlgoDailyCalcPositionLongbowSignalStrength = 'algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH',
  /** column name */
  AlgoDailyCalcTradeRangeHigh = 'algo_daily_CALC_TRADE_RANGE_HIGH',
  /** column name */
  AlgoDailyCalcTradeRangeLow = 'algo_daily_CALC_TRADE_RANGE_LOW',
  /** column name */
  AlgoDailyCalcTradeRangeOdds = 'algo_daily_CALC_TRADE_RANGE_ODDS',
  /** column name */
  AlgoDailyCalcTradeRangePercentHigh = 'algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH',
  /** column name */
  AlgoDailyCalcTradeRangePercentLow = 'algo_daily_CALC_TRADE_RANGE_PERCENT_LOW',
  /** column name */
  AlgoDailyCalcTradingRangeAsymmetry = 'algo_daily_CALC_TRADING_RANGE_ASYMMETRY',
  /** column name */
  AlgoDailyCalcTradingRangeSignal = 'algo_daily_CALC_TRADING_RANGE_SIGNAL',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem = 'algo_daily_CurrImpVolDiscPrem',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem1D = 'algo_daily_CurrImpVolDiscPrem1D',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem7D = 'algo_daily_CurrImpVolDiscPrem7D',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem30D = 'algo_daily_CurrImpVolDiscPrem30D',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem90D = 'algo_daily_CurrImpVolDiscPrem90D',
  /** column name */
  AlgoDailyIvol_1WkCheck = 'algo_daily_IVOL_1WK_CHECK',
  /** column name */
  AlgoDailyIvol_3MoCheck = 'algo_daily_IVOL_3MO_CHECK',
  /** column name */
  AlgoDailyIvolSignal = 'algo_daily_IVOL_SIGNAL',
  /** column name */
  AlgoDailyKissHigh = 'algo_daily_kiss_high',
  /** column name */
  AlgoDailyKissLow = 'algo_daily_kiss_low',
  /** column name */
  AlgoEodCalcPositionLongbowSignal = 'algo_eod_CALC_POSITION_LONGBOW_SIGNAL',
  /** column name */
  AlgoEodCalcPositionLongbowSignalStrength = 'algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH',
  /** column name */
  AlgoEodCalcTradeRangeHigh = 'algo_eod_CALC_TRADE_RANGE_HIGH',
  /** column name */
  AlgoEodCalcTradeRangeLow = 'algo_eod_CALC_TRADE_RANGE_LOW',
  /** column name */
  AlgoEodCalcTradeRangeOdds = 'algo_eod_CALC_TRADE_RANGE_ODDS',
  /** column name */
  AlgoEodPxLast = 'algo_eod_PX_LAST',
  /** column name */
  CalcPositionLongbowSignalStrength = 'calc_position_longbow_signal_strength',
  /** column name */
  CalcRealizedVolatility_1m = 'calc_realized_volatility_1m',
  /** column name */
  CalcRealizedVolatility_1w = 'calc_realized_volatility_1w',
  /** column name */
  CalcRealizedVolatility_3m = 'calc_realized_volatility_3m',
  /** column name */
  CalcRealizedVolatilityCurrent = 'calc_realized_volatility_current',
  /** column name */
  CalcVolume_1d = 'calc_volume_1d',
  /** column name */
  CalcVolume_1m = 'calc_volume_1m',
  /** column name */
  CalcVolume_3m = 'calc_volume_3m',
  /** column name */
  CalcVolume_5d = 'calc_volume_5d',
  /** column name */
  CdrCountryCode = 'cdr_country_code',
  /** column name */
  Country = 'country',
  /** column name */
  Crncy = 'crncy',
  /** column name */
  CurrentTrr_1d = 'current_trr_1d',
  /** column name */
  CurrentTrr_1mo = 'current_trr_1mo',
  /** column name */
  CurrentTrr_3mo = 'current_trr_3mo',
  /** column name */
  CurrentTrr_5d = 'current_trr_5d',
  /** column name */
  CurrentTrrYtd = 'current_trr_ytd',
  /** column name */
  Daily = 'daily',
  /** column name */
  EntryDate = 'entry_date',
  /** column name */
  EntryPrice = 'entry_price',
  /** column name */
  EqyBeta = 'eqy_beta',
  /** column name */
  EqyBeta_6m = 'eqy_beta_6m',
  /** column name */
  EqyRawBeta = 'eqy_raw_beta',
  /** column name */
  EqyRawBeta_6m = 'eqy_raw_beta_6m',
  /** column name */
  EqySplitAdjustmentFactor = 'eqy_split_adjustment_factor',
  /** column name */
  EqySplitDt = 'eqy_split_dt',
  /** column name */
  EqySplitRatio = 'eqy_split_ratio',
  /** column name */
  Exposure = 'exposure',
  /** column name */
  InsiderMonthlyTransaction = 'insider_monthly_transaction',
  /** column name */
  LongShort = 'long_short',
  /** column name */
  Name = 'name',
  /** column name */
  OnemShortIntPct = 'onem_short_int_pct',
  /** column name */
  PutImpVol_30d = 'put_imp_vol_30d',
  /** column name */
  PutImpVol_30d_1d = 'put_imp_vol_30d_1d',
  /** column name */
  PutImpVol_30d_1m = 'put_imp_vol_30d_1m',
  /** column name */
  PutImpVol_30d_1w = 'put_imp_vol_30d_1w',
  /** column name */
  PutImpVol_30d_3m = 'put_imp_vol_30d_3m',
  /** column name */
  PxClose_1d = 'px_close_1d',
  /** column name */
  PxClose_1m = 'px_close_1m',
  /** column name */
  PxClose_1yr = 'px_close_1yr',
  /** column name */
  PxClose_3m = 'px_close_3m',
  /** column name */
  PxClose_5d = 'px_close_5d',
  /** column name */
  PxCloseDt = 'px_close_dt',
  /** column name */
  PxCloseYtd = 'px_close_ytd',
  /** column name */
  PxHigh = 'px_high',
  /** column name */
  PxLast = 'px_last',
  /** column name */
  PxLastEod = 'px_last_eod',
  /** column name */
  PxLow = 'px_low',
  /** column name */
  PxVolume = 'px_volume',
  /** column name */
  PxVolume_1d = 'px_volume_1d',
  /** column name */
  RedCurrentTrr_1d = 'red_current_trr_1d',
  /** column name */
  RedCurrentTrr_1mo = 'red_current_trr_1mo',
  /** column name */
  RedCurrentTrr_3mo = 'red_current_trr_3mo',
  /** column name */
  RedCurrentTrr_5d = 'red_current_trr_5d',
  /** column name */
  RedCurrentTrrYtd = 'red_current_trr_ytd',
  /** column name */
  RedEqyBeta = 'red_eqy_beta',
  /** column name */
  RedEqyBeta_6m = 'red_eqy_beta_6m',
  /** column name */
  RedEqyRawBeta = 'red_eqy_raw_beta',
  /** column name */
  RedEqyRawBeta_6m = 'red_eqy_raw_beta_6m',
  /** column name */
  RedOnemShortIntPct = 'red_onem_short_int_pct',
  /** column name */
  RedPutImpVol_30d = 'red_put_imp_vol_30d',
  /** column name */
  RedPxClose_1d = 'red_px_close_1d',
  /** column name */
  RedPxClose_1m = 'red_px_close_1m',
  /** column name */
  RedPxClose_1yr = 'red_px_close_1yr',
  /** column name */
  RedPxClose_3m = 'red_px_close_3m',
  /** column name */
  RedPxClose_5d = 'red_px_close_5d',
  /** column name */
  RedPxCloseYtd = 'red_px_close_ytd',
  /** column name */
  RedPxHigh = 'red_px_high',
  /** column name */
  RedPxLast = 'red_px_last',
  /** column name */
  RedPxLastEod = 'red_px_last_eod',
  /** column name */
  RedPxLow = 'red_px_low',
  /** column name */
  RedPxVolume = 'red_px_volume',
  /** column name */
  RedPxVolume_1d = 'red_px_volume_1d',
  /** column name */
  RedShortIntPctChg = 'red_short_int_pct_chg',
  /** column name */
  RedSiPercentEquityFloat = 'red_si_percent_equity_float',
  /** column name */
  RedVolatility_10d = 'red_volatility_10d',
  /** column name */
  RedVolatility_30d = 'red_volatility_30d',
  /** column name */
  RedVolumeAvg_3m = 'red_volume_avg_3m',
  /** column name */
  RedVolumeAvg_5d = 'red_volume_avg_5d',
  /** column name */
  RedVolumeAvg_6m = 'red_volume_avg_6m',
  /** column name */
  RedVolumeAvg_30d = 'red_volume_avg_30d',
  /** column name */
  SecurityTyp = 'security_typ',
  /** column name */
  ShortIntDate = 'short_int_date',
  /** column name */
  ShortIntPctChg = 'short_int_pct_chg',
  /** column name */
  SiPercentEquityFloat = 'si_percent_equity_float',
  /** column name */
  Ticker = 'ticker',
  /** column name */
  TickerAndExchCode = 'ticker_and_exch_code',
  /** column name */
  Volatility_10d = 'volatility_10d',
  /** column name */
  Volatility_30d = 'volatility_30d',
  /** column name */
  Volatility_30d_1d = 'volatility_30d_1d',
  /** column name */
  Volatility_30d_1m = 'volatility_30d_1m',
  /** column name */
  Volatility_30d_1w = 'volatility_30d_1w',
  /** column name */
  Volatility_30d_3m = 'volatility_30d_3m',
  /** column name */
  VolumeAvg_1d = 'volume_avg_1d',
  /** column name */
  VolumeAvg_3m = 'volume_avg_3m',
  /** column name */
  VolumeAvg_5d = 'volume_avg_5d',
  /** column name */
  VolumeAvg_6m = 'volume_avg_6m',
  /** column name */
  VolumeAvg_30d = 'volume_avg_30d'
}

/** input type for updating data in table "data3" */
export type Data3_Set_Input = {
  algo_30D_ST_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_30D_ST_MOMENTUM_3D?: InputMaybe<Scalars['String']>;
  algo_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_90D_MT_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_IVOL_1WK_CHECK?: InputMaybe<Scalars['String']>;
  algo_IVOL_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM_3D?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_90D_MT_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_daily_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_daily_IVOL_1WK_CHECK?: InputMaybe<Scalars['String']>;
  algo_daily_IVOL_3MO_CHECK?: InputMaybe<Scalars['String']>;
  algo_daily_IVOL_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_kiss_high?: InputMaybe<Scalars['String']>;
  algo_daily_kiss_low?: InputMaybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: InputMaybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_current?: InputMaybe<Scalars['numeric']>;
  calc_volume_1d?: InputMaybe<Scalars['numeric']>;
  calc_volume_1m?: InputMaybe<Scalars['numeric']>;
  calc_volume_3m?: InputMaybe<Scalars['numeric']>;
  calc_volume_5d?: InputMaybe<Scalars['numeric']>;
  cdr_country_code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  crncy?: InputMaybe<Scalars['String']>;
  current_trr_1d?: InputMaybe<Scalars['numeric']>;
  current_trr_1mo?: InputMaybe<Scalars['numeric']>;
  current_trr_3mo?: InputMaybe<Scalars['numeric']>;
  current_trr_5d?: InputMaybe<Scalars['numeric']>;
  current_trr_ytd?: InputMaybe<Scalars['numeric']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  entry_date?: InputMaybe<Scalars['String']>;
  entry_price?: InputMaybe<Scalars['numeric']>;
  eqy_beta?: InputMaybe<Scalars['numeric']>;
  eqy_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: InputMaybe<Scalars['numeric']>;
  eqy_split_dt?: InputMaybe<Scalars['date']>;
  eqy_split_ratio?: InputMaybe<Scalars['String']>;
  exposure?: InputMaybe<Scalars['numeric']>;
  insider_monthly_transaction?: InputMaybe<Scalars['String']>;
  long_short?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  onem_short_int_pct?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: InputMaybe<Scalars['numeric']>;
  px_close_1d?: InputMaybe<Scalars['numeric']>;
  px_close_1m?: InputMaybe<Scalars['numeric']>;
  px_close_1yr?: InputMaybe<Scalars['numeric']>;
  px_close_3m?: InputMaybe<Scalars['numeric']>;
  px_close_5d?: InputMaybe<Scalars['numeric']>;
  px_close_dt?: InputMaybe<Scalars['date']>;
  px_close_ytd?: InputMaybe<Scalars['numeric']>;
  px_high?: InputMaybe<Scalars['numeric']>;
  px_last?: InputMaybe<Scalars['numeric']>;
  px_last_eod?: InputMaybe<Scalars['numeric']>;
  px_low?: InputMaybe<Scalars['numeric']>;
  px_volume?: InputMaybe<Scalars['numeric']>;
  px_volume_1d?: InputMaybe<Scalars['numeric']>;
  red_current_trr_1d?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_1mo?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_3mo?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_5d?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_ytd?: InputMaybe<Scalars['Boolean']>;
  red_eqy_beta?: InputMaybe<Scalars['Boolean']>;
  red_eqy_beta_6m?: InputMaybe<Scalars['Boolean']>;
  red_eqy_raw_beta?: InputMaybe<Scalars['Boolean']>;
  red_eqy_raw_beta_6m?: InputMaybe<Scalars['Boolean']>;
  red_onem_short_int_pct?: InputMaybe<Scalars['Boolean']>;
  red_put_imp_vol_30d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1m?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1yr?: InputMaybe<Scalars['Boolean']>;
  red_px_close_3m?: InputMaybe<Scalars['Boolean']>;
  red_px_close_5d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_ytd?: InputMaybe<Scalars['Boolean']>;
  red_px_high?: InputMaybe<Scalars['Boolean']>;
  red_px_last?: InputMaybe<Scalars['Boolean']>;
  red_px_last_eod?: InputMaybe<Scalars['Boolean']>;
  red_px_low?: InputMaybe<Scalars['Boolean']>;
  red_px_volume?: InputMaybe<Scalars['Boolean']>;
  red_px_volume_1d?: InputMaybe<Scalars['Boolean']>;
  red_short_int_pct_chg?: InputMaybe<Scalars['Boolean']>;
  red_si_percent_equity_float?: InputMaybe<Scalars['Boolean']>;
  red_volatility_10d?: InputMaybe<Scalars['Boolean']>;
  red_volatility_30d?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_3m?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_5d?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_6m?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_30d?: InputMaybe<Scalars['Boolean']>;
  security_typ?: InputMaybe<Scalars['String']>;
  short_int_date?: InputMaybe<Scalars['date']>;
  short_int_pct_chg?: InputMaybe<Scalars['numeric']>;
  si_percent_equity_float?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  ticker_and_exch_code?: InputMaybe<Scalars['String']>;
  volatility_10d?: InputMaybe<Scalars['numeric']>;
  volatility_30d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1m?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1w?: InputMaybe<Scalars['numeric']>;
  volatility_30d_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_1d?: InputMaybe<Scalars['numeric']>;
  volume_avg_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_5d?: InputMaybe<Scalars['numeric']>;
  volume_avg_6m?: InputMaybe<Scalars['numeric']>;
  volume_avg_30d?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Data3_Stddev_Fields = {
  __typename?: 'data3_stddev_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Data3_Stddev_Pop_Fields = {
  __typename?: 'data3_stddev_pop_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Data3_Stddev_Samp_Fields = {
  __typename?: 'data3_stddev_samp_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "data3" */
export type Data3_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Data3_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Data3_Stream_Cursor_Value_Input = {
  algo_30D_ST_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_30D_ST_MOMENTUM_3D?: InputMaybe<Scalars['String']>;
  algo_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_90D_MT_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Scalars['String']>;
  algo_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_IVOL_1WK_CHECK?: InputMaybe<Scalars['String']>;
  algo_IVOL_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_MOMENTUM_3D?: InputMaybe<Scalars['String']>;
  algo_daily_30D_ST_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_90D_MT_MOMENTUM?: InputMaybe<Scalars['String']>;
  algo_daily_90D_MT_PRICE?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADE_RANGE_PERCENT_LOW?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_ASYMMETRY?: InputMaybe<Scalars['String']>;
  algo_daily_CALC_TRADING_RANGE_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_CurrImpVolDiscPrem?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: InputMaybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: InputMaybe<Scalars['numeric']>;
  algo_daily_IVOL_1WK_CHECK?: InputMaybe<Scalars['String']>;
  algo_daily_IVOL_3MO_CHECK?: InputMaybe<Scalars['String']>;
  algo_daily_IVOL_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_daily_kiss_high?: InputMaybe<Scalars['String']>;
  algo_daily_kiss_low?: InputMaybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL?: InputMaybe<Scalars['String']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: InputMaybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: InputMaybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: InputMaybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: InputMaybe<Scalars['numeric']>;
  calc_realized_volatility_current?: InputMaybe<Scalars['numeric']>;
  calc_volume_1d?: InputMaybe<Scalars['numeric']>;
  calc_volume_1m?: InputMaybe<Scalars['numeric']>;
  calc_volume_3m?: InputMaybe<Scalars['numeric']>;
  calc_volume_5d?: InputMaybe<Scalars['numeric']>;
  cdr_country_code?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  crncy?: InputMaybe<Scalars['String']>;
  current_trr_1d?: InputMaybe<Scalars['numeric']>;
  current_trr_1mo?: InputMaybe<Scalars['numeric']>;
  current_trr_3mo?: InputMaybe<Scalars['numeric']>;
  current_trr_5d?: InputMaybe<Scalars['numeric']>;
  current_trr_ytd?: InputMaybe<Scalars['numeric']>;
  daily?: InputMaybe<Scalars['Boolean']>;
  entry_date?: InputMaybe<Scalars['String']>;
  entry_price?: InputMaybe<Scalars['numeric']>;
  eqy_beta?: InputMaybe<Scalars['numeric']>;
  eqy_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta?: InputMaybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: InputMaybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: InputMaybe<Scalars['numeric']>;
  eqy_split_dt?: InputMaybe<Scalars['date']>;
  eqy_split_ratio?: InputMaybe<Scalars['String']>;
  exposure?: InputMaybe<Scalars['numeric']>;
  insider_monthly_transaction?: InputMaybe<Scalars['String']>;
  long_short?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  onem_short_int_pct?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: InputMaybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: InputMaybe<Scalars['numeric']>;
  px_close_1d?: InputMaybe<Scalars['numeric']>;
  px_close_1m?: InputMaybe<Scalars['numeric']>;
  px_close_1yr?: InputMaybe<Scalars['numeric']>;
  px_close_3m?: InputMaybe<Scalars['numeric']>;
  px_close_5d?: InputMaybe<Scalars['numeric']>;
  px_close_dt?: InputMaybe<Scalars['date']>;
  px_close_ytd?: InputMaybe<Scalars['numeric']>;
  px_high?: InputMaybe<Scalars['numeric']>;
  px_last?: InputMaybe<Scalars['numeric']>;
  px_last_eod?: InputMaybe<Scalars['numeric']>;
  px_low?: InputMaybe<Scalars['numeric']>;
  px_volume?: InputMaybe<Scalars['numeric']>;
  px_volume_1d?: InputMaybe<Scalars['numeric']>;
  red_current_trr_1d?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_1mo?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_3mo?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_5d?: InputMaybe<Scalars['Boolean']>;
  red_current_trr_ytd?: InputMaybe<Scalars['Boolean']>;
  red_eqy_beta?: InputMaybe<Scalars['Boolean']>;
  red_eqy_beta_6m?: InputMaybe<Scalars['Boolean']>;
  red_eqy_raw_beta?: InputMaybe<Scalars['Boolean']>;
  red_eqy_raw_beta_6m?: InputMaybe<Scalars['Boolean']>;
  red_onem_short_int_pct?: InputMaybe<Scalars['Boolean']>;
  red_put_imp_vol_30d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1m?: InputMaybe<Scalars['Boolean']>;
  red_px_close_1yr?: InputMaybe<Scalars['Boolean']>;
  red_px_close_3m?: InputMaybe<Scalars['Boolean']>;
  red_px_close_5d?: InputMaybe<Scalars['Boolean']>;
  red_px_close_ytd?: InputMaybe<Scalars['Boolean']>;
  red_px_high?: InputMaybe<Scalars['Boolean']>;
  red_px_last?: InputMaybe<Scalars['Boolean']>;
  red_px_last_eod?: InputMaybe<Scalars['Boolean']>;
  red_px_low?: InputMaybe<Scalars['Boolean']>;
  red_px_volume?: InputMaybe<Scalars['Boolean']>;
  red_px_volume_1d?: InputMaybe<Scalars['Boolean']>;
  red_short_int_pct_chg?: InputMaybe<Scalars['Boolean']>;
  red_si_percent_equity_float?: InputMaybe<Scalars['Boolean']>;
  red_volatility_10d?: InputMaybe<Scalars['Boolean']>;
  red_volatility_30d?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_3m?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_5d?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_6m?: InputMaybe<Scalars['Boolean']>;
  red_volume_avg_30d?: InputMaybe<Scalars['Boolean']>;
  security_typ?: InputMaybe<Scalars['String']>;
  short_int_date?: InputMaybe<Scalars['date']>;
  short_int_pct_chg?: InputMaybe<Scalars['numeric']>;
  si_percent_equity_float?: InputMaybe<Scalars['numeric']>;
  ticker?: InputMaybe<Scalars['String']>;
  ticker_and_exch_code?: InputMaybe<Scalars['String']>;
  volatility_10d?: InputMaybe<Scalars['numeric']>;
  volatility_30d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1d?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1m?: InputMaybe<Scalars['numeric']>;
  volatility_30d_1w?: InputMaybe<Scalars['numeric']>;
  volatility_30d_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_1d?: InputMaybe<Scalars['numeric']>;
  volume_avg_3m?: InputMaybe<Scalars['numeric']>;
  volume_avg_5d?: InputMaybe<Scalars['numeric']>;
  volume_avg_6m?: InputMaybe<Scalars['numeric']>;
  volume_avg_30d?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Data3_Sum_Fields = {
  __typename?: 'data3_sum_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['numeric']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['numeric']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['numeric']>;
  algo_eod_PX_LAST?: Maybe<Scalars['numeric']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_1w?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_3m?: Maybe<Scalars['numeric']>;
  calc_realized_volatility_current?: Maybe<Scalars['numeric']>;
  calc_volume_1d?: Maybe<Scalars['numeric']>;
  calc_volume_1m?: Maybe<Scalars['numeric']>;
  calc_volume_3m?: Maybe<Scalars['numeric']>;
  calc_volume_5d?: Maybe<Scalars['numeric']>;
  current_trr_1d?: Maybe<Scalars['numeric']>;
  current_trr_1mo?: Maybe<Scalars['numeric']>;
  current_trr_3mo?: Maybe<Scalars['numeric']>;
  current_trr_5d?: Maybe<Scalars['numeric']>;
  current_trr_ytd?: Maybe<Scalars['numeric']>;
  entry_price?: Maybe<Scalars['numeric']>;
  eqy_beta?: Maybe<Scalars['numeric']>;
  eqy_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_raw_beta?: Maybe<Scalars['numeric']>;
  eqy_raw_beta_6m?: Maybe<Scalars['numeric']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['numeric']>;
  exposure?: Maybe<Scalars['numeric']>;
  onem_short_int_pct?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['numeric']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['numeric']>;
  px_close_1d?: Maybe<Scalars['numeric']>;
  px_close_1m?: Maybe<Scalars['numeric']>;
  px_close_1yr?: Maybe<Scalars['numeric']>;
  px_close_3m?: Maybe<Scalars['numeric']>;
  px_close_5d?: Maybe<Scalars['numeric']>;
  px_close_ytd?: Maybe<Scalars['numeric']>;
  px_high?: Maybe<Scalars['numeric']>;
  px_last?: Maybe<Scalars['numeric']>;
  px_last_eod?: Maybe<Scalars['numeric']>;
  px_low?: Maybe<Scalars['numeric']>;
  px_volume?: Maybe<Scalars['numeric']>;
  px_volume_1d?: Maybe<Scalars['numeric']>;
  short_int_pct_chg?: Maybe<Scalars['numeric']>;
  si_percent_equity_float?: Maybe<Scalars['numeric']>;
  volatility_10d?: Maybe<Scalars['numeric']>;
  volatility_30d?: Maybe<Scalars['numeric']>;
  volatility_30d_1d?: Maybe<Scalars['numeric']>;
  volatility_30d_1m?: Maybe<Scalars['numeric']>;
  volatility_30d_1w?: Maybe<Scalars['numeric']>;
  volatility_30d_3m?: Maybe<Scalars['numeric']>;
  volume_avg_1d?: Maybe<Scalars['numeric']>;
  volume_avg_3m?: Maybe<Scalars['numeric']>;
  volume_avg_5d?: Maybe<Scalars['numeric']>;
  volume_avg_6m?: Maybe<Scalars['numeric']>;
  volume_avg_30d?: Maybe<Scalars['numeric']>;
};

/** update columns of table "data3" */
export enum Data3_Update_Column {
  /** column name */
  Algo_30DStMomentum = 'algo_30D_ST_MOMENTUM',
  /** column name */
  Algo_30DStMomentum_3D = 'algo_30D_ST_MOMENTUM_3D',
  /** column name */
  Algo_30DStPrice = 'algo_30D_ST_PRICE',
  /** column name */
  Algo_90DMtMomentum = 'algo_90D_MT_MOMENTUM',
  /** column name */
  Algo_90DMtPrice = 'algo_90D_MT_PRICE',
  /** column name */
  AlgoCalcPositionLongbowSignal = 'algo_CALC_POSITION_LONGBOW_SIGNAL',
  /** column name */
  AlgoCalcPositionLongbowSignalStrength = 'algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH',
  /** column name */
  AlgoCalcTradeRangeHigh = 'algo_CALC_TRADE_RANGE_HIGH',
  /** column name */
  AlgoCalcTradeRangeLow = 'algo_CALC_TRADE_RANGE_LOW',
  /** column name */
  AlgoCalcTradeRangeOdds = 'algo_CALC_TRADE_RANGE_ODDS',
  /** column name */
  AlgoCalcTradeRangePercentHigh = 'algo_CALC_TRADE_RANGE_PERCENT_HIGH',
  /** column name */
  AlgoCalcTradeRangePercentLow = 'algo_CALC_TRADE_RANGE_PERCENT_LOW',
  /** column name */
  AlgoCalcTradingRangeAsymmetry = 'algo_CALC_TRADING_RANGE_ASYMMETRY',
  /** column name */
  AlgoCalcTradingRangeSignal = 'algo_CALC_TRADING_RANGE_SIGNAL',
  /** column name */
  AlgoCurrImpVolDiscPrem = 'algo_CurrImpVolDiscPrem',
  /** column name */
  AlgoCurrImpVolDiscPrem1D = 'algo_CurrImpVolDiscPrem1D',
  /** column name */
  AlgoCurrImpVolDiscPrem7D = 'algo_CurrImpVolDiscPrem7D',
  /** column name */
  AlgoCurrImpVolDiscPrem30D = 'algo_CurrImpVolDiscPrem30D',
  /** column name */
  AlgoCurrImpVolDiscPrem90D = 'algo_CurrImpVolDiscPrem90D',
  /** column name */
  AlgoIvol_1WkCheck = 'algo_IVOL_1WK_CHECK',
  /** column name */
  AlgoIvolSignal = 'algo_IVOL_SIGNAL',
  /** column name */
  AlgoDaily_30DStMomentum = 'algo_daily_30D_ST_MOMENTUM',
  /** column name */
  AlgoDaily_30DStMomentum_3D = 'algo_daily_30D_ST_MOMENTUM_3D',
  /** column name */
  AlgoDaily_30DStPrice = 'algo_daily_30D_ST_PRICE',
  /** column name */
  AlgoDaily_90DMtMomentum = 'algo_daily_90D_MT_MOMENTUM',
  /** column name */
  AlgoDaily_90DMtPrice = 'algo_daily_90D_MT_PRICE',
  /** column name */
  AlgoDailyCalcPositionLongbowSignal = 'algo_daily_CALC_POSITION_LONGBOW_SIGNAL',
  /** column name */
  AlgoDailyCalcPositionLongbowSignalStrength = 'algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH',
  /** column name */
  AlgoDailyCalcTradeRangeHigh = 'algo_daily_CALC_TRADE_RANGE_HIGH',
  /** column name */
  AlgoDailyCalcTradeRangeLow = 'algo_daily_CALC_TRADE_RANGE_LOW',
  /** column name */
  AlgoDailyCalcTradeRangeOdds = 'algo_daily_CALC_TRADE_RANGE_ODDS',
  /** column name */
  AlgoDailyCalcTradeRangePercentHigh = 'algo_daily_CALC_TRADE_RANGE_PERCENT_HIGH',
  /** column name */
  AlgoDailyCalcTradeRangePercentLow = 'algo_daily_CALC_TRADE_RANGE_PERCENT_LOW',
  /** column name */
  AlgoDailyCalcTradingRangeAsymmetry = 'algo_daily_CALC_TRADING_RANGE_ASYMMETRY',
  /** column name */
  AlgoDailyCalcTradingRangeSignal = 'algo_daily_CALC_TRADING_RANGE_SIGNAL',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem = 'algo_daily_CurrImpVolDiscPrem',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem1D = 'algo_daily_CurrImpVolDiscPrem1D',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem7D = 'algo_daily_CurrImpVolDiscPrem7D',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem30D = 'algo_daily_CurrImpVolDiscPrem30D',
  /** column name */
  AlgoDailyCurrImpVolDiscPrem90D = 'algo_daily_CurrImpVolDiscPrem90D',
  /** column name */
  AlgoDailyIvol_1WkCheck = 'algo_daily_IVOL_1WK_CHECK',
  /** column name */
  AlgoDailyIvol_3MoCheck = 'algo_daily_IVOL_3MO_CHECK',
  /** column name */
  AlgoDailyIvolSignal = 'algo_daily_IVOL_SIGNAL',
  /** column name */
  AlgoDailyKissHigh = 'algo_daily_kiss_high',
  /** column name */
  AlgoDailyKissLow = 'algo_daily_kiss_low',
  /** column name */
  AlgoEodCalcPositionLongbowSignal = 'algo_eod_CALC_POSITION_LONGBOW_SIGNAL',
  /** column name */
  AlgoEodCalcPositionLongbowSignalStrength = 'algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH',
  /** column name */
  AlgoEodCalcTradeRangeHigh = 'algo_eod_CALC_TRADE_RANGE_HIGH',
  /** column name */
  AlgoEodCalcTradeRangeLow = 'algo_eod_CALC_TRADE_RANGE_LOW',
  /** column name */
  AlgoEodCalcTradeRangeOdds = 'algo_eod_CALC_TRADE_RANGE_ODDS',
  /** column name */
  AlgoEodPxLast = 'algo_eod_PX_LAST',
  /** column name */
  CalcPositionLongbowSignalStrength = 'calc_position_longbow_signal_strength',
  /** column name */
  CalcRealizedVolatility_1m = 'calc_realized_volatility_1m',
  /** column name */
  CalcRealizedVolatility_1w = 'calc_realized_volatility_1w',
  /** column name */
  CalcRealizedVolatility_3m = 'calc_realized_volatility_3m',
  /** column name */
  CalcRealizedVolatilityCurrent = 'calc_realized_volatility_current',
  /** column name */
  CalcVolume_1d = 'calc_volume_1d',
  /** column name */
  CalcVolume_1m = 'calc_volume_1m',
  /** column name */
  CalcVolume_3m = 'calc_volume_3m',
  /** column name */
  CalcVolume_5d = 'calc_volume_5d',
  /** column name */
  CdrCountryCode = 'cdr_country_code',
  /** column name */
  Country = 'country',
  /** column name */
  Crncy = 'crncy',
  /** column name */
  CurrentTrr_1d = 'current_trr_1d',
  /** column name */
  CurrentTrr_1mo = 'current_trr_1mo',
  /** column name */
  CurrentTrr_3mo = 'current_trr_3mo',
  /** column name */
  CurrentTrr_5d = 'current_trr_5d',
  /** column name */
  CurrentTrrYtd = 'current_trr_ytd',
  /** column name */
  Daily = 'daily',
  /** column name */
  EntryDate = 'entry_date',
  /** column name */
  EntryPrice = 'entry_price',
  /** column name */
  EqyBeta = 'eqy_beta',
  /** column name */
  EqyBeta_6m = 'eqy_beta_6m',
  /** column name */
  EqyRawBeta = 'eqy_raw_beta',
  /** column name */
  EqyRawBeta_6m = 'eqy_raw_beta_6m',
  /** column name */
  EqySplitAdjustmentFactor = 'eqy_split_adjustment_factor',
  /** column name */
  EqySplitDt = 'eqy_split_dt',
  /** column name */
  EqySplitRatio = 'eqy_split_ratio',
  /** column name */
  Exposure = 'exposure',
  /** column name */
  InsiderMonthlyTransaction = 'insider_monthly_transaction',
  /** column name */
  LongShort = 'long_short',
  /** column name */
  Name = 'name',
  /** column name */
  OnemShortIntPct = 'onem_short_int_pct',
  /** column name */
  PutImpVol_30d = 'put_imp_vol_30d',
  /** column name */
  PutImpVol_30d_1d = 'put_imp_vol_30d_1d',
  /** column name */
  PutImpVol_30d_1m = 'put_imp_vol_30d_1m',
  /** column name */
  PutImpVol_30d_1w = 'put_imp_vol_30d_1w',
  /** column name */
  PutImpVol_30d_3m = 'put_imp_vol_30d_3m',
  /** column name */
  PxClose_1d = 'px_close_1d',
  /** column name */
  PxClose_1m = 'px_close_1m',
  /** column name */
  PxClose_1yr = 'px_close_1yr',
  /** column name */
  PxClose_3m = 'px_close_3m',
  /** column name */
  PxClose_5d = 'px_close_5d',
  /** column name */
  PxCloseDt = 'px_close_dt',
  /** column name */
  PxCloseYtd = 'px_close_ytd',
  /** column name */
  PxHigh = 'px_high',
  /** column name */
  PxLast = 'px_last',
  /** column name */
  PxLastEod = 'px_last_eod',
  /** column name */
  PxLow = 'px_low',
  /** column name */
  PxVolume = 'px_volume',
  /** column name */
  PxVolume_1d = 'px_volume_1d',
  /** column name */
  RedCurrentTrr_1d = 'red_current_trr_1d',
  /** column name */
  RedCurrentTrr_1mo = 'red_current_trr_1mo',
  /** column name */
  RedCurrentTrr_3mo = 'red_current_trr_3mo',
  /** column name */
  RedCurrentTrr_5d = 'red_current_trr_5d',
  /** column name */
  RedCurrentTrrYtd = 'red_current_trr_ytd',
  /** column name */
  RedEqyBeta = 'red_eqy_beta',
  /** column name */
  RedEqyBeta_6m = 'red_eqy_beta_6m',
  /** column name */
  RedEqyRawBeta = 'red_eqy_raw_beta',
  /** column name */
  RedEqyRawBeta_6m = 'red_eqy_raw_beta_6m',
  /** column name */
  RedOnemShortIntPct = 'red_onem_short_int_pct',
  /** column name */
  RedPutImpVol_30d = 'red_put_imp_vol_30d',
  /** column name */
  RedPxClose_1d = 'red_px_close_1d',
  /** column name */
  RedPxClose_1m = 'red_px_close_1m',
  /** column name */
  RedPxClose_1yr = 'red_px_close_1yr',
  /** column name */
  RedPxClose_3m = 'red_px_close_3m',
  /** column name */
  RedPxClose_5d = 'red_px_close_5d',
  /** column name */
  RedPxCloseYtd = 'red_px_close_ytd',
  /** column name */
  RedPxHigh = 'red_px_high',
  /** column name */
  RedPxLast = 'red_px_last',
  /** column name */
  RedPxLastEod = 'red_px_last_eod',
  /** column name */
  RedPxLow = 'red_px_low',
  /** column name */
  RedPxVolume = 'red_px_volume',
  /** column name */
  RedPxVolume_1d = 'red_px_volume_1d',
  /** column name */
  RedShortIntPctChg = 'red_short_int_pct_chg',
  /** column name */
  RedSiPercentEquityFloat = 'red_si_percent_equity_float',
  /** column name */
  RedVolatility_10d = 'red_volatility_10d',
  /** column name */
  RedVolatility_30d = 'red_volatility_30d',
  /** column name */
  RedVolumeAvg_3m = 'red_volume_avg_3m',
  /** column name */
  RedVolumeAvg_5d = 'red_volume_avg_5d',
  /** column name */
  RedVolumeAvg_6m = 'red_volume_avg_6m',
  /** column name */
  RedVolumeAvg_30d = 'red_volume_avg_30d',
  /** column name */
  SecurityTyp = 'security_typ',
  /** column name */
  ShortIntDate = 'short_int_date',
  /** column name */
  ShortIntPctChg = 'short_int_pct_chg',
  /** column name */
  SiPercentEquityFloat = 'si_percent_equity_float',
  /** column name */
  Ticker = 'ticker',
  /** column name */
  TickerAndExchCode = 'ticker_and_exch_code',
  /** column name */
  Volatility_10d = 'volatility_10d',
  /** column name */
  Volatility_30d = 'volatility_30d',
  /** column name */
  Volatility_30d_1d = 'volatility_30d_1d',
  /** column name */
  Volatility_30d_1m = 'volatility_30d_1m',
  /** column name */
  Volatility_30d_1w = 'volatility_30d_1w',
  /** column name */
  Volatility_30d_3m = 'volatility_30d_3m',
  /** column name */
  VolumeAvg_1d = 'volume_avg_1d',
  /** column name */
  VolumeAvg_3m = 'volume_avg_3m',
  /** column name */
  VolumeAvg_5d = 'volume_avg_5d',
  /** column name */
  VolumeAvg_6m = 'volume_avg_6m',
  /** column name */
  VolumeAvg_30d = 'volume_avg_30d'
}

export type Data3_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Data3_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Data3_Set_Input>;
  where: Data3_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Data3_Var_Pop_Fields = {
  __typename?: 'data3_var_pop_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Data3_Var_Samp_Fields = {
  __typename?: 'data3_var_samp_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Data3_Variance_Fields = {
  __typename?: 'data3_variance_fields';
  algo_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_daily_30D_ST_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_90D_MT_PRICE?: Maybe<Scalars['Float']>;
  algo_daily_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_daily_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem1D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem7D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem30D?: Maybe<Scalars['Float']>;
  algo_daily_CurrImpVolDiscPrem90D?: Maybe<Scalars['Float']>;
  algo_eod_CALC_POSITION_LONGBOW_SIGNAL_STRENGTH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_HIGH?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_LOW?: Maybe<Scalars['Float']>;
  algo_eod_CALC_TRADE_RANGE_ODDS?: Maybe<Scalars['Float']>;
  algo_eod_PX_LAST?: Maybe<Scalars['Float']>;
  calc_position_longbow_signal_strength?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_1w?: Maybe<Scalars['Float']>;
  calc_realized_volatility_3m?: Maybe<Scalars['Float']>;
  calc_realized_volatility_current?: Maybe<Scalars['Float']>;
  calc_volume_1d?: Maybe<Scalars['Float']>;
  calc_volume_1m?: Maybe<Scalars['Float']>;
  calc_volume_3m?: Maybe<Scalars['Float']>;
  calc_volume_5d?: Maybe<Scalars['Float']>;
  current_trr_1d?: Maybe<Scalars['Float']>;
  current_trr_1mo?: Maybe<Scalars['Float']>;
  current_trr_3mo?: Maybe<Scalars['Float']>;
  current_trr_5d?: Maybe<Scalars['Float']>;
  current_trr_ytd?: Maybe<Scalars['Float']>;
  entry_price?: Maybe<Scalars['Float']>;
  eqy_beta?: Maybe<Scalars['Float']>;
  eqy_beta_6m?: Maybe<Scalars['Float']>;
  eqy_raw_beta?: Maybe<Scalars['Float']>;
  eqy_raw_beta_6m?: Maybe<Scalars['Float']>;
  eqy_split_adjustment_factor?: Maybe<Scalars['Float']>;
  exposure?: Maybe<Scalars['Float']>;
  onem_short_int_pct?: Maybe<Scalars['Float']>;
  put_imp_vol_30d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1d?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1m?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_1w?: Maybe<Scalars['Float']>;
  put_imp_vol_30d_3m?: Maybe<Scalars['Float']>;
  px_close_1d?: Maybe<Scalars['Float']>;
  px_close_1m?: Maybe<Scalars['Float']>;
  px_close_1yr?: Maybe<Scalars['Float']>;
  px_close_3m?: Maybe<Scalars['Float']>;
  px_close_5d?: Maybe<Scalars['Float']>;
  px_close_ytd?: Maybe<Scalars['Float']>;
  px_high?: Maybe<Scalars['Float']>;
  px_last?: Maybe<Scalars['Float']>;
  px_last_eod?: Maybe<Scalars['Float']>;
  px_low?: Maybe<Scalars['Float']>;
  px_volume?: Maybe<Scalars['Float']>;
  px_volume_1d?: Maybe<Scalars['Float']>;
  short_int_pct_chg?: Maybe<Scalars['Float']>;
  si_percent_equity_float?: Maybe<Scalars['Float']>;
  volatility_10d?: Maybe<Scalars['Float']>;
  volatility_30d?: Maybe<Scalars['Float']>;
  volatility_30d_1d?: Maybe<Scalars['Float']>;
  volatility_30d_1m?: Maybe<Scalars['Float']>;
  volatility_30d_1w?: Maybe<Scalars['Float']>;
  volatility_30d_3m?: Maybe<Scalars['Float']>;
  volume_avg_1d?: Maybe<Scalars['Float']>;
  volume_avg_3m?: Maybe<Scalars['Float']>;
  volume_avg_5d?: Maybe<Scalars['Float']>;
  volume_avg_6m?: Maybe<Scalars['Float']>;
  volume_avg_30d?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

export type Get_Algo_Input = {
  ticker: Scalars['String'];
};

export type Get_Algo_Output = {
  __typename?: 'get_algo_output';
  data: Scalars['JSON'];
};

export type Get_Cacv_Data_Output = {
  __typename?: 'get_cacv_data_output';
  data: Scalars['JSON'];
};

export type Get_Cftc_Data_Output = {
  __typename?: 'get_cftc_data_output';
  data: Scalars['JSON'];
};

export type Get_Charting_Data_Input = {
  data: Scalars['JSON'];
};

export type Get_Charting_Data_Output = {
  __typename?: 'get_charting_data_output';
  data: Scalars['JSON'];
};

export type Get_Market_Volume_Data_Output = {
  __typename?: 'get_market_volume_data_output';
  data: Scalars['JSON'];
};

export type Get_Rates_And_Spreads_Data_Output = {
  __typename?: 'get_rates_and_spreads_data_output';
  data: Scalars['JSON'];
};

export type Get_Tickers_Left_Output = {
  __typename?: 'get_tickers_left_output';
  downgrade_plan_key: Scalars['String'];
  downgrade_plan_title: Scalars['String'];
  payment_confirmation_message: Scalars['String'];
  payment_success_message: Scalars['String'];
  tickers_left: Scalars['Int'];
  total_tickers: Scalars['Int'];
  upgrade_message: Scalars['String'];
  upgrade_plan_key: Scalars['String'];
  upgrade_plan_title: Scalars['String'];
};

export type Get_Usd_Correlations_Data_Output = {
  __typename?: 'get_usd_correlations_data_output';
  data: Scalars['JSON'];
};

export type Get_Usd_Correlations_For_Ticker_Input = {
  ticker: Scalars['String'];
};

export type Get_Usd_Correlations_For_Ticker_Output = {
  __typename?: 'get_usd_correlations_for_ticker_output';
  data: Scalars['JSON'];
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  add_panel?: Maybe<Add_Panel_Output>;
  add_ticker?: Maybe<Add_Ticker_Output>;
  /** delete data from the table: "cacv" */
  delete_cacv?: Maybe<Cacv_Mutation_Response>;
  /** delete single row from the table: "cacv" */
  delete_cacv_by_pk?: Maybe<Cacv>;
  /** delete data from the table: "chat" */
  delete_chat?: Maybe<Chat_Mutation_Response>;
  /** delete single row from the table: "chat" */
  delete_chat_by_pk?: Maybe<Chat>;
  /** delete data from the table: "column" */
  delete_column?: Maybe<Column_Mutation_Response>;
  /** delete single row from the table: "column" */
  delete_column_by_pk?: Maybe<Column>;
  /** delete data from the table: "correlations" */
  delete_correlations?: Maybe<Correlations_Mutation_Response>;
  /** delete single row from the table: "correlations" */
  delete_correlations_by_pk?: Maybe<Correlations>;
  /** delete data from the table: "data3" */
  delete_data3?: Maybe<Data3_Mutation_Response>;
  /** delete single row from the table: "data3" */
  delete_data3_by_pk?: Maybe<Data3>;
  /** delete data from the table: "panel" */
  delete_panel?: Maybe<Panel_Mutation_Response>;
  /** delete single row from the table: "panel" */
  delete_panel_by_pk?: Maybe<Panel>;
  /** delete data from the table: "python_scripts_cache" */
  delete_python_scripts_cache?: Maybe<Python_Scripts_Cache_Mutation_Response>;
  /** delete single row from the table: "python_scripts_cache" */
  delete_python_scripts_cache_by_pk?: Maybe<Python_Scripts_Cache>;
  /** delete data from the table: "request_tickers" */
  delete_request_tickers?: Maybe<Request_Tickers_Mutation_Response>;
  /** delete single row from the table: "request_tickers" */
  delete_request_tickers_by_pk?: Maybe<Request_Tickers>;
  /** delete data from the table: "search_tickers" */
  delete_search_tickers?: Maybe<Search_Tickers_Mutation_Response>;
  /** delete single row from the table: "search_tickers" */
  delete_search_tickers_by_pk?: Maybe<Search_Tickers>;
  /** delete data from the table: "section" */
  delete_section?: Maybe<Section_Mutation_Response>;
  /** delete single row from the table: "section" */
  delete_section_by_pk?: Maybe<Section>;
  /** delete data from the table: "subscriptions" */
  delete_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** delete single row from the table: "subscriptions" */
  delete_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** delete data from the table: "ticker" */
  delete_ticker?: Maybe<Ticker_Mutation_Response>;
  /** delete single row from the table: "ticker" */
  delete_ticker_by_pk?: Maybe<Ticker>;
  /** delete data from the table: "user_subscriptions" */
  delete_user_subscriptions?: Maybe<User_Subscriptions_Mutation_Response>;
  /** delete single row from the table: "user_subscriptions" */
  delete_user_subscriptions_by_pk?: Maybe<User_Subscriptions>;
  /** delete data from the table: "users" */
  delete_users?: Maybe<Users_Mutation_Response>;
  /** delete single row from the table: "users" */
  delete_users_by_pk?: Maybe<Users>;
  /** insert data into the table: "cacv" */
  insert_cacv?: Maybe<Cacv_Mutation_Response>;
  /** insert a single row into the table: "cacv" */
  insert_cacv_one?: Maybe<Cacv>;
  /** insert data into the table: "chat" */
  insert_chat?: Maybe<Chat_Mutation_Response>;
  /** insert a single row into the table: "chat" */
  insert_chat_one?: Maybe<Chat>;
  /** insert data into the table: "column" */
  insert_column?: Maybe<Column_Mutation_Response>;
  /** insert a single row into the table: "column" */
  insert_column_one?: Maybe<Column>;
  /** insert data into the table: "correlations" */
  insert_correlations?: Maybe<Correlations_Mutation_Response>;
  /** insert a single row into the table: "correlations" */
  insert_correlations_one?: Maybe<Correlations>;
  /** insert data into the table: "data3" */
  insert_data3?: Maybe<Data3_Mutation_Response>;
  /** insert a single row into the table: "data3" */
  insert_data3_one?: Maybe<Data3>;
  /** insert data into the table: "panel" */
  insert_panel?: Maybe<Panel_Mutation_Response>;
  /** insert a single row into the table: "panel" */
  insert_panel_one?: Maybe<Panel>;
  /** insert data into the table: "python_scripts_cache" */
  insert_python_scripts_cache?: Maybe<Python_Scripts_Cache_Mutation_Response>;
  /** insert a single row into the table: "python_scripts_cache" */
  insert_python_scripts_cache_one?: Maybe<Python_Scripts_Cache>;
  /** insert data into the table: "request_tickers" */
  insert_request_tickers?: Maybe<Request_Tickers_Mutation_Response>;
  /** insert a single row into the table: "request_tickers" */
  insert_request_tickers_one?: Maybe<Request_Tickers>;
  /** insert data into the table: "search_tickers" */
  insert_search_tickers?: Maybe<Search_Tickers_Mutation_Response>;
  /** insert a single row into the table: "search_tickers" */
  insert_search_tickers_one?: Maybe<Search_Tickers>;
  /** insert data into the table: "section" */
  insert_section?: Maybe<Section_Mutation_Response>;
  /** insert a single row into the table: "section" */
  insert_section_one?: Maybe<Section>;
  /** insert data into the table: "subscriptions" */
  insert_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "subscriptions" */
  insert_subscriptions_one?: Maybe<Subscriptions>;
  /** insert data into the table: "ticker" */
  insert_ticker?: Maybe<Ticker_Mutation_Response>;
  /** insert a single row into the table: "ticker" */
  insert_ticker_one?: Maybe<Ticker>;
  /** insert data into the table: "user_subscriptions" */
  insert_user_subscriptions?: Maybe<User_Subscriptions_Mutation_Response>;
  /** insert a single row into the table: "user_subscriptions" */
  insert_user_subscriptions_one?: Maybe<User_Subscriptions>;
  /** insert data into the table: "users" */
  insert_users?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users" */
  insert_users_one?: Maybe<Users>;
  /** update data of the table: "cacv" */
  update_cacv?: Maybe<Cacv_Mutation_Response>;
  /** update single row of the table: "cacv" */
  update_cacv_by_pk?: Maybe<Cacv>;
  /** update multiples rows of table: "cacv" */
  update_cacv_many?: Maybe<Array<Maybe<Cacv_Mutation_Response>>>;
  /** update data of the table: "chat" */
  update_chat?: Maybe<Chat_Mutation_Response>;
  /** update single row of the table: "chat" */
  update_chat_by_pk?: Maybe<Chat>;
  /** update multiples rows of table: "chat" */
  update_chat_many?: Maybe<Array<Maybe<Chat_Mutation_Response>>>;
  /** update data of the table: "column" */
  update_column?: Maybe<Column_Mutation_Response>;
  /** update single row of the table: "column" */
  update_column_by_pk?: Maybe<Column>;
  /** update multiples rows of table: "column" */
  update_column_many?: Maybe<Array<Maybe<Column_Mutation_Response>>>;
  /** update data of the table: "correlations" */
  update_correlations?: Maybe<Correlations_Mutation_Response>;
  /** update single row of the table: "correlations" */
  update_correlations_by_pk?: Maybe<Correlations>;
  /** update multiples rows of table: "correlations" */
  update_correlations_many?: Maybe<Array<Maybe<Correlations_Mutation_Response>>>;
  /** update data of the table: "data3" */
  update_data3?: Maybe<Data3_Mutation_Response>;
  /** update single row of the table: "data3" */
  update_data3_by_pk?: Maybe<Data3>;
  /** update multiples rows of table: "data3" */
  update_data3_many?: Maybe<Array<Maybe<Data3_Mutation_Response>>>;
  /** update data of the table: "panel" */
  update_panel?: Maybe<Panel_Mutation_Response>;
  /** update single row of the table: "panel" */
  update_panel_by_pk?: Maybe<Panel>;
  /** update multiples rows of table: "panel" */
  update_panel_many?: Maybe<Array<Maybe<Panel_Mutation_Response>>>;
  /** update data of the table: "python_scripts_cache" */
  update_python_scripts_cache?: Maybe<Python_Scripts_Cache_Mutation_Response>;
  /** update single row of the table: "python_scripts_cache" */
  update_python_scripts_cache_by_pk?: Maybe<Python_Scripts_Cache>;
  /** update multiples rows of table: "python_scripts_cache" */
  update_python_scripts_cache_many?: Maybe<Array<Maybe<Python_Scripts_Cache_Mutation_Response>>>;
  /** update data of the table: "request_tickers" */
  update_request_tickers?: Maybe<Request_Tickers_Mutation_Response>;
  /** update single row of the table: "request_tickers" */
  update_request_tickers_by_pk?: Maybe<Request_Tickers>;
  /** update multiples rows of table: "request_tickers" */
  update_request_tickers_many?: Maybe<Array<Maybe<Request_Tickers_Mutation_Response>>>;
  /** update data of the table: "search_tickers" */
  update_search_tickers?: Maybe<Search_Tickers_Mutation_Response>;
  /** update single row of the table: "search_tickers" */
  update_search_tickers_by_pk?: Maybe<Search_Tickers>;
  /** update multiples rows of table: "search_tickers" */
  update_search_tickers_many?: Maybe<Array<Maybe<Search_Tickers_Mutation_Response>>>;
  /** update data of the table: "section" */
  update_section?: Maybe<Section_Mutation_Response>;
  /** update single row of the table: "section" */
  update_section_by_pk?: Maybe<Section>;
  /** update multiples rows of table: "section" */
  update_section_many?: Maybe<Array<Maybe<Section_Mutation_Response>>>;
  /** update data of the table: "subscriptions" */
  update_subscriptions?: Maybe<Subscriptions_Mutation_Response>;
  /** update single row of the table: "subscriptions" */
  update_subscriptions_by_pk?: Maybe<Subscriptions>;
  /** update multiples rows of table: "subscriptions" */
  update_subscriptions_many?: Maybe<Array<Maybe<Subscriptions_Mutation_Response>>>;
  /** update data of the table: "ticker" */
  update_ticker?: Maybe<Ticker_Mutation_Response>;
  /** update single row of the table: "ticker" */
  update_ticker_by_pk?: Maybe<Ticker>;
  /** update multiples rows of table: "ticker" */
  update_ticker_many?: Maybe<Array<Maybe<Ticker_Mutation_Response>>>;
  /** update data of the table: "user_subscriptions" */
  update_user_subscriptions?: Maybe<User_Subscriptions_Mutation_Response>;
  /** update single row of the table: "user_subscriptions" */
  update_user_subscriptions_by_pk?: Maybe<User_Subscriptions>;
  /** update multiples rows of table: "user_subscriptions" */
  update_user_subscriptions_many?: Maybe<Array<Maybe<User_Subscriptions_Mutation_Response>>>;
  /** update data of the table: "users" */
  update_users?: Maybe<Users_Mutation_Response>;
  /** update single row of the table: "users" */
  update_users_by_pk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
};


/** mutation root */
export type Mutation_RootAdd_PanelArgs = {
  object: Add_Panel_Input;
};


/** mutation root */
export type Mutation_RootAdd_TickerArgs = {
  object: Add_Ticker_Input;
};


/** mutation root */
export type Mutation_RootDelete_CacvArgs = {
  where: Cacv_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cacv_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ChatArgs = {
  where: Chat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Chat_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ColumnArgs = {
  where: Column_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Column_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CorrelationsArgs = {
  where: Correlations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Correlations_By_PkArgs = {
  date: Scalars['date'];
};


/** mutation root */
export type Mutation_RootDelete_Data3Args = {
  where: Data3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Data3_By_PkArgs = {
  ticker: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_PanelArgs = {
  where: Panel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Panel_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Python_Scripts_CacheArgs = {
  where: Python_Scripts_Cache_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Python_Scripts_Cache_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Request_TickersArgs = {
  where: Request_Tickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Request_Tickers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Search_TickersArgs = {
  where: Search_Tickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Search_Tickers_By_PkArgs = {
  ticker: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_SectionArgs = {
  where: Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Section_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubscriptionsArgs = {
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Subscriptions_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_TickerArgs = {
  where: Ticker_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Ticker_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_SubscriptionsArgs = {
  where: User_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_UsersArgs = {
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Users_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootInsert_CacvArgs = {
  objects: Array<Cacv_Insert_Input>;
  on_conflict?: InputMaybe<Cacv_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cacv_OneArgs = {
  object: Cacv_Insert_Input;
  on_conflict?: InputMaybe<Cacv_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ChatArgs = {
  objects: Array<Chat_Insert_Input>;
  on_conflict?: InputMaybe<Chat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Chat_OneArgs = {
  object: Chat_Insert_Input;
  on_conflict?: InputMaybe<Chat_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ColumnArgs = {
  objects: Array<Column_Insert_Input>;
  on_conflict?: InputMaybe<Column_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Column_OneArgs = {
  object: Column_Insert_Input;
  on_conflict?: InputMaybe<Column_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CorrelationsArgs = {
  objects: Array<Correlations_Insert_Input>;
  on_conflict?: InputMaybe<Correlations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Correlations_OneArgs = {
  object: Correlations_Insert_Input;
  on_conflict?: InputMaybe<Correlations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data3Args = {
  objects: Array<Data3_Insert_Input>;
  on_conflict?: InputMaybe<Data3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Data3_OneArgs = {
  object: Data3_Insert_Input;
  on_conflict?: InputMaybe<Data3_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_PanelArgs = {
  objects: Array<Panel_Insert_Input>;
  on_conflict?: InputMaybe<Panel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Panel_OneArgs = {
  object: Panel_Insert_Input;
  on_conflict?: InputMaybe<Panel_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Python_Scripts_CacheArgs = {
  objects: Array<Python_Scripts_Cache_Insert_Input>;
  on_conflict?: InputMaybe<Python_Scripts_Cache_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Python_Scripts_Cache_OneArgs = {
  object: Python_Scripts_Cache_Insert_Input;
  on_conflict?: InputMaybe<Python_Scripts_Cache_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_TickersArgs = {
  objects: Array<Request_Tickers_Insert_Input>;
  on_conflict?: InputMaybe<Request_Tickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Request_Tickers_OneArgs = {
  object: Request_Tickers_Insert_Input;
  on_conflict?: InputMaybe<Request_Tickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_TickersArgs = {
  objects: Array<Search_Tickers_Insert_Input>;
  on_conflict?: InputMaybe<Search_Tickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Search_Tickers_OneArgs = {
  object: Search_Tickers_Insert_Input;
  on_conflict?: InputMaybe<Search_Tickers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SectionArgs = {
  objects: Array<Section_Insert_Input>;
  on_conflict?: InputMaybe<Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Section_OneArgs = {
  object: Section_Insert_Input;
  on_conflict?: InputMaybe<Section_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubscriptionsArgs = {
  objects: Array<Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Subscriptions_OneArgs = {
  object: Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_TickerArgs = {
  objects: Array<Ticker_Insert_Input>;
  on_conflict?: InputMaybe<Ticker_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Ticker_OneArgs = {
  object: Ticker_Insert_Input;
  on_conflict?: InputMaybe<Ticker_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_SubscriptionsArgs = {
  objects: Array<User_Subscriptions_Insert_Input>;
  on_conflict?: InputMaybe<User_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Subscriptions_OneArgs = {
  object: User_Subscriptions_Insert_Input;
  on_conflict?: InputMaybe<User_Subscriptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_UsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Users_OneArgs = {
  object: Users_Insert_Input;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootUpdate_CacvArgs = {
  _inc?: InputMaybe<Cacv_Inc_Input>;
  _set?: InputMaybe<Cacv_Set_Input>;
  where: Cacv_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cacv_By_PkArgs = {
  _inc?: InputMaybe<Cacv_Inc_Input>;
  _set?: InputMaybe<Cacv_Set_Input>;
  pk_columns: Cacv_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cacv_ManyArgs = {
  updates: Array<Cacv_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ChatArgs = {
  _set?: InputMaybe<Chat_Set_Input>;
  where: Chat_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_By_PkArgs = {
  _set?: InputMaybe<Chat_Set_Input>;
  pk_columns: Chat_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Chat_ManyArgs = {
  updates: Array<Chat_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ColumnArgs = {
  _inc?: InputMaybe<Column_Inc_Input>;
  _set?: InputMaybe<Column_Set_Input>;
  where: Column_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Column_By_PkArgs = {
  _inc?: InputMaybe<Column_Inc_Input>;
  _set?: InputMaybe<Column_Set_Input>;
  pk_columns: Column_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Column_ManyArgs = {
  updates: Array<Column_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CorrelationsArgs = {
  _inc?: InputMaybe<Correlations_Inc_Input>;
  _set?: InputMaybe<Correlations_Set_Input>;
  where: Correlations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Correlations_By_PkArgs = {
  _inc?: InputMaybe<Correlations_Inc_Input>;
  _set?: InputMaybe<Correlations_Set_Input>;
  pk_columns: Correlations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Correlations_ManyArgs = {
  updates: Array<Correlations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Data3Args = {
  _inc?: InputMaybe<Data3_Inc_Input>;
  _set?: InputMaybe<Data3_Set_Input>;
  where: Data3_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Data3_By_PkArgs = {
  _inc?: InputMaybe<Data3_Inc_Input>;
  _set?: InputMaybe<Data3_Set_Input>;
  pk_columns: Data3_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Data3_ManyArgs = {
  updates: Array<Data3_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PanelArgs = {
  _inc?: InputMaybe<Panel_Inc_Input>;
  _set?: InputMaybe<Panel_Set_Input>;
  where: Panel_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Panel_By_PkArgs = {
  _inc?: InputMaybe<Panel_Inc_Input>;
  _set?: InputMaybe<Panel_Set_Input>;
  pk_columns: Panel_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Panel_ManyArgs = {
  updates: Array<Panel_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Python_Scripts_CacheArgs = {
  _append?: InputMaybe<Python_Scripts_Cache_Append_Input>;
  _delete_at_path?: InputMaybe<Python_Scripts_Cache_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Python_Scripts_Cache_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Python_Scripts_Cache_Delete_Key_Input>;
  _prepend?: InputMaybe<Python_Scripts_Cache_Prepend_Input>;
  _set?: InputMaybe<Python_Scripts_Cache_Set_Input>;
  where: Python_Scripts_Cache_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Python_Scripts_Cache_By_PkArgs = {
  _append?: InputMaybe<Python_Scripts_Cache_Append_Input>;
  _delete_at_path?: InputMaybe<Python_Scripts_Cache_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Python_Scripts_Cache_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Python_Scripts_Cache_Delete_Key_Input>;
  _prepend?: InputMaybe<Python_Scripts_Cache_Prepend_Input>;
  _set?: InputMaybe<Python_Scripts_Cache_Set_Input>;
  pk_columns: Python_Scripts_Cache_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Python_Scripts_Cache_ManyArgs = {
  updates: Array<Python_Scripts_Cache_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Request_TickersArgs = {
  _set?: InputMaybe<Request_Tickers_Set_Input>;
  where: Request_Tickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Tickers_By_PkArgs = {
  _set?: InputMaybe<Request_Tickers_Set_Input>;
  pk_columns: Request_Tickers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Tickers_ManyArgs = {
  updates: Array<Request_Tickers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Search_TickersArgs = {
  _set?: InputMaybe<Search_Tickers_Set_Input>;
  where: Search_Tickers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Tickers_By_PkArgs = {
  _set?: InputMaybe<Search_Tickers_Set_Input>;
  pk_columns: Search_Tickers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Search_Tickers_ManyArgs = {
  updates: Array<Search_Tickers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SectionArgs = {
  _inc?: InputMaybe<Section_Inc_Input>;
  _set?: InputMaybe<Section_Set_Input>;
  where: Section_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Section_By_PkArgs = {
  _inc?: InputMaybe<Section_Inc_Input>;
  _set?: InputMaybe<Section_Set_Input>;
  pk_columns: Section_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Section_ManyArgs = {
  updates: Array<Section_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubscriptionsArgs = {
  _append?: InputMaybe<Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscriptions_Delete_Key_Input>;
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _prepend?: InputMaybe<Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_By_PkArgs = {
  _append?: InputMaybe<Subscriptions_Append_Input>;
  _delete_at_path?: InputMaybe<Subscriptions_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Subscriptions_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Subscriptions_Delete_Key_Input>;
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  _prepend?: InputMaybe<Subscriptions_Prepend_Input>;
  _set?: InputMaybe<Subscriptions_Set_Input>;
  pk_columns: Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Subscriptions_ManyArgs = {
  updates: Array<Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TickerArgs = {
  _inc?: InputMaybe<Ticker_Inc_Input>;
  _set?: InputMaybe<Ticker_Set_Input>;
  where: Ticker_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_By_PkArgs = {
  _inc?: InputMaybe<Ticker_Inc_Input>;
  _set?: InputMaybe<Ticker_Set_Input>;
  pk_columns: Ticker_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Ticker_ManyArgs = {
  updates: Array<Ticker_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_SubscriptionsArgs = {
  _inc?: InputMaybe<User_Subscriptions_Inc_Input>;
  _set?: InputMaybe<User_Subscriptions_Set_Input>;
  where: User_Subscriptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscriptions_By_PkArgs = {
  _inc?: InputMaybe<User_Subscriptions_Inc_Input>;
  _set?: InputMaybe<User_Subscriptions_Set_Input>;
  pk_columns: User_Subscriptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Subscriptions_ManyArgs = {
  updates: Array<User_Subscriptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Users_By_PkArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "panel" */
export type Panel = {
  __typename?: 'panel';
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamptz'];
  hidden: Scalars['Boolean'];
  id: Scalars['uuid'];
  kiss?: Maybe<Scalars['Boolean']>;
  longbow_panel: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  /** An array relationship */
  section: Array<Section>;
  /** An aggregate relationship */
  section_aggregate: Section_Aggregate;
  subscription_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  tickers: Array<Ticker>;
  /** An aggregate relationship */
  tickers_aggregate: Ticker_Aggregate;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid'];
  /** An array relationship */
  user_subscriptions: Array<User_Subscriptions>;
  /** An aggregate relationship */
  user_subscriptions_aggregate: User_Subscriptions_Aggregate;
};


/** columns and relationships of "panel" */
export type PanelSectionArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


/** columns and relationships of "panel" */
export type PanelSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


/** columns and relationships of "panel" */
export type PanelTickersArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Order_By>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


/** columns and relationships of "panel" */
export type PanelTickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Order_By>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


/** columns and relationships of "panel" */
export type PanelUser_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "panel" */
export type PanelUser_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};

/** aggregated selection of "panel" */
export type Panel_Aggregate = {
  __typename?: 'panel_aggregate';
  aggregate?: Maybe<Panel_Aggregate_Fields>;
  nodes: Array<Panel>;
};

/** aggregate fields of "panel" */
export type Panel_Aggregate_Fields = {
  __typename?: 'panel_aggregate_fields';
  avg?: Maybe<Panel_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Panel_Max_Fields>;
  min?: Maybe<Panel_Min_Fields>;
  stddev?: Maybe<Panel_Stddev_Fields>;
  stddev_pop?: Maybe<Panel_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Panel_Stddev_Samp_Fields>;
  sum?: Maybe<Panel_Sum_Fields>;
  var_pop?: Maybe<Panel_Var_Pop_Fields>;
  var_samp?: Maybe<Panel_Var_Samp_Fields>;
  variance?: Maybe<Panel_Variance_Fields>;
};


/** aggregate fields of "panel" */
export type Panel_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Panel_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "panel" */
export type Panel_Aggregate_Order_By = {
  avg?: InputMaybe<Panel_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Panel_Max_Order_By>;
  min?: InputMaybe<Panel_Min_Order_By>;
  stddev?: InputMaybe<Panel_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Panel_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Panel_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Panel_Sum_Order_By>;
  var_pop?: InputMaybe<Panel_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Panel_Var_Samp_Order_By>;
  variance?: InputMaybe<Panel_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "panel" */
export type Panel_Arr_Rel_Insert_Input = {
  data: Array<Panel_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Panel_On_Conflict>;
};

/** aggregate avg on columns */
export type Panel_Avg_Fields = {
  __typename?: 'panel_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "panel" */
export type Panel_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "panel". All fields are combined with a logical 'AND'. */
export type Panel_Bool_Exp = {
  _and?: InputMaybe<Array<Panel_Bool_Exp>>;
  _not?: InputMaybe<Panel_Bool_Exp>;
  _or?: InputMaybe<Array<Panel_Bool_Exp>>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kiss?: InputMaybe<Boolean_Comparison_Exp>;
  longbow_panel?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  section?: InputMaybe<Section_Bool_Exp>;
  subscription_id?: InputMaybe<String_Comparison_Exp>;
  tickers?: InputMaybe<Ticker_Bool_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
  user_subscriptions?: InputMaybe<User_Subscriptions_Bool_Exp>;
};

/** unique or primary key constraints on table "panel" */
export enum Panel_Constraint {
  /** unique or primary key constraint on columns "id" */
  PanelPkey = 'panel_pkey'
}

/** input type for incrementing numeric columns in table "panel" */
export type Panel_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "panel" */
export type Panel_Insert_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  kiss?: InputMaybe<Scalars['Boolean']>;
  longbow_panel?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  section?: InputMaybe<Section_Arr_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['String']>;
  tickers?: InputMaybe<Ticker_Arr_Rel_Insert_Input>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
  user_subscriptions?: InputMaybe<User_Subscriptions_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Panel_Max_Fields = {
  __typename?: 'panel_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  subscription_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "panel" */
export type Panel_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Panel_Min_Fields = {
  __typename?: 'panel_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  subscription_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "panel" */
export type Panel_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "panel" */
export type Panel_Mutation_Response = {
  __typename?: 'panel_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Panel>;
};

/** input type for inserting object relation for remote table "panel" */
export type Panel_Obj_Rel_Insert_Input = {
  data: Panel_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Panel_On_Conflict>;
};

/** on_conflict condition type for table "panel" */
export type Panel_On_Conflict = {
  constraint: Panel_Constraint;
  update_columns?: Array<Panel_Update_Column>;
  where?: InputMaybe<Panel_Bool_Exp>;
};

/** Ordering options when selecting data from "panel". */
export type Panel_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kiss?: InputMaybe<Order_By>;
  longbow_panel?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  section_aggregate?: InputMaybe<Section_Aggregate_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  tickers_aggregate?: InputMaybe<Ticker_Aggregate_Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_subscriptions_aggregate?: InputMaybe<User_Subscriptions_Aggregate_Order_By>;
};

/** primary key columns input for table: panel */
export type Panel_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "panel" */
export enum Panel_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Kiss = 'kiss',
  /** column name */
  LongbowPanel = 'longbow_panel',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "panel" */
export type Panel_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  kiss?: InputMaybe<Scalars['Boolean']>;
  longbow_panel?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  subscription_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Panel_Stddev_Fields = {
  __typename?: 'panel_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "panel" */
export type Panel_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Panel_Stddev_Pop_Fields = {
  __typename?: 'panel_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "panel" */
export type Panel_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Panel_Stddev_Samp_Fields = {
  __typename?: 'panel_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "panel" */
export type Panel_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "panel" */
export type Panel_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Panel_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Panel_Stream_Cursor_Value_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  kiss?: InputMaybe<Scalars['Boolean']>;
  longbow_panel?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  subscription_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Panel_Sum_Fields = {
  __typename?: 'panel_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "panel" */
export type Panel_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "panel" */
export enum Panel_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Kiss = 'kiss',
  /** column name */
  LongbowPanel = 'longbow_panel',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  UserId = 'user_id'
}

export type Panel_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Panel_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Panel_Set_Input>;
  where: Panel_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Panel_Var_Pop_Fields = {
  __typename?: 'panel_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "panel" */
export type Panel_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Panel_Var_Samp_Fields = {
  __typename?: 'panel_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "panel" */
export type Panel_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Panel_Variance_Fields = {
  __typename?: 'panel_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "panel" */
export type Panel_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** columns and relationships of "python_scripts_cache" */
export type Python_Scripts_Cache = {
  __typename?: 'python_scripts_cache';
  data?: Maybe<Scalars['jsonb']>;
  id: Scalars['String'];
};


/** columns and relationships of "python_scripts_cache" */
export type Python_Scripts_CacheDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "python_scripts_cache" */
export type Python_Scripts_Cache_Aggregate = {
  __typename?: 'python_scripts_cache_aggregate';
  aggregate?: Maybe<Python_Scripts_Cache_Aggregate_Fields>;
  nodes: Array<Python_Scripts_Cache>;
};

/** aggregate fields of "python_scripts_cache" */
export type Python_Scripts_Cache_Aggregate_Fields = {
  __typename?: 'python_scripts_cache_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Python_Scripts_Cache_Max_Fields>;
  min?: Maybe<Python_Scripts_Cache_Min_Fields>;
};


/** aggregate fields of "python_scripts_cache" */
export type Python_Scripts_Cache_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Python_Scripts_Cache_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Python_Scripts_Cache_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "python_scripts_cache". All fields are combined with a logical 'AND'. */
export type Python_Scripts_Cache_Bool_Exp = {
  _and?: InputMaybe<Array<Python_Scripts_Cache_Bool_Exp>>;
  _not?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
  _or?: InputMaybe<Array<Python_Scripts_Cache_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "python_scripts_cache" */
export enum Python_Scripts_Cache_Constraint {
  /** unique or primary key constraint on columns "id" */
  PythonScriptsCachePkey = 'python_scripts_cache_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Python_Scripts_Cache_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Python_Scripts_Cache_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Python_Scripts_Cache_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "python_scripts_cache" */
export type Python_Scripts_Cache_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Python_Scripts_Cache_Max_Fields = {
  __typename?: 'python_scripts_cache_max_fields';
  id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Python_Scripts_Cache_Min_Fields = {
  __typename?: 'python_scripts_cache_min_fields';
  id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "python_scripts_cache" */
export type Python_Scripts_Cache_Mutation_Response = {
  __typename?: 'python_scripts_cache_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Python_Scripts_Cache>;
};

/** on_conflict condition type for table "python_scripts_cache" */
export type Python_Scripts_Cache_On_Conflict = {
  constraint: Python_Scripts_Cache_Constraint;
  update_columns?: Array<Python_Scripts_Cache_Update_Column>;
  where?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
};

/** Ordering options when selecting data from "python_scripts_cache". */
export type Python_Scripts_Cache_Order_By = {
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: python_scripts_cache */
export type Python_Scripts_Cache_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Python_Scripts_Cache_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "python_scripts_cache" */
export enum Python_Scripts_Cache_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "python_scripts_cache" */
export type Python_Scripts_Cache_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "python_scripts_cache" */
export type Python_Scripts_Cache_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Python_Scripts_Cache_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Python_Scripts_Cache_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "python_scripts_cache" */
export enum Python_Scripts_Cache_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id'
}

export type Python_Scripts_Cache_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Python_Scripts_Cache_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Python_Scripts_Cache_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Python_Scripts_Cache_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Python_Scripts_Cache_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Python_Scripts_Cache_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Python_Scripts_Cache_Set_Input>;
  where: Python_Scripts_Cache_Bool_Exp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "cacv" */
  cacv: Array<Cacv>;
  /** fetch aggregated fields from the table: "cacv" */
  cacv_aggregate: Cacv_Aggregate;
  /** fetch data from the table: "cacv" using primary key columns */
  cacv_by_pk?: Maybe<Cacv>;
  /** fetch data from the table: "chat" */
  chat: Array<Chat>;
  /** fetch aggregated fields from the table: "chat" */
  chat_aggregate: Chat_Aggregate;
  /** fetch data from the table: "chat" using primary key columns */
  chat_by_pk?: Maybe<Chat>;
  /** An array relationship */
  column: Array<Column>;
  /** An aggregate relationship */
  column_aggregate: Column_Aggregate;
  /** fetch data from the table: "column" using primary key columns */
  column_by_pk?: Maybe<Column>;
  /** fetch data from the table: "correlations" */
  correlations: Array<Correlations>;
  /** fetch aggregated fields from the table: "correlations" */
  correlations_aggregate: Correlations_Aggregate;
  /** fetch data from the table: "correlations" using primary key columns */
  correlations_by_pk?: Maybe<Correlations>;
  /** fetch data from the table: "data3" */
  data3: Array<Data3>;
  /** fetch aggregated fields from the table: "data3" */
  data3_aggregate: Data3_Aggregate;
  /** fetch data from the table: "data3" using primary key columns */
  data3_by_pk?: Maybe<Data3>;
  get_algo_data?: Maybe<Get_Algo_Output>;
  get_cacv_data?: Maybe<Get_Cacv_Data_Output>;
  get_cftc_data?: Maybe<Get_Cftc_Data_Output>;
  get_charting_data?: Maybe<Get_Charting_Data_Output>;
  get_market_volume_data?: Maybe<Get_Market_Volume_Data_Output>;
  get_rates_and_spreads_data?: Maybe<Get_Rates_And_Spreads_Data_Output>;
  get_tickers_left?: Maybe<Get_Tickers_Left_Output>;
  get_usd_correlations_data?: Maybe<Get_Usd_Correlations_Data_Output>;
  get_usd_correlations_for_ticker_data?: Maybe<Get_Usd_Correlations_For_Ticker_Output>;
  /** fetch data from the table: "panel" */
  panel: Array<Panel>;
  /** fetch aggregated fields from the table: "panel" */
  panel_aggregate: Panel_Aggregate;
  /** fetch data from the table: "panel" using primary key columns */
  panel_by_pk?: Maybe<Panel>;
  /** fetch data from the table: "python_scripts_cache" */
  python_scripts_cache: Array<Python_Scripts_Cache>;
  /** fetch aggregated fields from the table: "python_scripts_cache" */
  python_scripts_cache_aggregate: Python_Scripts_Cache_Aggregate;
  /** fetch data from the table: "python_scripts_cache" using primary key columns */
  python_scripts_cache_by_pk?: Maybe<Python_Scripts_Cache>;
  /** fetch data from the table: "request_tickers" */
  request_tickers: Array<Request_Tickers>;
  /** fetch aggregated fields from the table: "request_tickers" */
  request_tickers_aggregate: Request_Tickers_Aggregate;
  /** fetch data from the table: "request_tickers" using primary key columns */
  request_tickers_by_pk?: Maybe<Request_Tickers>;
  /** fetch data from the table: "search_tickers" */
  search_tickers: Array<Search_Tickers>;
  /** fetch aggregated fields from the table: "search_tickers" */
  search_tickers_aggregate: Search_Tickers_Aggregate;
  /** fetch data from the table: "search_tickers" using primary key columns */
  search_tickers_by_pk?: Maybe<Search_Tickers>;
  /** An array relationship */
  section: Array<Section>;
  /** An aggregate relationship */
  section_aggregate: Section_Aggregate;
  /** fetch data from the table: "section" using primary key columns */
  section_by_pk?: Maybe<Section>;
  /** fetch data from the table: "subscriptions" */
  subscriptions: Array<Subscriptions>;
  /** fetch aggregated fields from the table: "subscriptions" */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table: "ticker" */
  ticker: Array<Ticker>;
  ticker2_schema_data?: Maybe<Ticker2_Schema_Data>;
  /** fetch aggregated fields from the table: "ticker" */
  ticker_aggregate: Ticker_Aggregate;
  /** fetch data from the table: "ticker" using primary key columns */
  ticker_by_pk?: Maybe<Ticker>;
  /** An array relationship */
  user_subscriptions: Array<User_Subscriptions>;
  /** An aggregate relationship */
  user_subscriptions_aggregate: User_Subscriptions_Aggregate;
  /** fetch data from the table: "user_subscriptions" using primary key columns */
  user_subscriptions_by_pk?: Maybe<User_Subscriptions>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
};


export type Query_RootCacvArgs = {
  distinct_on?: InputMaybe<Array<Cacv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cacv_Order_By>>;
  where?: InputMaybe<Cacv_Bool_Exp>;
};


export type Query_RootCacv_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cacv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cacv_Order_By>>;
  where?: InputMaybe<Cacv_Bool_Exp>;
};


export type Query_RootCacv_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootChatArgs = {
  distinct_on?: InputMaybe<Array<Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Order_By>>;
  where?: InputMaybe<Chat_Bool_Exp>;
};


export type Query_RootChat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Order_By>>;
  where?: InputMaybe<Chat_Bool_Exp>;
};


export type Query_RootChat_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootColumnArgs = {
  distinct_on?: InputMaybe<Array<Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Column_Order_By>>;
  where?: InputMaybe<Column_Bool_Exp>;
};


export type Query_RootColumn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Column_Order_By>>;
  where?: InputMaybe<Column_Bool_Exp>;
};


export type Query_RootColumn_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCorrelationsArgs = {
  distinct_on?: InputMaybe<Array<Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Correlations_Order_By>>;
  where?: InputMaybe<Correlations_Bool_Exp>;
};


export type Query_RootCorrelations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Correlations_Order_By>>;
  where?: InputMaybe<Correlations_Bool_Exp>;
};


export type Query_RootCorrelations_By_PkArgs = {
  date: Scalars['date'];
};


export type Query_RootData3Args = {
  distinct_on?: InputMaybe<Array<Data3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data3_Order_By>>;
  where?: InputMaybe<Data3_Bool_Exp>;
};


export type Query_RootData3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data3_Order_By>>;
  where?: InputMaybe<Data3_Bool_Exp>;
};


export type Query_RootData3_By_PkArgs = {
  ticker: Scalars['String'];
};


export type Query_RootGet_Algo_DataArgs = {
  object: Get_Algo_Input;
};


export type Query_RootGet_Charting_DataArgs = {
  object: Get_Charting_Data_Input;
};


export type Query_RootGet_Usd_Correlations_For_Ticker_DataArgs = {
  object: Get_Usd_Correlations_For_Ticker_Input;
};


export type Query_RootPanelArgs = {
  distinct_on?: InputMaybe<Array<Panel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Panel_Order_By>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


export type Query_RootPanel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Panel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Panel_Order_By>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


export type Query_RootPanel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPython_Scripts_CacheArgs = {
  distinct_on?: InputMaybe<Array<Python_Scripts_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Python_Scripts_Cache_Order_By>>;
  where?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
};


export type Query_RootPython_Scripts_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Python_Scripts_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Python_Scripts_Cache_Order_By>>;
  where?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
};


export type Query_RootPython_Scripts_Cache_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootRequest_TickersArgs = {
  distinct_on?: InputMaybe<Array<Request_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Tickers_Order_By>>;
  where?: InputMaybe<Request_Tickers_Bool_Exp>;
};


export type Query_RootRequest_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Tickers_Order_By>>;
  where?: InputMaybe<Request_Tickers_Bool_Exp>;
};


export type Query_RootRequest_Tickers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSearch_TickersArgs = {
  distinct_on?: InputMaybe<Array<Search_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Tickers_Order_By>>;
  where?: InputMaybe<Search_Tickers_Bool_Exp>;
};


export type Query_RootSearch_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Tickers_Order_By>>;
  where?: InputMaybe<Search_Tickers_Bool_Exp>;
};


export type Query_RootSearch_Tickers_By_PkArgs = {
  ticker: Scalars['String'];
};


export type Query_RootSectionArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Query_RootSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Query_RootSection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Query_RootSubscriptions_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootTickerArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Order_By>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


export type Query_RootTicker2_Schema_DataArgs = {
  where?: InputMaybe<Ticker2_Schema_Input>;
};


export type Query_RootTicker_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Order_By>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


export type Query_RootTicker_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUser_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


export type Query_RootUser_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


export type Query_RootUser_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Query_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};

/** columns and relationships of "request_tickers" */
export type Request_Tickers = {
  __typename?: 'request_tickers';
  date_created: Scalars['timestamptz'];
  id: Scalars['uuid'];
  sent_to_admin: Scalars['Boolean'];
  sent_to_user: Scalars['Boolean'];
  ticker: Scalars['String'];
  user_id: Scalars['bpchar'];
};

/** aggregated selection of "request_tickers" */
export type Request_Tickers_Aggregate = {
  __typename?: 'request_tickers_aggregate';
  aggregate?: Maybe<Request_Tickers_Aggregate_Fields>;
  nodes: Array<Request_Tickers>;
};

/** aggregate fields of "request_tickers" */
export type Request_Tickers_Aggregate_Fields = {
  __typename?: 'request_tickers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Request_Tickers_Max_Fields>;
  min?: Maybe<Request_Tickers_Min_Fields>;
};


/** aggregate fields of "request_tickers" */
export type Request_Tickers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Tickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "request_tickers". All fields are combined with a logical 'AND'. */
export type Request_Tickers_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Tickers_Bool_Exp>>;
  _not?: InputMaybe<Request_Tickers_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Tickers_Bool_Exp>>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sent_to_admin?: InputMaybe<Boolean_Comparison_Exp>;
  sent_to_user?: InputMaybe<Boolean_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<Bpchar_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_tickers" */
export enum Request_Tickers_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequestTickersPkey = 'request_tickers_pkey'
}

/** input type for inserting data into table "request_tickers" */
export type Request_Tickers_Insert_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sent_to_admin?: InputMaybe<Scalars['Boolean']>;
  sent_to_user?: InputMaybe<Scalars['Boolean']>;
  ticker?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bpchar']>;
};

/** aggregate max on columns */
export type Request_Tickers_Max_Fields = {
  __typename?: 'request_tickers_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bpchar']>;
};

/** aggregate min on columns */
export type Request_Tickers_Min_Fields = {
  __typename?: 'request_tickers_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['bpchar']>;
};

/** response of any mutation on the table "request_tickers" */
export type Request_Tickers_Mutation_Response = {
  __typename?: 'request_tickers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request_Tickers>;
};

/** input type for inserting object relation for remote table "request_tickers" */
export type Request_Tickers_Obj_Rel_Insert_Input = {
  data: Request_Tickers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Request_Tickers_On_Conflict>;
};

/** on_conflict condition type for table "request_tickers" */
export type Request_Tickers_On_Conflict = {
  constraint: Request_Tickers_Constraint;
  update_columns?: Array<Request_Tickers_Update_Column>;
  where?: InputMaybe<Request_Tickers_Bool_Exp>;
};

/** Ordering options when selecting data from "request_tickers". */
export type Request_Tickers_Order_By = {
  date_created?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sent_to_admin?: InputMaybe<Order_By>;
  sent_to_user?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_tickers */
export type Request_Tickers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "request_tickers" */
export enum Request_Tickers_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Id = 'id',
  /** column name */
  SentToAdmin = 'sent_to_admin',
  /** column name */
  SentToUser = 'sent_to_user',
  /** column name */
  Ticker = 'ticker',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "request_tickers" */
export type Request_Tickers_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sent_to_admin?: InputMaybe<Scalars['Boolean']>;
  sent_to_user?: InputMaybe<Scalars['Boolean']>;
  ticker?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bpchar']>;
};

/** Streaming cursor of the table "request_tickers" */
export type Request_Tickers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Tickers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Tickers_Stream_Cursor_Value_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  sent_to_admin?: InputMaybe<Scalars['Boolean']>;
  sent_to_user?: InputMaybe<Scalars['Boolean']>;
  ticker?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['bpchar']>;
};

/** update columns of table "request_tickers" */
export enum Request_Tickers_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  Id = 'id',
  /** column name */
  SentToAdmin = 'sent_to_admin',
  /** column name */
  SentToUser = 'sent_to_user',
  /** column name */
  Ticker = 'ticker',
  /** column name */
  UserId = 'user_id'
}

export type Request_Tickers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Tickers_Set_Input>;
  where: Request_Tickers_Bool_Exp;
};

/** columns and relationships of "search_tickers" */
export type Search_Tickers = {
  __typename?: 'search_tickers';
  exists: Scalars['Boolean'];
  name: Scalars['String'];
  /** An object relationship */
  requested?: Maybe<Request_Tickers>;
  ticker: Scalars['String'];
};

/** aggregated selection of "search_tickers" */
export type Search_Tickers_Aggregate = {
  __typename?: 'search_tickers_aggregate';
  aggregate?: Maybe<Search_Tickers_Aggregate_Fields>;
  nodes: Array<Search_Tickers>;
};

/** aggregate fields of "search_tickers" */
export type Search_Tickers_Aggregate_Fields = {
  __typename?: 'search_tickers_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Search_Tickers_Max_Fields>;
  min?: Maybe<Search_Tickers_Min_Fields>;
};


/** aggregate fields of "search_tickers" */
export type Search_Tickers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Search_Tickers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "search_tickers". All fields are combined with a logical 'AND'. */
export type Search_Tickers_Bool_Exp = {
  _and?: InputMaybe<Array<Search_Tickers_Bool_Exp>>;
  _not?: InputMaybe<Search_Tickers_Bool_Exp>;
  _or?: InputMaybe<Array<Search_Tickers_Bool_Exp>>;
  exists?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  requested?: InputMaybe<Request_Tickers_Bool_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "search_tickers" */
export enum Search_Tickers_Constraint {
  /** unique or primary key constraint on columns "ticker" */
  SearchTickersPkey = 'search_tickers_pkey'
}

/** input type for inserting data into table "search_tickers" */
export type Search_Tickers_Insert_Input = {
  exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  requested?: InputMaybe<Request_Tickers_Obj_Rel_Insert_Input>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Search_Tickers_Max_Fields = {
  __typename?: 'search_tickers_max_fields';
  name?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Search_Tickers_Min_Fields = {
  __typename?: 'search_tickers_min_fields';
  name?: Maybe<Scalars['String']>;
  ticker?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "search_tickers" */
export type Search_Tickers_Mutation_Response = {
  __typename?: 'search_tickers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Search_Tickers>;
};

/** on_conflict condition type for table "search_tickers" */
export type Search_Tickers_On_Conflict = {
  constraint: Search_Tickers_Constraint;
  update_columns?: Array<Search_Tickers_Update_Column>;
  where?: InputMaybe<Search_Tickers_Bool_Exp>;
};

/** Ordering options when selecting data from "search_tickers". */
export type Search_Tickers_Order_By = {
  exists?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  requested?: InputMaybe<Request_Tickers_Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** primary key columns input for table: search_tickers */
export type Search_Tickers_Pk_Columns_Input = {
  ticker: Scalars['String'];
};

/** select columns of table "search_tickers" */
export enum Search_Tickers_Select_Column {
  /** column name */
  Exists = 'exists',
  /** column name */
  Name = 'name',
  /** column name */
  Ticker = 'ticker'
}

/** input type for updating data in table "search_tickers" */
export type Search_Tickers_Set_Input = {
  exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "search_tickers" */
export type Search_Tickers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Search_Tickers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Search_Tickers_Stream_Cursor_Value_Input = {
  exists?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** update columns of table "search_tickers" */
export enum Search_Tickers_Update_Column {
  /** column name */
  Exists = 'exists',
  /** column name */
  Name = 'name',
  /** column name */
  Ticker = 'ticker'
}

export type Search_Tickers_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Search_Tickers_Set_Input>;
  where: Search_Tickers_Bool_Exp;
};

/** columns and relationships of "section" */
export type Section = {
  __typename?: 'section';
  /** An array relationship */
  column: Array<Column>;
  /** An aggregate relationship */
  column_aggregate: Column_Aggregate;
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamptz'];
  hidden?: Maybe<Scalars['Boolean']>;
  id: Scalars['uuid'];
  kiss: Scalars['Boolean'];
  name: Scalars['String'];
  order: Scalars['Int'];
  panel_id: Scalars['uuid'];
};


/** columns and relationships of "section" */
export type SectionColumnArgs = {
  distinct_on?: InputMaybe<Array<Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Column_Order_By>>;
  where?: InputMaybe<Column_Bool_Exp>;
};


/** columns and relationships of "section" */
export type SectionColumn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Column_Order_By>>;
  where?: InputMaybe<Column_Bool_Exp>;
};

/** aggregated selection of "section" */
export type Section_Aggregate = {
  __typename?: 'section_aggregate';
  aggregate?: Maybe<Section_Aggregate_Fields>;
  nodes: Array<Section>;
};

/** aggregate fields of "section" */
export type Section_Aggregate_Fields = {
  __typename?: 'section_aggregate_fields';
  avg?: Maybe<Section_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Section_Max_Fields>;
  min?: Maybe<Section_Min_Fields>;
  stddev?: Maybe<Section_Stddev_Fields>;
  stddev_pop?: Maybe<Section_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Section_Stddev_Samp_Fields>;
  sum?: Maybe<Section_Sum_Fields>;
  var_pop?: Maybe<Section_Var_Pop_Fields>;
  var_samp?: Maybe<Section_Var_Samp_Fields>;
  variance?: Maybe<Section_Variance_Fields>;
};


/** aggregate fields of "section" */
export type Section_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Section_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "section" */
export type Section_Aggregate_Order_By = {
  avg?: InputMaybe<Section_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Section_Max_Order_By>;
  min?: InputMaybe<Section_Min_Order_By>;
  stddev?: InputMaybe<Section_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Section_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Section_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Section_Sum_Order_By>;
  var_pop?: InputMaybe<Section_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Section_Var_Samp_Order_By>;
  variance?: InputMaybe<Section_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "section" */
export type Section_Arr_Rel_Insert_Input = {
  data: Array<Section_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Section_On_Conflict>;
};

/** aggregate avg on columns */
export type Section_Avg_Fields = {
  __typename?: 'section_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "section" */
export type Section_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "section". All fields are combined with a logical 'AND'. */
export type Section_Bool_Exp = {
  _and?: InputMaybe<Array<Section_Bool_Exp>>;
  _not?: InputMaybe<Section_Bool_Exp>;
  _or?: InputMaybe<Array<Section_Bool_Exp>>;
  column?: InputMaybe<Column_Bool_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  hidden?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  kiss?: InputMaybe<Boolean_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  panel_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "section" */
export enum Section_Constraint {
  /** unique or primary key constraint on columns "id" */
  SectionPkey = 'section_pkey'
}

/** input type for incrementing numeric columns in table "section" */
export type Section_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "section" */
export type Section_Insert_Input = {
  column?: InputMaybe<Column_Arr_Rel_Insert_Input>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  kiss?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Section_Max_Fields = {
  __typename?: 'section_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  panel_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "section" */
export type Section_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Section_Min_Fields = {
  __typename?: 'section_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
  panel_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "section" */
export type Section_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "section" */
export type Section_Mutation_Response = {
  __typename?: 'section_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Section>;
};

/** on_conflict condition type for table "section" */
export type Section_On_Conflict = {
  constraint: Section_Constraint;
  update_columns?: Array<Section_Update_Column>;
  where?: InputMaybe<Section_Bool_Exp>;
};

/** Ordering options when selecting data from "section". */
export type Section_Order_By = {
  column_aggregate?: InputMaybe<Column_Aggregate_Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  hidden?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kiss?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: section */
export type Section_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "section" */
export enum Section_Select_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Kiss = 'kiss',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  PanelId = 'panel_id'
}

/** input type for updating data in table "section" */
export type Section_Set_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  kiss?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Section_Stddev_Fields = {
  __typename?: 'section_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "section" */
export type Section_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Section_Stddev_Pop_Fields = {
  __typename?: 'section_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "section" */
export type Section_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Section_Stddev_Samp_Fields = {
  __typename?: 'section_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "section" */
export type Section_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "section" */
export type Section_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Section_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Section_Stream_Cursor_Value_Input = {
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  hidden?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  kiss?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Section_Sum_Fields = {
  __typename?: 'section_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "section" */
export type Section_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "section" */
export enum Section_Update_Column {
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Hidden = 'hidden',
  /** column name */
  Id = 'id',
  /** column name */
  Kiss = 'kiss',
  /** column name */
  Name = 'name',
  /** column name */
  Order = 'order',
  /** column name */
  PanelId = 'panel_id'
}

export type Section_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Section_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Section_Set_Input>;
  where: Section_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Section_Var_Pop_Fields = {
  __typename?: 'section_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "section" */
export type Section_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Section_Var_Samp_Fields = {
  __typename?: 'section_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "section" */
export type Section_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Section_Variance_Fields = {
  __typename?: 'section_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "section" */
export type Section_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "cacv" */
  cacv: Array<Cacv>;
  /** fetch aggregated fields from the table: "cacv" */
  cacv_aggregate: Cacv_Aggregate;
  /** fetch data from the table: "cacv" using primary key columns */
  cacv_by_pk?: Maybe<Cacv>;
  /** fetch data from the table in a streaming manner : "cacv" */
  cacv_stream: Array<Cacv>;
  /** fetch data from the table: "chat" */
  chat: Array<Chat>;
  /** fetch aggregated fields from the table: "chat" */
  chat_aggregate: Chat_Aggregate;
  /** fetch data from the table: "chat" using primary key columns */
  chat_by_pk?: Maybe<Chat>;
  /** fetch data from the table in a streaming manner : "chat" */
  chat_stream: Array<Chat>;
  /** An array relationship */
  column: Array<Column>;
  /** An aggregate relationship */
  column_aggregate: Column_Aggregate;
  /** fetch data from the table: "column" using primary key columns */
  column_by_pk?: Maybe<Column>;
  /** fetch data from the table in a streaming manner : "column" */
  column_stream: Array<Column>;
  /** fetch data from the table: "correlations" */
  correlations: Array<Correlations>;
  /** fetch aggregated fields from the table: "correlations" */
  correlations_aggregate: Correlations_Aggregate;
  /** fetch data from the table: "correlations" using primary key columns */
  correlations_by_pk?: Maybe<Correlations>;
  /** fetch data from the table in a streaming manner : "correlations" */
  correlations_stream: Array<Correlations>;
  /** fetch data from the table: "data3" */
  data3: Array<Data3>;
  /** fetch aggregated fields from the table: "data3" */
  data3_aggregate: Data3_Aggregate;
  /** fetch data from the table: "data3" using primary key columns */
  data3_by_pk?: Maybe<Data3>;
  /** fetch data from the table in a streaming manner : "data3" */
  data3_stream: Array<Data3>;
  /** fetch data from the table: "panel" */
  panel: Array<Panel>;
  /** fetch aggregated fields from the table: "panel" */
  panel_aggregate: Panel_Aggregate;
  /** fetch data from the table: "panel" using primary key columns */
  panel_by_pk?: Maybe<Panel>;
  /** fetch data from the table in a streaming manner : "panel" */
  panel_stream: Array<Panel>;
  /** fetch data from the table: "python_scripts_cache" */
  python_scripts_cache: Array<Python_Scripts_Cache>;
  /** fetch aggregated fields from the table: "python_scripts_cache" */
  python_scripts_cache_aggregate: Python_Scripts_Cache_Aggregate;
  /** fetch data from the table: "python_scripts_cache" using primary key columns */
  python_scripts_cache_by_pk?: Maybe<Python_Scripts_Cache>;
  /** fetch data from the table in a streaming manner : "python_scripts_cache" */
  python_scripts_cache_stream: Array<Python_Scripts_Cache>;
  /** fetch data from the table: "request_tickers" */
  request_tickers: Array<Request_Tickers>;
  /** fetch aggregated fields from the table: "request_tickers" */
  request_tickers_aggregate: Request_Tickers_Aggregate;
  /** fetch data from the table: "request_tickers" using primary key columns */
  request_tickers_by_pk?: Maybe<Request_Tickers>;
  /** fetch data from the table in a streaming manner : "request_tickers" */
  request_tickers_stream: Array<Request_Tickers>;
  /** fetch data from the table: "search_tickers" */
  search_tickers: Array<Search_Tickers>;
  /** fetch aggregated fields from the table: "search_tickers" */
  search_tickers_aggregate: Search_Tickers_Aggregate;
  /** fetch data from the table: "search_tickers" using primary key columns */
  search_tickers_by_pk?: Maybe<Search_Tickers>;
  /** fetch data from the table in a streaming manner : "search_tickers" */
  search_tickers_stream: Array<Search_Tickers>;
  /** An array relationship */
  section: Array<Section>;
  /** An aggregate relationship */
  section_aggregate: Section_Aggregate;
  /** fetch data from the table: "section" using primary key columns */
  section_by_pk?: Maybe<Section>;
  /** fetch data from the table in a streaming manner : "section" */
  section_stream: Array<Section>;
  /** fetch data from the table: "subscriptions" */
  subscriptions: Array<Subscriptions>;
  /** fetch aggregated fields from the table: "subscriptions" */
  subscriptions_aggregate: Subscriptions_Aggregate;
  /** fetch data from the table: "subscriptions" using primary key columns */
  subscriptions_by_pk?: Maybe<Subscriptions>;
  /** fetch data from the table in a streaming manner : "subscriptions" */
  subscriptions_stream: Array<Subscriptions>;
  /** fetch data from the table: "ticker" */
  ticker: Array<Ticker>;
  /** fetch aggregated fields from the table: "ticker" */
  ticker_aggregate: Ticker_Aggregate;
  /** fetch data from the table: "ticker" using primary key columns */
  ticker_by_pk?: Maybe<Ticker>;
  /** fetch data from the table in a streaming manner : "ticker" */
  ticker_stream: Array<Ticker>;
  /** An array relationship */
  user_subscriptions: Array<User_Subscriptions>;
  /** An aggregate relationship */
  user_subscriptions_aggregate: User_Subscriptions_Aggregate;
  /** fetch data from the table: "user_subscriptions" using primary key columns */
  user_subscriptions_by_pk?: Maybe<User_Subscriptions>;
  /** fetch data from the table in a streaming manner : "user_subscriptions" */
  user_subscriptions_stream: Array<User_Subscriptions>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  users_aggregate: Users_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  users_by_pk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner : "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootCacvArgs = {
  distinct_on?: InputMaybe<Array<Cacv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cacv_Order_By>>;
  where?: InputMaybe<Cacv_Bool_Exp>;
};


export type Subscription_RootCacv_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cacv_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cacv_Order_By>>;
  where?: InputMaybe<Cacv_Bool_Exp>;
};


export type Subscription_RootCacv_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCacv_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cacv_Stream_Cursor_Input>>;
  where?: InputMaybe<Cacv_Bool_Exp>;
};


export type Subscription_RootChatArgs = {
  distinct_on?: InputMaybe<Array<Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Order_By>>;
  where?: InputMaybe<Chat_Bool_Exp>;
};


export type Subscription_RootChat_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Chat_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Chat_Order_By>>;
  where?: InputMaybe<Chat_Bool_Exp>;
};


export type Subscription_RootChat_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootChat_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Chat_Stream_Cursor_Input>>;
  where?: InputMaybe<Chat_Bool_Exp>;
};


export type Subscription_RootColumnArgs = {
  distinct_on?: InputMaybe<Array<Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Column_Order_By>>;
  where?: InputMaybe<Column_Bool_Exp>;
};


export type Subscription_RootColumn_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Column_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Column_Order_By>>;
  where?: InputMaybe<Column_Bool_Exp>;
};


export type Subscription_RootColumn_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootColumn_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Column_Stream_Cursor_Input>>;
  where?: InputMaybe<Column_Bool_Exp>;
};


export type Subscription_RootCorrelationsArgs = {
  distinct_on?: InputMaybe<Array<Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Correlations_Order_By>>;
  where?: InputMaybe<Correlations_Bool_Exp>;
};


export type Subscription_RootCorrelations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Correlations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Correlations_Order_By>>;
  where?: InputMaybe<Correlations_Bool_Exp>;
};


export type Subscription_RootCorrelations_By_PkArgs = {
  date: Scalars['date'];
};


export type Subscription_RootCorrelations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Correlations_Stream_Cursor_Input>>;
  where?: InputMaybe<Correlations_Bool_Exp>;
};


export type Subscription_RootData3Args = {
  distinct_on?: InputMaybe<Array<Data3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data3_Order_By>>;
  where?: InputMaybe<Data3_Bool_Exp>;
};


export type Subscription_RootData3_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Data3_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Data3_Order_By>>;
  where?: InputMaybe<Data3_Bool_Exp>;
};


export type Subscription_RootData3_By_PkArgs = {
  ticker: Scalars['String'];
};


export type Subscription_RootData3_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Data3_Stream_Cursor_Input>>;
  where?: InputMaybe<Data3_Bool_Exp>;
};


export type Subscription_RootPanelArgs = {
  distinct_on?: InputMaybe<Array<Panel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Panel_Order_By>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


export type Subscription_RootPanel_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Panel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Panel_Order_By>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


export type Subscription_RootPanel_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPanel_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Panel_Stream_Cursor_Input>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


export type Subscription_RootPython_Scripts_CacheArgs = {
  distinct_on?: InputMaybe<Array<Python_Scripts_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Python_Scripts_Cache_Order_By>>;
  where?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
};


export type Subscription_RootPython_Scripts_Cache_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Python_Scripts_Cache_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Python_Scripts_Cache_Order_By>>;
  where?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
};


export type Subscription_RootPython_Scripts_Cache_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPython_Scripts_Cache_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Python_Scripts_Cache_Stream_Cursor_Input>>;
  where?: InputMaybe<Python_Scripts_Cache_Bool_Exp>;
};


export type Subscription_RootRequest_TickersArgs = {
  distinct_on?: InputMaybe<Array<Request_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Tickers_Order_By>>;
  where?: InputMaybe<Request_Tickers_Bool_Exp>;
};


export type Subscription_RootRequest_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Tickers_Order_By>>;
  where?: InputMaybe<Request_Tickers_Bool_Exp>;
};


export type Subscription_RootRequest_Tickers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRequest_Tickers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Tickers_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Tickers_Bool_Exp>;
};


export type Subscription_RootSearch_TickersArgs = {
  distinct_on?: InputMaybe<Array<Search_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Tickers_Order_By>>;
  where?: InputMaybe<Search_Tickers_Bool_Exp>;
};


export type Subscription_RootSearch_Tickers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Search_Tickers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Search_Tickers_Order_By>>;
  where?: InputMaybe<Search_Tickers_Bool_Exp>;
};


export type Subscription_RootSearch_Tickers_By_PkArgs = {
  ticker: Scalars['String'];
};


export type Subscription_RootSearch_Tickers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Search_Tickers_Stream_Cursor_Input>>;
  where?: InputMaybe<Search_Tickers_Bool_Exp>;
};


export type Subscription_RootSectionArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Subscription_RootSection_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Section_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Section_Order_By>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Subscription_RootSection_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSection_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Section_Stream_Cursor_Input>>;
  where?: InputMaybe<Section_Bool_Exp>;
};


export type Subscription_RootSubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Subscriptions_Order_By>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootSubscriptions_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSubscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};


export type Subscription_RootTickerArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Order_By>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


export type Subscription_RootTicker_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Ticker_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Ticker_Order_By>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


export type Subscription_RootTicker_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTicker_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Ticker_Stream_Cursor_Input>>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};


export type Subscription_RootUser_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


export type Subscription_RootUser_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


export type Subscription_RootUser_Subscriptions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Subscriptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Subscriptions_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "subscriptions" */
export type Subscriptions = {
  __typename?: 'subscriptions';
  id: Scalars['String'];
  key?: Maybe<Scalars['String']>;
  longbow_tabs?: Maybe<Scalars['jsonb']>;
  monthly_daily_price?: Maybe<Scalars['numeric']>;
  monthly_daily_price_id?: Maybe<Scalars['String']>;
  monthly_intraday_price?: Maybe<Scalars['numeric']>;
  monthly_intraday_price_id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  product_id: Scalars['String'];
  /** An object relationship */
  subscribed?: Maybe<User_Subscriptions>;
  total_tickers?: Maybe<Scalars['numeric']>;
};


/** columns and relationships of "subscriptions" */
export type SubscriptionsLongbow_TabsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "subscriptions" */
export type Subscriptions_Aggregate = {
  __typename?: 'subscriptions_aggregate';
  aggregate?: Maybe<Subscriptions_Aggregate_Fields>;
  nodes: Array<Subscriptions>;
};

/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_Fields = {
  __typename?: 'subscriptions_aggregate_fields';
  avg?: Maybe<Subscriptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Subscriptions_Max_Fields>;
  min?: Maybe<Subscriptions_Min_Fields>;
  stddev?: Maybe<Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<Subscriptions_Sum_Fields>;
  var_pop?: Maybe<Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<Subscriptions_Variance_Fields>;
};


/** aggregate fields of "subscriptions" */
export type Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Subscriptions_Append_Input = {
  longbow_tabs?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Subscriptions_Avg_Fields = {
  __typename?: 'subscriptions_avg_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "subscriptions". All fields are combined with a logical 'AND'. */
export type Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<Subscriptions_Bool_Exp>>;
  id?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  longbow_tabs?: InputMaybe<Jsonb_Comparison_Exp>;
  monthly_daily_price?: InputMaybe<Numeric_Comparison_Exp>;
  monthly_daily_price_id?: InputMaybe<String_Comparison_Exp>;
  monthly_intraday_price?: InputMaybe<Numeric_Comparison_Exp>;
  monthly_intraday_price_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  product_id?: InputMaybe<String_Comparison_Exp>;
  subscribed?: InputMaybe<User_Subscriptions_Bool_Exp>;
  total_tickers?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "subscriptions" */
export enum Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubscriptionsPkey = 'subscriptions_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Subscriptions_Delete_At_Path_Input = {
  longbow_tabs?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Subscriptions_Delete_Elem_Input = {
  longbow_tabs?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Subscriptions_Delete_Key_Input = {
  longbow_tabs?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "subscriptions" */
export type Subscriptions_Inc_Input = {
  monthly_daily_price?: InputMaybe<Scalars['numeric']>;
  monthly_intraday_price?: InputMaybe<Scalars['numeric']>;
  total_tickers?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "subscriptions" */
export type Subscriptions_Insert_Input = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  longbow_tabs?: InputMaybe<Scalars['jsonb']>;
  monthly_daily_price?: InputMaybe<Scalars['numeric']>;
  monthly_daily_price_id?: InputMaybe<Scalars['String']>;
  monthly_intraday_price?: InputMaybe<Scalars['numeric']>;
  monthly_intraday_price_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  subscribed?: InputMaybe<User_Subscriptions_Obj_Rel_Insert_Input>;
  total_tickers?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Subscriptions_Max_Fields = {
  __typename?: 'subscriptions_max_fields';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  monthly_daily_price?: Maybe<Scalars['numeric']>;
  monthly_daily_price_id?: Maybe<Scalars['String']>;
  monthly_intraday_price?: Maybe<Scalars['numeric']>;
  monthly_intraday_price_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  total_tickers?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Subscriptions_Min_Fields = {
  __typename?: 'subscriptions_min_fields';
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  monthly_daily_price?: Maybe<Scalars['numeric']>;
  monthly_daily_price_id?: Maybe<Scalars['String']>;
  monthly_intraday_price?: Maybe<Scalars['numeric']>;
  monthly_intraday_price_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  product_id?: Maybe<Scalars['String']>;
  total_tickers?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "subscriptions" */
export type Subscriptions_Mutation_Response = {
  __typename?: 'subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Subscriptions>;
};

/** input type for inserting object relation for remote table "subscriptions" */
export type Subscriptions_Obj_Rel_Insert_Input = {
  data: Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "subscriptions" */
export type Subscriptions_On_Conflict = {
  constraint: Subscriptions_Constraint;
  update_columns?: Array<Subscriptions_Update_Column>;
  where?: InputMaybe<Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "subscriptions". */
export type Subscriptions_Order_By = {
  id?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  longbow_tabs?: InputMaybe<Order_By>;
  monthly_daily_price?: InputMaybe<Order_By>;
  monthly_daily_price_id?: InputMaybe<Order_By>;
  monthly_intraday_price?: InputMaybe<Order_By>;
  monthly_intraday_price_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  product_id?: InputMaybe<Order_By>;
  subscribed?: InputMaybe<User_Subscriptions_Order_By>;
  total_tickers?: InputMaybe<Order_By>;
};

/** primary key columns input for table: subscriptions */
export type Subscriptions_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Subscriptions_Prepend_Input = {
  longbow_tabs?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "subscriptions" */
export enum Subscriptions_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LongbowTabs = 'longbow_tabs',
  /** column name */
  MonthlyDailyPrice = 'monthly_daily_price',
  /** column name */
  MonthlyDailyPriceId = 'monthly_daily_price_id',
  /** column name */
  MonthlyIntradayPrice = 'monthly_intraday_price',
  /** column name */
  MonthlyIntradayPriceId = 'monthly_intraday_price_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  TotalTickers = 'total_tickers'
}

/** input type for updating data in table "subscriptions" */
export type Subscriptions_Set_Input = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  longbow_tabs?: InputMaybe<Scalars['jsonb']>;
  monthly_daily_price?: InputMaybe<Scalars['numeric']>;
  monthly_daily_price_id?: InputMaybe<Scalars['String']>;
  monthly_intraday_price?: InputMaybe<Scalars['numeric']>;
  monthly_intraday_price_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  total_tickers?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Subscriptions_Stddev_Fields = {
  __typename?: 'subscriptions_stddev_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'subscriptions_stddev_pop_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'subscriptions_stddev_samp_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "subscriptions" */
export type Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Subscriptions_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  longbow_tabs?: InputMaybe<Scalars['jsonb']>;
  monthly_daily_price?: InputMaybe<Scalars['numeric']>;
  monthly_daily_price_id?: InputMaybe<Scalars['String']>;
  monthly_intraday_price?: InputMaybe<Scalars['numeric']>;
  monthly_intraday_price_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  product_id?: InputMaybe<Scalars['String']>;
  total_tickers?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Subscriptions_Sum_Fields = {
  __typename?: 'subscriptions_sum_fields';
  monthly_daily_price?: Maybe<Scalars['numeric']>;
  monthly_intraday_price?: Maybe<Scalars['numeric']>;
  total_tickers?: Maybe<Scalars['numeric']>;
};

/** update columns of table "subscriptions" */
export enum Subscriptions_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Key = 'key',
  /** column name */
  LongbowTabs = 'longbow_tabs',
  /** column name */
  MonthlyDailyPrice = 'monthly_daily_price',
  /** column name */
  MonthlyDailyPriceId = 'monthly_daily_price_id',
  /** column name */
  MonthlyIntradayPrice = 'monthly_intraday_price',
  /** column name */
  MonthlyIntradayPriceId = 'monthly_intraday_price_id',
  /** column name */
  Name = 'name',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  TotalTickers = 'total_tickers'
}

export type Subscriptions_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Subscriptions_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Subscriptions_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Subscriptions_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Subscriptions_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Subscriptions_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Subscriptions_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Subscriptions_Set_Input>;
  where: Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Subscriptions_Var_Pop_Fields = {
  __typename?: 'subscriptions_var_pop_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Subscriptions_Var_Samp_Fields = {
  __typename?: 'subscriptions_var_samp_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Subscriptions_Variance_Fields = {
  __typename?: 'subscriptions_variance_fields';
  monthly_daily_price?: Maybe<Scalars['Float']>;
  monthly_intraday_price?: Maybe<Scalars['Float']>;
  total_tickers?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "ticker" */
export type Ticker = {
  __typename?: 'ticker';
  alert_longbow_overall_signal: Scalars['Boolean'];
  alert_momentum_30d_flag: Scalars['Boolean'];
  alert_momentum_90d_flag: Scalars['Boolean'];
  alert_trading_range_signal: Scalars['Boolean'];
  alert_volatility_signal: Scalars['Boolean'];
  /** An object relationship */
  data?: Maybe<Data3>;
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamptz'];
  deleted?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  order?: Maybe<Scalars['Int']>;
  /** An object relationship */
  panel: Panel;
  panel_id: Scalars['uuid'];
  ticker: Scalars['String'];
};

export type Ticker2_Schema_Data = {
  __typename?: 'ticker2_schema_data';
  data?: Maybe<Scalars['JSON']>;
  ticker?: Maybe<Scalars['String']>;
};

export type Ticker2_Schema_Input = {
  ticker: Scalars['String'];
};

/** aggregated selection of "ticker" */
export type Ticker_Aggregate = {
  __typename?: 'ticker_aggregate';
  aggregate?: Maybe<Ticker_Aggregate_Fields>;
  nodes: Array<Ticker>;
};

/** aggregate fields of "ticker" */
export type Ticker_Aggregate_Fields = {
  __typename?: 'ticker_aggregate_fields';
  avg?: Maybe<Ticker_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Ticker_Max_Fields>;
  min?: Maybe<Ticker_Min_Fields>;
  stddev?: Maybe<Ticker_Stddev_Fields>;
  stddev_pop?: Maybe<Ticker_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Ticker_Stddev_Samp_Fields>;
  sum?: Maybe<Ticker_Sum_Fields>;
  var_pop?: Maybe<Ticker_Var_Pop_Fields>;
  var_samp?: Maybe<Ticker_Var_Samp_Fields>;
  variance?: Maybe<Ticker_Variance_Fields>;
};


/** aggregate fields of "ticker" */
export type Ticker_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Ticker_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "ticker" */
export type Ticker_Aggregate_Order_By = {
  avg?: InputMaybe<Ticker_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Ticker_Max_Order_By>;
  min?: InputMaybe<Ticker_Min_Order_By>;
  stddev?: InputMaybe<Ticker_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Ticker_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Ticker_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Ticker_Sum_Order_By>;
  var_pop?: InputMaybe<Ticker_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Ticker_Var_Samp_Order_By>;
  variance?: InputMaybe<Ticker_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "ticker" */
export type Ticker_Arr_Rel_Insert_Input = {
  data: Array<Ticker_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Ticker_On_Conflict>;
};

/** aggregate avg on columns */
export type Ticker_Avg_Fields = {
  __typename?: 'ticker_avg_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "ticker" */
export type Ticker_Avg_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "ticker". All fields are combined with a logical 'AND'. */
export type Ticker_Bool_Exp = {
  _and?: InputMaybe<Array<Ticker_Bool_Exp>>;
  _not?: InputMaybe<Ticker_Bool_Exp>;
  _or?: InputMaybe<Array<Ticker_Bool_Exp>>;
  alert_longbow_overall_signal?: InputMaybe<Boolean_Comparison_Exp>;
  alert_momentum_30d_flag?: InputMaybe<Boolean_Comparison_Exp>;
  alert_momentum_90d_flag?: InputMaybe<Boolean_Comparison_Exp>;
  alert_trading_range_signal?: InputMaybe<Boolean_Comparison_Exp>;
  alert_volatility_signal?: InputMaybe<Boolean_Comparison_Exp>;
  data?: InputMaybe<Data3_Bool_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  deleted?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  order?: InputMaybe<Int_Comparison_Exp>;
  panel?: InputMaybe<Panel_Bool_Exp>;
  panel_id?: InputMaybe<Uuid_Comparison_Exp>;
  ticker?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "ticker" */
export enum Ticker_Constraint {
  /** unique or primary key constraint on columns "id" */
  TickerPkey = 'ticker_pkey'
}

/** input type for incrementing numeric columns in table "ticker" */
export type Ticker_Inc_Input = {
  order?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "ticker" */
export type Ticker_Insert_Input = {
  alert_longbow_overall_signal?: InputMaybe<Scalars['Boolean']>;
  alert_momentum_30d_flag?: InputMaybe<Scalars['Boolean']>;
  alert_momentum_90d_flag?: InputMaybe<Scalars['Boolean']>;
  alert_trading_range_signal?: InputMaybe<Scalars['Boolean']>;
  alert_volatility_signal?: InputMaybe<Scalars['Boolean']>;
  data?: InputMaybe<Data3_Obj_Rel_Insert_Input>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  panel?: InputMaybe<Panel_Obj_Rel_Insert_Input>;
  panel_id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Ticker_Max_Fields = {
  __typename?: 'ticker_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  panel_id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "ticker" */
export type Ticker_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel_id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Ticker_Min_Fields = {
  __typename?: 'ticker_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  deleted?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  order?: Maybe<Scalars['Int']>;
  panel_id?: Maybe<Scalars['uuid']>;
  ticker?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "ticker" */
export type Ticker_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel_id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "ticker" */
export type Ticker_Mutation_Response = {
  __typename?: 'ticker_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Ticker>;
};

/** on_conflict condition type for table "ticker" */
export type Ticker_On_Conflict = {
  constraint: Ticker_Constraint;
  update_columns?: Array<Ticker_Update_Column>;
  where?: InputMaybe<Ticker_Bool_Exp>;
};

/** Ordering options when selecting data from "ticker". */
export type Ticker_Order_By = {
  alert_longbow_overall_signal?: InputMaybe<Order_By>;
  alert_momentum_30d_flag?: InputMaybe<Order_By>;
  alert_momentum_90d_flag?: InputMaybe<Order_By>;
  alert_trading_range_signal?: InputMaybe<Order_By>;
  alert_volatility_signal?: InputMaybe<Order_By>;
  data?: InputMaybe<Data3_Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  deleted?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_By>;
  panel?: InputMaybe<Panel_Order_By>;
  panel_id?: InputMaybe<Order_By>;
  ticker?: InputMaybe<Order_By>;
};

/** primary key columns input for table: ticker */
export type Ticker_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "ticker" */
export enum Ticker_Select_Column {
  /** column name */
  AlertLongbowOverallSignal = 'alert_longbow_overall_signal',
  /** column name */
  AlertMomentum_30dFlag = 'alert_momentum_30d_flag',
  /** column name */
  AlertMomentum_90dFlag = 'alert_momentum_90d_flag',
  /** column name */
  AlertTradingRangeSignal = 'alert_trading_range_signal',
  /** column name */
  AlertVolatilitySignal = 'alert_volatility_signal',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PanelId = 'panel_id',
  /** column name */
  Ticker = 'ticker'
}

/** input type for updating data in table "ticker" */
export type Ticker_Set_Input = {
  alert_longbow_overall_signal?: InputMaybe<Scalars['Boolean']>;
  alert_momentum_30d_flag?: InputMaybe<Scalars['Boolean']>;
  alert_momentum_90d_flag?: InputMaybe<Scalars['Boolean']>;
  alert_trading_range_signal?: InputMaybe<Scalars['Boolean']>;
  alert_volatility_signal?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Ticker_Stddev_Fields = {
  __typename?: 'ticker_stddev_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "ticker" */
export type Ticker_Stddev_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Ticker_Stddev_Pop_Fields = {
  __typename?: 'ticker_stddev_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "ticker" */
export type Ticker_Stddev_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Ticker_Stddev_Samp_Fields = {
  __typename?: 'ticker_stddev_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "ticker" */
export type Ticker_Stddev_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "ticker" */
export type Ticker_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Ticker_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Ticker_Stream_Cursor_Value_Input = {
  alert_longbow_overall_signal?: InputMaybe<Scalars['Boolean']>;
  alert_momentum_30d_flag?: InputMaybe<Scalars['Boolean']>;
  alert_momentum_90d_flag?: InputMaybe<Scalars['Boolean']>;
  alert_trading_range_signal?: InputMaybe<Scalars['Boolean']>;
  alert_volatility_signal?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  deleted?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  order?: InputMaybe<Scalars['Int']>;
  panel_id?: InputMaybe<Scalars['uuid']>;
  ticker?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Ticker_Sum_Fields = {
  __typename?: 'ticker_sum_fields';
  order?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "ticker" */
export type Ticker_Sum_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** update columns of table "ticker" */
export enum Ticker_Update_Column {
  /** column name */
  AlertLongbowOverallSignal = 'alert_longbow_overall_signal',
  /** column name */
  AlertMomentum_30dFlag = 'alert_momentum_30d_flag',
  /** column name */
  AlertMomentum_90dFlag = 'alert_momentum_90d_flag',
  /** column name */
  AlertTradingRangeSignal = 'alert_trading_range_signal',
  /** column name */
  AlertVolatilitySignal = 'alert_volatility_signal',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Deleted = 'deleted',
  /** column name */
  Id = 'id',
  /** column name */
  Order = 'order',
  /** column name */
  PanelId = 'panel_id',
  /** column name */
  Ticker = 'ticker'
}

export type Ticker_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Ticker_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Ticker_Set_Input>;
  where: Ticker_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Ticker_Var_Pop_Fields = {
  __typename?: 'ticker_var_pop_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "ticker" */
export type Ticker_Var_Pop_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Ticker_Var_Samp_Fields = {
  __typename?: 'ticker_var_samp_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "ticker" */
export type Ticker_Var_Samp_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Ticker_Variance_Fields = {
  __typename?: 'ticker_variance_fields';
  order?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "ticker" */
export type Ticker_Variance_Order_By = {
  order?: InputMaybe<Order_By>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "user_subscriptions" */
export type User_Subscriptions = {
  __typename?: 'user_subscriptions';
  can_downgrade: Scalars['Boolean'];
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamptz'];
  expires?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  price_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  subscription?: Maybe<Subscriptions>;
  subscription_id: Scalars['String'];
  trial?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  /** An object relationship */
  user?: Maybe<Users>;
  user_id: Scalars['uuid'];
};

/** aggregated selection of "user_subscriptions" */
export type User_Subscriptions_Aggregate = {
  __typename?: 'user_subscriptions_aggregate';
  aggregate?: Maybe<User_Subscriptions_Aggregate_Fields>;
  nodes: Array<User_Subscriptions>;
};

/** aggregate fields of "user_subscriptions" */
export type User_Subscriptions_Aggregate_Fields = {
  __typename?: 'user_subscriptions_aggregate_fields';
  avg?: Maybe<User_Subscriptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<User_Subscriptions_Max_Fields>;
  min?: Maybe<User_Subscriptions_Min_Fields>;
  stddev?: Maybe<User_Subscriptions_Stddev_Fields>;
  stddev_pop?: Maybe<User_Subscriptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<User_Subscriptions_Stddev_Samp_Fields>;
  sum?: Maybe<User_Subscriptions_Sum_Fields>;
  var_pop?: Maybe<User_Subscriptions_Var_Pop_Fields>;
  var_samp?: Maybe<User_Subscriptions_Var_Samp_Fields>;
  variance?: Maybe<User_Subscriptions_Variance_Fields>;
};


/** aggregate fields of "user_subscriptions" */
export type User_Subscriptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_subscriptions" */
export type User_Subscriptions_Aggregate_Order_By = {
  avg?: InputMaybe<User_Subscriptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Subscriptions_Max_Order_By>;
  min?: InputMaybe<User_Subscriptions_Min_Order_By>;
  stddev?: InputMaybe<User_Subscriptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Subscriptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Subscriptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Subscriptions_Sum_Order_By>;
  var_pop?: InputMaybe<User_Subscriptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Subscriptions_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Subscriptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "user_subscriptions" */
export type User_Subscriptions_Arr_Rel_Insert_Input = {
  data: Array<User_Subscriptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Subscriptions_On_Conflict>;
};

/** aggregate avg on columns */
export type User_Subscriptions_Avg_Fields = {
  __typename?: 'user_subscriptions_avg_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "user_subscriptions" */
export type User_Subscriptions_Avg_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user_subscriptions". All fields are combined with a logical 'AND'. */
export type User_Subscriptions_Bool_Exp = {
  _and?: InputMaybe<Array<User_Subscriptions_Bool_Exp>>;
  _not?: InputMaybe<User_Subscriptions_Bool_Exp>;
  _or?: InputMaybe<Array<User_Subscriptions_Bool_Exp>>;
  can_downgrade?: InputMaybe<Boolean_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamptz_Comparison_Exp>;
  expires?: InputMaybe<Date_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  price_id?: InputMaybe<String_Comparison_Exp>;
  subscription?: InputMaybe<Subscriptions_Bool_Exp>;
  subscription_id?: InputMaybe<String_Comparison_Exp>;
  trial?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  user_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_subscriptions" */
export enum User_Subscriptions_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserSubscriptionsPkey = 'user_subscriptions_pkey'
}

/** input type for incrementing numeric columns in table "user_subscriptions" */
export type User_Subscriptions_Inc_Input = {
  trial?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "user_subscriptions" */
export type User_Subscriptions_Insert_Input = {
  can_downgrade?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  expires?: InputMaybe<Scalars['date']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  price_id?: InputMaybe<Scalars['String']>;
  subscription?: InputMaybe<Subscriptions_Obj_Rel_Insert_Input>;
  subscription_id?: InputMaybe<Scalars['String']>;
  trial?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type User_Subscriptions_Max_Fields = {
  __typename?: 'user_subscriptions_max_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  expires?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  price_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "user_subscriptions" */
export type User_Subscriptions_Max_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  expires?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  trial?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Subscriptions_Min_Fields = {
  __typename?: 'user_subscriptions_min_fields';
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamptz']>;
  expires?: Maybe<Scalars['date']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  price_id?: Maybe<Scalars['String']>;
  subscription_id?: Maybe<Scalars['String']>;
  trial?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "user_subscriptions" */
export type User_Subscriptions_Min_Order_By = {
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  expires?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  trial?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_subscriptions" */
export type User_Subscriptions_Mutation_Response = {
  __typename?: 'user_subscriptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Subscriptions>;
};

/** input type for inserting object relation for remote table "user_subscriptions" */
export type User_Subscriptions_Obj_Rel_Insert_Input = {
  data: User_Subscriptions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<User_Subscriptions_On_Conflict>;
};

/** on_conflict condition type for table "user_subscriptions" */
export type User_Subscriptions_On_Conflict = {
  constraint: User_Subscriptions_Constraint;
  update_columns?: Array<User_Subscriptions_Update_Column>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};

/** Ordering options when selecting data from "user_subscriptions". */
export type User_Subscriptions_Order_By = {
  can_downgrade?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  expires?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  price_id?: InputMaybe<Order_By>;
  subscription?: InputMaybe<Subscriptions_Order_By>;
  subscription_id?: InputMaybe<Order_By>;
  trial?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_subscriptions */
export type User_Subscriptions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_subscriptions" */
export enum User_Subscriptions_Select_Column {
  /** column name */
  CanDowngrade = 'can_downgrade',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Expires = 'expires',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Trial = 'trial',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_subscriptions" */
export type User_Subscriptions_Set_Input = {
  can_downgrade?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  expires?: InputMaybe<Scalars['date']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  price_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['String']>;
  trial?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type User_Subscriptions_Stddev_Fields = {
  __typename?: 'user_subscriptions_stddev_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "user_subscriptions" */
export type User_Subscriptions_Stddev_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type User_Subscriptions_Stddev_Pop_Fields = {
  __typename?: 'user_subscriptions_stddev_pop_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "user_subscriptions" */
export type User_Subscriptions_Stddev_Pop_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type User_Subscriptions_Stddev_Samp_Fields = {
  __typename?: 'user_subscriptions_stddev_samp_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "user_subscriptions" */
export type User_Subscriptions_Stddev_Samp_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user_subscriptions" */
export type User_Subscriptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Subscriptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Subscriptions_Stream_Cursor_Value_Input = {
  can_downgrade?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamptz']>;
  expires?: InputMaybe<Scalars['date']>;
  frequency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  price_id?: InputMaybe<Scalars['String']>;
  subscription_id?: InputMaybe<Scalars['String']>;
  trial?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type User_Subscriptions_Sum_Fields = {
  __typename?: 'user_subscriptions_sum_fields';
  trial?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "user_subscriptions" */
export type User_Subscriptions_Sum_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** update columns of table "user_subscriptions" */
export enum User_Subscriptions_Update_Column {
  /** column name */
  CanDowngrade = 'can_downgrade',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Expires = 'expires',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  Id = 'id',
  /** column name */
  PriceId = 'price_id',
  /** column name */
  SubscriptionId = 'subscription_id',
  /** column name */
  Trial = 'trial',
  /** column name */
  Type = 'type',
  /** column name */
  UserId = 'user_id'
}

export type User_Subscriptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Subscriptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Subscriptions_Set_Input>;
  where: User_Subscriptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type User_Subscriptions_Var_Pop_Fields = {
  __typename?: 'user_subscriptions_var_pop_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "user_subscriptions" */
export type User_Subscriptions_Var_Pop_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type User_Subscriptions_Var_Samp_Fields = {
  __typename?: 'user_subscriptions_var_samp_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "user_subscriptions" */
export type User_Subscriptions_Var_Samp_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type User_Subscriptions_Variance_Fields = {
  __typename?: 'user_subscriptions_variance_fields';
  trial?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "user_subscriptions" */
export type User_Subscriptions_Variance_Order_By = {
  trial?: InputMaybe<Order_By>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  brokerage?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  dark_mode?: Maybe<Scalars['Boolean']>;
  date_created: Scalars['timestamptz'];
  date_updated: Scalars['timestamp'];
  email: Scalars['String'];
  email_notifications?: Maybe<Scalars['Boolean']>;
  first_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  guided_tour: Scalars['Boolean'];
  id: Scalars['uuid'];
  is_active: Scalars['Boolean'];
  last_name?: Maybe<Scalars['String']>;
  meta?: Maybe<Scalars['jsonb']>;
  mobile?: Maybe<Scalars['String']>;
  /** An array relationship */
  panels: Array<Panel>;
  /** An aggregate relationship */
  panels_aggregate: Panel_Aggregate;
  payment_method_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  sms_notifications?: Maybe<Scalars['Boolean']>;
  type?: Maybe<Scalars['String']>;
  /** An array relationship */
  user_subscriptions: Array<User_Subscriptions>;
  /** An aggregate relationship */
  user_subscriptions_aggregate: User_Subscriptions_Aggregate;
  user_type: Scalars['String'];
  verified_42macro?: Maybe<Scalars['String']>;
  verified_sms: Scalars['Boolean'];
};


/** columns and relationships of "users" */
export type UsersMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersPanelsArgs = {
  distinct_on?: InputMaybe<Array<Panel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Panel_Order_By>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersPanels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Panel_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Panel_Order_By>>;
  where?: InputMaybe<Panel_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_SubscriptionsArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUser_Subscriptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Subscriptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Subscriptions_Order_By>>;
  where?: InputMaybe<User_Subscriptions_Bool_Exp>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  brokerage?: InputMaybe<String_Comparison_Exp>;
  customer_id?: InputMaybe<String_Comparison_Exp>;
  dark_mode?: InputMaybe<Boolean_Comparison_Exp>;
  date_created?: InputMaybe<Timestamptz_Comparison_Exp>;
  date_updated?: InputMaybe<Timestamp_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  email_notifications?: InputMaybe<Boolean_Comparison_Exp>;
  first_name?: InputMaybe<String_Comparison_Exp>;
  frequency?: InputMaybe<String_Comparison_Exp>;
  guided_tour?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_active?: InputMaybe<Boolean_Comparison_Exp>;
  last_name?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  mobile?: InputMaybe<String_Comparison_Exp>;
  panels?: InputMaybe<Panel_Bool_Exp>;
  payment_method_id?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  plan?: InputMaybe<String_Comparison_Exp>;
  sms_notifications?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  user_subscriptions?: InputMaybe<User_Subscriptions_Bool_Exp>;
  user_type?: InputMaybe<String_Comparison_Exp>;
  verified_42macro?: InputMaybe<String_Comparison_Exp>;
  verified_sms?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey = 'users_email_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  brokerage?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  dark_mode?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  email_notifications?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  guided_tour?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mobile?: InputMaybe<Scalars['String']>;
  panels?: InputMaybe<Panel_Arr_Rel_Insert_Input>;
  payment_method_id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  sms_notifications?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  user_subscriptions?: InputMaybe<User_Subscriptions_Arr_Rel_Insert_Input>;
  user_type?: InputMaybe<Scalars['String']>;
  verified_42macro?: InputMaybe<Scalars['String']>;
  verified_sms?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  brokerage?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  payment_method_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  verified_42macro?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  brokerage?: Maybe<Scalars['String']>;
  customer_id?: Maybe<Scalars['String']>;
  date_created?: Maybe<Scalars['timestamptz']>;
  date_updated?: Maybe<Scalars['timestamp']>;
  email?: Maybe<Scalars['String']>;
  first_name?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  last_name?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  payment_method_id?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  plan?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  user_type?: Maybe<Scalars['String']>;
  verified_42macro?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  brokerage?: InputMaybe<Order_By>;
  customer_id?: InputMaybe<Order_By>;
  dark_mode?: InputMaybe<Order_By>;
  date_created?: InputMaybe<Order_By>;
  date_updated?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  email_notifications?: InputMaybe<Order_By>;
  first_name?: InputMaybe<Order_By>;
  frequency?: InputMaybe<Order_By>;
  guided_tour?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_active?: InputMaybe<Order_By>;
  last_name?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  mobile?: InputMaybe<Order_By>;
  panels_aggregate?: InputMaybe<Panel_Aggregate_Order_By>;
  payment_method_id?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  plan?: InputMaybe<Order_By>;
  sms_notifications?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  user_subscriptions_aggregate?: InputMaybe<User_Subscriptions_Aggregate_Order_By>;
  user_type?: InputMaybe<Order_By>;
  verified_42macro?: InputMaybe<Order_By>;
  verified_sms?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Brokerage = 'brokerage',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DarkMode = 'dark_mode',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Email = 'email',
  /** column name */
  EmailNotifications = 'email_notifications',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  GuidedTour = 'guided_tour',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Plan = 'plan',
  /** column name */
  SmsNotifications = 'sms_notifications',
  /** column name */
  Type = 'type',
  /** column name */
  UserType = 'user_type',
  /** column name */
  Verified_42macro = 'verified_42macro',
  /** column name */
  VerifiedSms = 'verified_sms'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  brokerage?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  dark_mode?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  email_notifications?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  guided_tour?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mobile?: InputMaybe<Scalars['String']>;
  payment_method_id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  sms_notifications?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<Scalars['String']>;
  verified_42macro?: InputMaybe<Scalars['String']>;
  verified_sms?: InputMaybe<Scalars['Boolean']>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  brokerage?: InputMaybe<Scalars['String']>;
  customer_id?: InputMaybe<Scalars['String']>;
  dark_mode?: InputMaybe<Scalars['Boolean']>;
  date_created?: InputMaybe<Scalars['timestamptz']>;
  date_updated?: InputMaybe<Scalars['timestamp']>;
  email?: InputMaybe<Scalars['String']>;
  email_notifications?: InputMaybe<Scalars['Boolean']>;
  first_name?: InputMaybe<Scalars['String']>;
  frequency?: InputMaybe<Scalars['String']>;
  guided_tour?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_active?: InputMaybe<Scalars['Boolean']>;
  last_name?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  mobile?: InputMaybe<Scalars['String']>;
  payment_method_id?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  plan?: InputMaybe<Scalars['String']>;
  sms_notifications?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Scalars['String']>;
  user_type?: InputMaybe<Scalars['String']>;
  verified_42macro?: InputMaybe<Scalars['String']>;
  verified_sms?: InputMaybe<Scalars['Boolean']>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Brokerage = 'brokerage',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  DarkMode = 'dark_mode',
  /** column name */
  DateCreated = 'date_created',
  /** column name */
  DateUpdated = 'date_updated',
  /** column name */
  Email = 'email',
  /** column name */
  EmailNotifications = 'email_notifications',
  /** column name */
  FirstName = 'first_name',
  /** column name */
  Frequency = 'frequency',
  /** column name */
  GuidedTour = 'guided_tour',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  LastName = 'last_name',
  /** column name */
  Meta = 'meta',
  /** column name */
  Mobile = 'mobile',
  /** column name */
  PaymentMethodId = 'payment_method_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Plan = 'plan',
  /** column name */
  SmsNotifications = 'sms_notifications',
  /** column name */
  Type = 'type',
  /** column name */
  UserType = 'user_type',
  /** column name */
  Verified_42macro = 'verified_42macro',
  /** column name */
  VerifiedSms = 'verified_sms'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  where: Users_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

export type SetUserStatusMutationVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetUserStatusMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type SetEmailNotificationsMutationVariables = Exact<{
  on?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetEmailNotificationsMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type SetSmsNotificationsMutationVariables = Exact<{
  on?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetSmsNotificationsMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type DeleteUserTickersMutationVariables = Exact<{
  tickers?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteUserTickersMutation = { __typename?: 'mutation_root', delete_ticker?: { __typename?: 'ticker_mutation_response', affected_rows: number } | null };

export type UpdatePanelsMutationVariables = Exact<{
  updates: Array<Panel_Updates> | Panel_Updates;
}>;


export type UpdatePanelsMutation = { __typename?: 'mutation_root', update_panel_many?: Array<{ __typename?: 'panel_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'panel', name: string, order: number }> } | null> | null };

export type AddPanelMutationVariables = Exact<{
  name: Scalars['String'];
}>;


export type AddPanelMutation = { __typename?: 'mutation_root', add_panel?: { __typename?: 'add_panel_output', id: string, message: string } | null };

export type AddTickerMutationVariables = Exact<{
  ticker: Scalars['String'];
  panelId: Scalars['uuid'];
}>;


export type AddTickerMutation = { __typename?: 'mutation_root', add_ticker?: { __typename?: 'add_ticker_output', tickers_left: number, message: string } | null };

export type DeletePanelMutationVariables = Exact<{
  id: Scalars['uuid'];
}>;


export type DeletePanelMutation = { __typename?: 'mutation_root', delete_panel_by_pk?: { __typename?: 'panel', id: any } | null };

export type SetGuidedTourMutationVariables = Exact<{
  on?: InputMaybe<Scalars['Boolean']>;
}>;


export type SetGuidedTourMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number } | null };

export type ActiveSessionsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveSessionsQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', is_active: boolean }> };

export type UserDataQueryVariables = Exact<{ [key: string]: never; }>;


export type UserDataQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', id: any, first_name?: string | null, last_name?: string | null, email: string, phone?: string | null, mobile?: string | null, dark_mode?: boolean | null, sms_notifications?: boolean | null, email_notifications?: boolean | null, verified_sms: boolean, verified_42macro?: string | null }> };

export type UserTickersQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTickersQuery = { __typename?: 'query_root', ticker: Array<{ __typename?: 'ticker', ticker: string, panel: { __typename?: 'panel', id: any, name: string } }> };

export type UserSubscriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserSubscriptionsQuery = { __typename?: 'query_root', user_subscriptions: Array<{ __typename?: 'user_subscriptions', subscription_id: string, price_id?: string | null, type?: string | null, frequency?: string | null }>, subscriptions: Array<{ __typename?: 'subscriptions', id: string, name: string, key?: string | null, monthly_daily_price?: any | null, monthly_daily_price_id?: string | null, monthly_intraday_price?: any | null, monthly_intraday_price_id?: string | null, longbow_tabs?: any | null, subscribed?: { __typename?: 'user_subscriptions', date_created: any, id: any, subscription_id: string, type?: string | null, frequency?: string | null, price_id?: string | null, expires?: any | null, trial?: number | null, can_downgrade: boolean } | null }> };

export type UserPanelsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserPanelsQuery = { __typename?: 'query_root', panel: Array<{ __typename?: 'panel', id: any, name: string, longbow_panel: boolean, hidden: boolean, subscription_id?: string | null, order: number, user_subscriptions: Array<{ __typename?: 'user_subscriptions', id: any }>, section: Array<{ __typename?: 'section', id: any, name: string, order: number, hidden?: boolean | null, kiss: boolean, date_created: any, date_updated: any, column: Array<{ __typename?: 'column', date_created: any, date_updated: any, hidden: boolean, id: any, key?: string | null, name: string, order: any }> }> }> };

export type GuidedTourQueryVariables = Exact<{ [key: string]: never; }>;


export type GuidedTourQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'users', guided_tour: boolean }> };

export type ChartDataQueryVariables = Exact<{
  ticker: Scalars['String'];
  from: Scalars['String'];
  to: Scalars['String'];
  interval: Scalars['String'];
  fields: Array<Scalars['String']> | Scalars['String'];
}>;


export type ChartDataQuery = { __typename?: 'query_root', get_charting_data?: { __typename?: 'get_charting_data_output', data: any } | null };


export const SetUserStatusDocument = gql`
    mutation SetUserStatus($active: Boolean) {
  update_users(_set: {is_active: $active}, where: {id: {_is_null: false}}) {
    affected_rows
  }
}
    `;
export type SetUserStatusMutationFn = Apollo.MutationFunction<SetUserStatusMutation, SetUserStatusMutationVariables>;

/**
 * __useSetUserStatusMutation__
 *
 * To run a mutation, you first call `useSetUserStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserStatusMutation, { data, loading, error }] = useSetUserStatusMutation({
 *   variables: {
 *      active: // value for 'active'
 *   },
 * });
 */
export function useSetUserStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetUserStatusMutation, SetUserStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserStatusMutation, SetUserStatusMutationVariables>(SetUserStatusDocument, options);
      }
export type SetUserStatusMutationHookResult = ReturnType<typeof useSetUserStatusMutation>;
export type SetUserStatusMutationResult = Apollo.MutationResult<SetUserStatusMutation>;
export type SetUserStatusMutationOptions = Apollo.BaseMutationOptions<SetUserStatusMutation, SetUserStatusMutationVariables>;
export const SetEmailNotificationsDocument = gql`
    mutation SetEmailNotifications($on: Boolean) {
  update_users(where: {}, _set: {email_notifications: $on}) {
    affected_rows
  }
}
    `;
export type SetEmailNotificationsMutationFn = Apollo.MutationFunction<SetEmailNotificationsMutation, SetEmailNotificationsMutationVariables>;

/**
 * __useSetEmailNotificationsMutation__
 *
 * To run a mutation, you first call `useSetEmailNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetEmailNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setEmailNotificationsMutation, { data, loading, error }] = useSetEmailNotificationsMutation({
 *   variables: {
 *      on: // value for 'on'
 *   },
 * });
 */
export function useSetEmailNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetEmailNotificationsMutation, SetEmailNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetEmailNotificationsMutation, SetEmailNotificationsMutationVariables>(SetEmailNotificationsDocument, options);
      }
export type SetEmailNotificationsMutationHookResult = ReturnType<typeof useSetEmailNotificationsMutation>;
export type SetEmailNotificationsMutationResult = Apollo.MutationResult<SetEmailNotificationsMutation>;
export type SetEmailNotificationsMutationOptions = Apollo.BaseMutationOptions<SetEmailNotificationsMutation, SetEmailNotificationsMutationVariables>;
export const SetSmsNotificationsDocument = gql`
    mutation SetSmsNotifications($on: Boolean) {
  update_users(where: {}, _set: {sms_notifications: $on}) {
    affected_rows
  }
}
    `;
export type SetSmsNotificationsMutationFn = Apollo.MutationFunction<SetSmsNotificationsMutation, SetSmsNotificationsMutationVariables>;

/**
 * __useSetSmsNotificationsMutation__
 *
 * To run a mutation, you first call `useSetSmsNotificationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSmsNotificationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSmsNotificationsMutation, { data, loading, error }] = useSetSmsNotificationsMutation({
 *   variables: {
 *      on: // value for 'on'
 *   },
 * });
 */
export function useSetSmsNotificationsMutation(baseOptions?: Apollo.MutationHookOptions<SetSmsNotificationsMutation, SetSmsNotificationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSmsNotificationsMutation, SetSmsNotificationsMutationVariables>(SetSmsNotificationsDocument, options);
      }
export type SetSmsNotificationsMutationHookResult = ReturnType<typeof useSetSmsNotificationsMutation>;
export type SetSmsNotificationsMutationResult = Apollo.MutationResult<SetSmsNotificationsMutation>;
export type SetSmsNotificationsMutationOptions = Apollo.BaseMutationOptions<SetSmsNotificationsMutation, SetSmsNotificationsMutationVariables>;
export const DeleteUserTickersDocument = gql`
    mutation DeleteUserTickers($tickers: [String!]) {
  delete_ticker(where: {ticker: {_in: $tickers}}) {
    affected_rows
  }
}
    `;
export type DeleteUserTickersMutationFn = Apollo.MutationFunction<DeleteUserTickersMutation, DeleteUserTickersMutationVariables>;

/**
 * __useDeleteUserTickersMutation__
 *
 * To run a mutation, you first call `useDeleteUserTickersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserTickersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserTickersMutation, { data, loading, error }] = useDeleteUserTickersMutation({
 *   variables: {
 *      tickers: // value for 'tickers'
 *   },
 * });
 */
export function useDeleteUserTickersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserTickersMutation, DeleteUserTickersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserTickersMutation, DeleteUserTickersMutationVariables>(DeleteUserTickersDocument, options);
      }
export type DeleteUserTickersMutationHookResult = ReturnType<typeof useDeleteUserTickersMutation>;
export type DeleteUserTickersMutationResult = Apollo.MutationResult<DeleteUserTickersMutation>;
export type DeleteUserTickersMutationOptions = Apollo.BaseMutationOptions<DeleteUserTickersMutation, DeleteUserTickersMutationVariables>;
export const UpdatePanelsDocument = gql`
    mutation UpdatePanels($updates: [panel_updates!]!) {
  update_panel_many(updates: $updates) {
    affected_rows
    returning {
      name
      order
    }
  }
}
    `;
export type UpdatePanelsMutationFn = Apollo.MutationFunction<UpdatePanelsMutation, UpdatePanelsMutationVariables>;

/**
 * __useUpdatePanelsMutation__
 *
 * To run a mutation, you first call `useUpdatePanelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePanelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePanelsMutation, { data, loading, error }] = useUpdatePanelsMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdatePanelsMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePanelsMutation, UpdatePanelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePanelsMutation, UpdatePanelsMutationVariables>(UpdatePanelsDocument, options);
      }
export type UpdatePanelsMutationHookResult = ReturnType<typeof useUpdatePanelsMutation>;
export type UpdatePanelsMutationResult = Apollo.MutationResult<UpdatePanelsMutation>;
export type UpdatePanelsMutationOptions = Apollo.BaseMutationOptions<UpdatePanelsMutation, UpdatePanelsMutationVariables>;
export const AddPanelDocument = gql`
    mutation AddPanel($name: String!) {
  add_panel(object: {name: $name}) {
    id
    message
  }
}
    `;
export type AddPanelMutationFn = Apollo.MutationFunction<AddPanelMutation, AddPanelMutationVariables>;

/**
 * __useAddPanelMutation__
 *
 * To run a mutation, you first call `useAddPanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddPanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addPanelMutation, { data, loading, error }] = useAddPanelMutation({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useAddPanelMutation(baseOptions?: Apollo.MutationHookOptions<AddPanelMutation, AddPanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddPanelMutation, AddPanelMutationVariables>(AddPanelDocument, options);
      }
export type AddPanelMutationHookResult = ReturnType<typeof useAddPanelMutation>;
export type AddPanelMutationResult = Apollo.MutationResult<AddPanelMutation>;
export type AddPanelMutationOptions = Apollo.BaseMutationOptions<AddPanelMutation, AddPanelMutationVariables>;
export const AddTickerDocument = gql`
    mutation AddTicker($ticker: String!, $panelId: uuid!) {
  add_ticker(object: {ticker: $ticker, panel_id: $panelId}) {
    tickers_left
    message
  }
}
    `;
export type AddTickerMutationFn = Apollo.MutationFunction<AddTickerMutation, AddTickerMutationVariables>;

/**
 * __useAddTickerMutation__
 *
 * To run a mutation, you first call `useAddTickerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTickerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTickerMutation, { data, loading, error }] = useAddTickerMutation({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      panelId: // value for 'panelId'
 *   },
 * });
 */
export function useAddTickerMutation(baseOptions?: Apollo.MutationHookOptions<AddTickerMutation, AddTickerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTickerMutation, AddTickerMutationVariables>(AddTickerDocument, options);
      }
export type AddTickerMutationHookResult = ReturnType<typeof useAddTickerMutation>;
export type AddTickerMutationResult = Apollo.MutationResult<AddTickerMutation>;
export type AddTickerMutationOptions = Apollo.BaseMutationOptions<AddTickerMutation, AddTickerMutationVariables>;
export const DeletePanelDocument = gql`
    mutation DeletePanel($id: uuid!) {
  delete_panel_by_pk(id: $id) {
    id
  }
}
    `;
export type DeletePanelMutationFn = Apollo.MutationFunction<DeletePanelMutation, DeletePanelMutationVariables>;

/**
 * __useDeletePanelMutation__
 *
 * To run a mutation, you first call `useDeletePanelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePanelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePanelMutation, { data, loading, error }] = useDeletePanelMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePanelMutation(baseOptions?: Apollo.MutationHookOptions<DeletePanelMutation, DeletePanelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePanelMutation, DeletePanelMutationVariables>(DeletePanelDocument, options);
      }
export type DeletePanelMutationHookResult = ReturnType<typeof useDeletePanelMutation>;
export type DeletePanelMutationResult = Apollo.MutationResult<DeletePanelMutation>;
export type DeletePanelMutationOptions = Apollo.BaseMutationOptions<DeletePanelMutation, DeletePanelMutationVariables>;
export const SetGuidedTourDocument = gql`
    mutation SetGuidedTour($on: Boolean) {
  update_users(where: {}, _set: {guided_tour: $on}) {
    affected_rows
  }
}
    `;
export type SetGuidedTourMutationFn = Apollo.MutationFunction<SetGuidedTourMutation, SetGuidedTourMutationVariables>;

/**
 * __useSetGuidedTourMutation__
 *
 * To run a mutation, you first call `useSetGuidedTourMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetGuidedTourMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setGuidedTourMutation, { data, loading, error }] = useSetGuidedTourMutation({
 *   variables: {
 *      on: // value for 'on'
 *   },
 * });
 */
export function useSetGuidedTourMutation(baseOptions?: Apollo.MutationHookOptions<SetGuidedTourMutation, SetGuidedTourMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetGuidedTourMutation, SetGuidedTourMutationVariables>(SetGuidedTourDocument, options);
      }
export type SetGuidedTourMutationHookResult = ReturnType<typeof useSetGuidedTourMutation>;
export type SetGuidedTourMutationResult = Apollo.MutationResult<SetGuidedTourMutation>;
export type SetGuidedTourMutationOptions = Apollo.BaseMutationOptions<SetGuidedTourMutation, SetGuidedTourMutationVariables>;
export const ActiveSessionsDocument = gql`
    query ActiveSessions {
  users {
    is_active
  }
}
    `;

/**
 * __useActiveSessionsQuery__
 *
 * To run a query within a React component, call `useActiveSessionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveSessionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveSessionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useActiveSessionsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveSessionsQuery, ActiveSessionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveSessionsQuery, ActiveSessionsQueryVariables>(ActiveSessionsDocument, options);
      }
export function useActiveSessionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveSessionsQuery, ActiveSessionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveSessionsQuery, ActiveSessionsQueryVariables>(ActiveSessionsDocument, options);
        }
export type ActiveSessionsQueryHookResult = ReturnType<typeof useActiveSessionsQuery>;
export type ActiveSessionsLazyQueryHookResult = ReturnType<typeof useActiveSessionsLazyQuery>;
export type ActiveSessionsQueryResult = Apollo.QueryResult<ActiveSessionsQuery, ActiveSessionsQueryVariables>;
export const UserDataDocument = gql`
    query UserData {
  users {
    id
    first_name
    last_name
    email
    phone
    mobile
    dark_mode
    sms_notifications
    email_notifications
    verified_sms
    verified_42macro
  }
}
    `;

/**
 * __useUserDataQuery__
 *
 * To run a query within a React component, call `useUserDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserDataQuery(baseOptions?: Apollo.QueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
      }
export function useUserDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserDataQuery, UserDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserDataQuery, UserDataQueryVariables>(UserDataDocument, options);
        }
export type UserDataQueryHookResult = ReturnType<typeof useUserDataQuery>;
export type UserDataLazyQueryHookResult = ReturnType<typeof useUserDataLazyQuery>;
export type UserDataQueryResult = Apollo.QueryResult<UserDataQuery, UserDataQueryVariables>;
export const UserTickersDocument = gql`
    query UserTickers {
  ticker(where: {panel: {longbow_panel: {_eq: false}}}) {
    ticker
    panel {
      id
      name
    }
  }
}
    `;

/**
 * __useUserTickersQuery__
 *
 * To run a query within a React component, call `useUserTickersQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTickersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTickersQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTickersQuery(baseOptions?: Apollo.QueryHookOptions<UserTickersQuery, UserTickersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTickersQuery, UserTickersQueryVariables>(UserTickersDocument, options);
      }
export function useUserTickersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTickersQuery, UserTickersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTickersQuery, UserTickersQueryVariables>(UserTickersDocument, options);
        }
export type UserTickersQueryHookResult = ReturnType<typeof useUserTickersQuery>;
export type UserTickersLazyQueryHookResult = ReturnType<typeof useUserTickersLazyQuery>;
export type UserTickersQueryResult = Apollo.QueryResult<UserTickersQuery, UserTickersQueryVariables>;
export const UserSubscriptionsDocument = gql`
    query UserSubscriptions {
  user_subscriptions(where: {subscription_id: {_like: "%plan"}}) {
    subscription_id
    price_id
    type
    frequency
  }
  subscriptions {
    id
    name
    key
    monthly_daily_price
    monthly_daily_price_id
    monthly_intraday_price
    monthly_intraday_price_id
    longbow_tabs
    subscribed {
      date_created
      id
      subscription_id
      type
      frequency
      price_id
      expires
      trial
      can_downgrade
    }
  }
}
    `;

/**
 * __useUserSubscriptionsQuery__
 *
 * To run a query within a React component, call `useUserSubscriptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserSubscriptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserSubscriptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserSubscriptionsQuery(baseOptions?: Apollo.QueryHookOptions<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>(UserSubscriptionsDocument, options);
      }
export function useUserSubscriptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>(UserSubscriptionsDocument, options);
        }
export type UserSubscriptionsQueryHookResult = ReturnType<typeof useUserSubscriptionsQuery>;
export type UserSubscriptionsLazyQueryHookResult = ReturnType<typeof useUserSubscriptionsLazyQuery>;
export type UserSubscriptionsQueryResult = Apollo.QueryResult<UserSubscriptionsQuery, UserSubscriptionsQueryVariables>;
export const UserPanelsDocument = gql`
    query UserPanels {
  panel(order_by: {order: asc}) {
    id
    name
    longbow_panel
    hidden
    subscription_id
    order
    user_subscriptions {
      id
    }
    section(order_by: {order: asc}) {
      id
      name
      order
      hidden
      kiss
      date_created
      date_updated
      column(order_by: {order: asc}) {
        date_created
        date_updated
        hidden
        id
        key
        name
        order
      }
    }
  }
}
    `;

/**
 * __useUserPanelsQuery__
 *
 * To run a query within a React component, call `useUserPanelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserPanelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserPanelsQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserPanelsQuery(baseOptions?: Apollo.QueryHookOptions<UserPanelsQuery, UserPanelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserPanelsQuery, UserPanelsQueryVariables>(UserPanelsDocument, options);
      }
export function useUserPanelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserPanelsQuery, UserPanelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserPanelsQuery, UserPanelsQueryVariables>(UserPanelsDocument, options);
        }
export type UserPanelsQueryHookResult = ReturnType<typeof useUserPanelsQuery>;
export type UserPanelsLazyQueryHookResult = ReturnType<typeof useUserPanelsLazyQuery>;
export type UserPanelsQueryResult = Apollo.QueryResult<UserPanelsQuery, UserPanelsQueryVariables>;
export const GuidedTourDocument = gql`
    query GuidedTour {
  users {
    guided_tour
  }
}
    `;

/**
 * __useGuidedTourQuery__
 *
 * To run a query within a React component, call `useGuidedTourQuery` and pass it any options that fit your needs.
 * When your component renders, `useGuidedTourQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGuidedTourQuery({
 *   variables: {
 *   },
 * });
 */
export function useGuidedTourQuery(baseOptions?: Apollo.QueryHookOptions<GuidedTourQuery, GuidedTourQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GuidedTourQuery, GuidedTourQueryVariables>(GuidedTourDocument, options);
      }
export function useGuidedTourLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GuidedTourQuery, GuidedTourQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GuidedTourQuery, GuidedTourQueryVariables>(GuidedTourDocument, options);
        }
export type GuidedTourQueryHookResult = ReturnType<typeof useGuidedTourQuery>;
export type GuidedTourLazyQueryHookResult = ReturnType<typeof useGuidedTourLazyQuery>;
export type GuidedTourQueryResult = Apollo.QueryResult<GuidedTourQuery, GuidedTourQueryVariables>;
export const ChartDataDocument = gql`
    query ChartData($ticker: String!, $from: String!, $to: String!, $interval: String!, $fields: [String!]!) {
  get_charting_data(
    object: {data: {ticker: $ticker, from: $from, to: $to, interval: $interval, fields: $fields}}
  ) {
    data
  }
}
    `;

/**
 * __useChartDataQuery__
 *
 * To run a query within a React component, call `useChartDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useChartDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChartDataQuery({
 *   variables: {
 *      ticker: // value for 'ticker'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      interval: // value for 'interval'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useChartDataQuery(baseOptions: Apollo.QueryHookOptions<ChartDataQuery, ChartDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ChartDataQuery, ChartDataQueryVariables>(ChartDataDocument, options);
      }
export function useChartDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ChartDataQuery, ChartDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ChartDataQuery, ChartDataQueryVariables>(ChartDataDocument, options);
        }
export type ChartDataQueryHookResult = ReturnType<typeof useChartDataQuery>;
export type ChartDataLazyQueryHookResult = ReturnType<typeof useChartDataLazyQuery>;
export type ChartDataQueryResult = Apollo.QueryResult<ChartDataQuery, ChartDataQueryVariables>;